/**
 * BP Configuratore Ritratto — BePirate
 * Mattone 1: selettori variante + prezzo dinamico.
 * Mattone 2: bottone "Aggiungi al carrello" autonomo.
 * Mattone 3: griglia sfondi (blocchi del theme editor) con scelta
 *            registrata nello stato del modulo. La property
 *            "Seleziona lo sfondo" verrà collegata al POST nel
 *            mattone dedicato alle properties, non qui.
 * Mattone 4: campo dettagli per gli artisti (facoltativo), testo
 *            registrato nello stato del modulo. Property
 *            "Fornisci i dettagli per gli artisti" solo se non vuoto.
 * Mattone 5: FOTO (definitivo). Area upload con anteprime e
 *            rimozione singola. Massimo legato ai personaggi
 *            (1 -> 3, 2 -> 4, 3+ -> 8; progetto punto 6). Almeno
 *            una foto obbligatoria. Le foto salgono su CDN Shopify
 *            DENTRO il POST multipart FormData di add-to-cart come
 *            properties numerate "_Carica le foto 1", "2", ...
 *            (nome OPTIS con un underscore SINGOLO davanti, vedi
 *            BP_PROP_FOTO_PREFIX). Nello stesso POST viaggiano anche
 *            le properties di sfondo e dettagli.
 * Mattone 6: SALTACODA, doppia funzione (progetto punto 7), flusso
 *            a 3 POST: 1) prodottino da 5 euro; 2) ritratto
 *            multipart; 3) property sul RITRATTO (nomi esatti
 *            OPTIS) via /cart/change.js in JSON. La property NON
 *            può viaggiare nel multipart: il parser di Shopify
 *            perde i nomi campo non-ASCII ("sarà", "?", "!") —
 *            verificato sul campo. Pagamento e property sono
 *            legati nei due sensi: prodottino fallito -> niente
 *            property; property non scrivibile o ritratto fallito
 *            -> rollback del prodottino. Il ritratto non è mai
 *            bloccato dal saltacoda.
 * Mattone 7: SFONDO PERSONALIZZATO (progetto punto 10), stesso
 *            schema del saltacoda: prodottino da 5 euro, deciso AL
 *            CLICK guardando lo sfondo selezionato in quel momento
 *            (radio marcato data-bp-sfondo-custom). Ordine POST:
 *            prodottini prima (saltacoda, sfondo custom), poi
 *            ritratto, poi property saltacoda. Prodottino sfondo
 *            fallito -> property "Personalizzato" tolta dal
 *            ritratto + avviso non bloccante; ritratto fallito ->
 *            rollback di TUTTI i prodottini entrati. La property
 *            sfondo viaggia nel multipart (nome ASCII, sicuro).
 *            In più: descrizione FACOLTATIVA dello sfondo custom
 *            (textarea visibile solo col Personalizzato selezionato),
 *            property "Descrivi lo sfondo personalizzato" scritta
 *            solo se al click è selezionato il Personalizzato e il
 *            prodottino è entrato; casella vuota = valore fisso
 *            BP_SFONDO_DESCR_VUOTA.
 * Mattone 8: MODALITÀ MULTI-PRODOTTO (BP-MODALITA). Il tipo di
 *            prodotto arriva dal theme editor via
 *            data-bp-modalita: "classico" (invariato) o "wanted"
 *            (aggiunge i campi OBBLIGATORI nome e taglia, con
 *            gating del bottone come le foto). Nomi property
 *            confermati da ordine OPTIS vero: il nome viaggia nel
 *            multipart (ASCII), la taglia in JSON via change.js
 *            (apostrofo tipografico nel nome della property).
 *            Prezzi sempre dalle varianti del prodotto ospite;
 *            prodottini saltacoda/sfondo custom condivisi.
 * Mattone 9: MODALITÀ PUZZLE / PORTACHIAVI / COVER (BP-MODALITA).
 *            Come il Classico (i selettori sono già generici: con
 *            una sola opzione — quantità del Portachiavi, modello
 *            della Cover — rendono un solo gruppo), più
 *            l'interruttore "versione Manifesto" che mostra i due
 *            campi del Wanted: acceso -> obbligatori e stesse
 *            properties (nome multipart, taglia JSON); spento ->
 *            nascosti, nessuna property. Non tocca il prezzo.
 *            La verità sui campi Wanted è bpWantedFieldsAttivi():
 *            sempre in modalità wanted, dal checkbox nelle altre.
 *
 * Completamente indipendente dal JavaScript di Shrine (main.js su CDN):
 * - custom element proprio: <bp-configuratore>
 * - nessun hook sul product form nativo, nessun submit sostituito
 * - tutti i nomi con prefisso "bp" per non collidere con il tema
 *
 * L'add-to-cart fa da sé il POST multipart a /cart/add.js (MAI body
 * JSON: i file si perderebbero; niente Content-Type manuale, il
 * boundary lo imposta il browser) chiedendo anche le sezioni
 * cart-drawer e cart-icon-bubble. Il refresh del drawer è MANUALE
 * (ritaglio di .drawer__inner + #cart-icon-bubble, stesso pattern
 * del codice upsell già collaudato in questo tema): il
 * renderContents di Shrine non va MAI chiamato — è offuscato, senza
 * null-check, e su questo drawer personalizzato muore a metà.
 * Dell'elemento nativo si usa solo open(); fallback: pagina carrello.
 *
 * I prezzi arrivano dalle varianti Shopify (in centesimi) incorporate
 * nella sezione via <script type="application/json" data-bp-product>.
 * Nessun prezzo è scritto in questo file.
 */
(function () {
  'use strict';

  if (window.customElements.get('bp-configuratore')) return;

  /* Nome ESATTO della line item property per lo sfondo, copiato da
     OPTIS (PROGETTO_Modulo_Configuratore_Ritratto.md, punto 5).
     Il cart drawer del tema la riconosce già (match su 'sfondo' /
     'seleziona lo sfondo'). Verrà usata nel mattone che collega
     tutte le properties al POST /cart/add.js. */
  const BP_PROP_SFONDO = 'Seleziona lo sfondo';

  /* Nome ESATTO della property per il testo libero, copiato da OPTIS
     (PROGETTO_Modulo_Configuratore_Ritratto.md, punto 5). */
  const BP_PROP_DETTAGLI = 'Fornisci i dettagli per gli artisti';

  /* La frase storica della prima scheda del passo 4, quella che i clienti
     scrivevano a mano prima che ci fosse la scheda. Il generatore di brief
     a valle la riconosce ESATTA, virgola e punto esclamativo compresi:
     serve come ripiego se la setting del theme editor arrivasse vuota, per
     non mandare al carrello una property senza la frase che quel
     generatore aspetta. */
  const BP_DETTAGLI_FATEVOI_STORICO = 'Fate voi, mi fido!';

  /* Prefisso delle properties foto: "_Carica le foto 1", "_Carica le
     foto 2", ... Il numero viene concatenato al momento del POST.
     Il nome viene da OPTIS (progetto, punto 5), con UN UNDERSCORE
     DAVANTI aggiunto dopo.

     PERCHE' L'UNDERSCORE. Shopify non stampa al cliente le properties
     il cui nome comincia per underscore: restano visibili nell'admin e
     nell'API ma non compaiono ne' nella pagina ordine ne' nella mail di
     conferma. Il valore di questa property e' un gettone (bpfoto_ piu'
     32 esadecimali) che apre la foto del cliente: senza l'underscore lo
     leggerebbe in chiaro chiunque veda quella pagina o quella mail.

     DEVE RESTARE SINGOLO, MAI DOPPIO. Il CRM scarta le properties il
     cui nome comincia per due underscore (le considera dati tecnici,
     significativa() in prodotto.mjs): con "__Carica le foto" le foto
     sparirebbero dall'ordine, che resterebbe "ok" senza nessuna
     anomalia. E' un guasto silenzioso. Con uno solo il CRM le legge
     come sempre, perche' il riconoscimento normalizza il nome (l'
     underscore iniziale cade) e cerca la parola "foto"; per lo stesso
     motivo gli ordini gia' fatti, senza underscore, si leggono ancora. */
  const BP_PROP_FOTO_PREFIX = '_Carica le foto ';

  /* Massimo foto per numero personaggi (progetto, punto 6):
     1 -> 3, 2 -> 4, 3 o più -> 8. */
  const BP_FOTO_LIMITI = { 1: 3, 2: 4 };
  const BP_FOTO_LIMITE_3PIU = 8;
  /* Limite da usare FINCHE' IL CLIENTE NON HA SCELTO: il piu' basso di
     tutti. Partire dal piu' alto lascerebbe caricare otto foto a chi poi
     sceglie "1 personaggio", e le foto in eccesso non si cancellano mai
     da sole: resterebbe il bottone bloccato e un avviso da risolvere a
     mano. Meglio chiedere poco e allargare dopo la scelta.
     Calcolato dalla tabella qui sopra, non scritto a mano: se un domani i
     limiti cambiano, questo li segue senza che nessuno se ne ricordi. */
  const BP_FOTO_MINIMO = Object.keys(BP_FOTO_LIMITI).reduce(function (bpMin, bpChiave) {
    return Math.min(bpMin, BP_FOTO_LIMITI[bpChiave]);
  }, BP_FOTO_LIMITE_3PIU);

  /* Tetto del file IN INGRESSO, prima del ridimensionamento. Alzato da 20
     a 40 MB quando è arrivata la conversione nel browser: prima era il
     limite di cosa poteva viaggiare nel multipart, adesso è solo il
     limite di cosa ha senso provare a decodificare. Una HEIC da 25 MB
     scartata in partenza sarebbe una foto persa per niente, visto che
     dopo la conversione ne pesa meno di due. */
  const BP_FOTO_MAX_BYTES = 40 * 1024 * 1024;

  /* ---- Ridimensionamento nel browser -------------------------------
     Le foto da telefono sono 4000x3000 e pesano 4-12 MB. Caricate così
     costano secondi sul bottone, e soprattutto sbattono contro i tetti
     del server che scarica le foto per il brief (7 MB per foto, 18 MB
     in totale): oltre quelli l'ordine si ferma in officina invece di
     andare all'illustratore. Rimpicciolire qui chiude quel guasto.

     Le regole, tutte volute:
     - lato lungo a 3000 px, e MAI ingrandire: una foto già piccola
       resta com'è, non si inventano pixel;
     - sotto la soglia di 2 MB non si tocca niente: il file originale è
       già leggero e ricomprimerlo peggiorerebbe soltanto;
     - qualità 0.9, alta di proposito: queste foto le guarda un
       illustratore per disegnare una faccia, non sono immagini di
       galleria;
     - un PNG con trasparenza resta PNG (l'alpha andrebbe perso in
       JPEG e lo sfondo diventerebbe nero), ma si ridimensiona lo
       stesso se è grande;
     - se la conversione fallisce per QUALUNQUE motivo si carica
       l'originale: mai perdere una foto, mai bloccare un ordine. */
  const BP_FOTO_LATO_MAX = 3000;
  const BP_FOTO_SOGLIA_INTATTA = 2 * 1024 * 1024;
  const BP_FOTO_QUALITA = 0.9;

  /* ---- Anteprima delle HEIC (SOLO SCHERMO) --------------------------
     Chrome e Android non sanno mostrare le HEIC: senza niente il cliente
     vedeva il riquadro "Foto caricata" al posto della foto. Qui se ne fa
     una miniatura vera con libheif (assets/libheif-bundle.js, LGPL-3.0,
     licenza in assets/libheif-LICENSE.txt). IL FILE CHE VA A R2 E
     ALL'ORDINE NON SI TOCCA: la miniatura e' un'immagine a parte,
     piccola, solo per lo schermo.
     Perche' libheif e non heic2any (che il fix Android usa per le HEIC
     sopra il tetto): heic2any produce il JPG a piena risoluzione e lo
     disegna nella pagina, che resta ferma fino a 4 secondi su un
     telefono lento con una 48 MP; libheif lavora tutta in un worker.
     Le regole, tutte volute:
     - la libreria (1,9 MB, circa 620 KB compressa) si scarica SOLO
       quando serve, cioe' quando il browser non sa mostrare una HEIC da
       solo (Safari su iPhone la mostra e non scarica niente);
     - lavora in un WORKER: decodifica e WebAssembly non toccano la
       pagina, quindi X, passi e bottone restano sempre liberi;
     - parte solo DOPO che la foto e' arrivata su R2;
     - una foto alla volta, ridotta subito a miniatura: la foto a piena
       risoluzione vive solo dentro il worker e solo per il tempo della
       riduzione;
     - 8 secondi al massimo, poi il riquadro "Foto caricata";
     - telefoni con meno di 4 GB (navigator.deviceMemory) non ci provano;
     - l'orientamento lo applica libheif (irot/imir del contenitore);
     - QUALUNQUE errore finisce nel riquadro "Foto caricata", mai
       nell'icona rotta e mai in un errore che ferma la pagina. */
  const BP_HEIC_TIMEOUT_MS = 8000;
  const BP_HEIC_LATO_ANTEPRIMA = 320;
  const BP_HEIC_MEMORIA_MIN_GB = 4;

  /* Il worker, scritto qui e avviato da un Blob: cosi' e' dello stesso
     dominio della pagina qualunque sia il dominio da cui Shopify serve gli
     asset, e la libreria entra con importScripts. Riceve i byte della HEIC
     (trasferiti, non copiati), risponde con una JPEG piccola o con un
     errore. La compilazione del WebAssembly della libreria e' sincrona:
     nel browser e' permessa solo in un worker, un motivo in piu'. */
  const BP_HEIC_WORKER = [
    'var bpLib = null;',
    'self.onmessage = async function (bpEv) {',
    '  var bpDecoder = null, bpImmagini = [];',
    '  try {',
    '    if (!bpLib) { importScripts(bpEv.data.libUrl); bpLib = libheif(); }',
    '    bpDecoder = new bpLib.HeifDecoder();',
    '    bpImmagini = bpDecoder.decode(new Uint8Array(bpEv.data.byte)) || [];',
    '    if (!bpImmagini.length) throw new Error("nessuna immagine nel file");',
    '    var bpImg = bpImmagini.find(function (i) { return i.is_primary(); }) || bpImmagini[0];',
    '    var bpL = bpImg.get_width(), bpA = bpImg.get_height();',
    '    if (!bpL || !bpA) throw new Error("misure non valide");',
    '    var bpDati = new ImageData(bpL, bpA);',
    '    await new Promise(function (ok, ko) { bpImg.display(bpDati, function (d) { d ? ok() : ko(new Error("decodifica non riuscita")); }); });',
    '    var bpScala = Math.min(1, bpEv.data.lato / Math.max(bpL, bpA));',
    '    var bpBitmap = await createImageBitmap(bpDati, { resizeWidth: Math.max(1, Math.round(bpL * bpScala)), resizeHeight: Math.max(1, Math.round(bpA * bpScala)), resizeQuality: "medium" });',
    '    bpDati = null;',
    '    var bpTela = new OffscreenCanvas(bpBitmap.width, bpBitmap.height);',
    '    bpTela.getContext("2d").drawImage(bpBitmap, 0, 0);',
    '    bpBitmap.close();',
    '    var bpBlob = await bpTela.convertToBlob({ type: "image/jpeg", quality: 0.8 });',
    '    self.postMessage({ ok: true, blob: bpBlob, larghezza: bpL, altezza: bpA });',
    '  } catch (bpErrore) {',
    '    self.postMessage({ ok: false, errore: String((bpErrore && bpErrore.message) || bpErrore) });',
    '  } finally {',
    '    bpImmagini.forEach(function (i) { try { i.free(); } catch (e) {} });',
    '    try { if (bpDecoder && bpDecoder.decoder) bpLib.heif_context_free(bpDecoder.decoder); } catch (e) {}',
    '  }',
    '};',
  ].join('\n');

  /* Una riga per la sentinella bp-errori (snippets/bp-errori.liquid) quando
     il configuratore si ferma senza che ci sia un errore JavaScript vero:
     da sola la sentinella non lo vedrebbe mai. Passa dal canale che la
     sentinella ascolta gia' (l'evento "error" sulla finestra), cosi' valgono
     i suoi filtri, il suo "una volta per messaggio" e il suo tetto per
     pagina, e l'indirizzo della function resta scritto in un posto solo.
     Arriva su Telegram come "Errore JavaScript" col messaggio qui sotto.
     Non rompe mai niente: se il browser non sa creare l'evento, tace. */
  function bpSegnalaSentinella(bpMessaggio) {
    try {
      window.dispatchEvent(new ErrorEvent('error', {
        message: '[bp-configuratore] ' + bpMessaggio,
        filename: 'bp-configuratore.js',
      }));
    } catch (bpErrore) { /* niente da fare */ }
  }

  /* La sentinella scarta in silenzio i messaggi che contengono certe parole
     (BP_RUMORE in snippets/bp-errori.liquid): "load failed", "failed to
     fetch", "networkerror"... Sono proprio gli errori di rete di iPhone e
     Android, e dentro un avviso del configuratore DEVONO arrivare. Qui si
     spezzano con un trattino basso, cosi' il filtro non li riconosce e il
     Capitano li legge lo stesso. */
  function bpSenzaRumore(bpTesto) {
    return String(bpTesto == null ? '' : bpTesto)
      .replace(/(load|failed|network|abort|script|cancel|annull|chunk)(\s*)(failed|to fetch|error|led|ata|ed)/gi, '$1_$3')
      /* 14/10/2026: la function bp-errori scarta come rumore di Instagram e
         Facebook ogni messaggio con "illegal invocation". Se l'errore e'
         NEL CONFIGURATORE deve arrivare lo stesso. */
      .replace(/(illegal)(\s+)(invocation)/gi, '$1_$3');
  }

  /* ERRORI JAVASCRIPT DEL CONFIGURATORE (08/10/2026): vanno al Capitano dal
     canale proprio (window.bpCanaleAvvisi), uno per cliente, anche quando
     la sentinella non li farebbe passare (spenta, tetto, filtri). Solo gli
     errori veri il cui punto d'origine e' questo file: gli ErrorEvent finti
     di bpSegnalaSentinella non hanno .error e si saltano. Se il canale non
     c'e', ci pensa la sentinella come sempre. */
  function bpErroreJsConfiguratore(bpMessaggio, bpDove) {
    try {
      if (typeof window.bpCanaleAvvisi !== 'function') return;
      window.bpCanaleAvvisi('errore JS nel configuratore', [
        '[bp-configuratore] Aggiunta al carrello fallita: errore JS nel configuratore | ' + bpSenzaRumore(bpMessaggio).slice(0, 260)
        + ' | ' + bpDove + ' | browser=' + (navigator.userAgent || '?') + ' | url=' + window.location.href,
      ], { file: 'bp-configuratore.js' });
    } catch (bpErrore) { /* niente da fare */ }
  }
  window.addEventListener('error', function (bpEvento) {
    if (!bpEvento || !bpEvento.error) return;
    const bpPila = String(bpEvento.error.stack || '');
    if (String(bpEvento.filename || '').indexOf('bp-configuratore') === -1 && bpPila.indexOf('bp-configuratore') === -1) return;
    bpErroreJsConfiguratore(bpEvento.message || String(bpEvento.error), 'riga ' + bpEvento.lineno + ':' + bpEvento.colno);
  });
  window.addEventListener('unhandledrejection', function (bpEvento) {
    const bpMotivo = bpEvento && bpEvento.reason;
    if (String((bpMotivo && bpMotivo.stack) || '').indexOf('bp-configuratore') === -1) return;
    bpErroreJsConfiguratore((bpMotivo && bpMotivo.message) || String(bpMotivo), 'promessa non gestita');
  });

  /* Un valore di opzione scritto ESATTO: tra virgolette, con ogni carattere
     non ASCII stampabile in forma \uXXXX. Cosi' nell'avviso si vedono spazi
     doppi, spazi non separabili, apostrofi tipografici e simili, che a
     occhio sarebbero identici e per il confronto delle varianti no. */
  function bpEsatto(bpValore) {
    if (bpValore === null || bpValore === undefined) return 'NESSUNO';
    return '"' + String(bpValore).replace(/[^\x20-\x7E]/g, function (bpC) {
      return '\\u' + ('0000' + bpC.charCodeAt(0).toString(16)).slice(-4);
    }) + '"';
  }

  /* CONFRONTO DI RISERVA FRA TESTI (14/10/2026, variante sicura). Serve solo
     quando gli ID e il testo identico non bastano. Toglie le differenze che a
     occhio non si vedono: forma Unicode (NFC), spazi non separabili e
     invisibili, i vari tipi di punto (·, •, ⋅, ∙...), spazi doppi, maiuscole. */
  function bpNormalizza(bpValore) {
    let bpTesto = String(bpValore == null ? '' : bpValore);
    try { bpTesto = bpTesto.normalize('NFC'); } catch (bpErrore) { /* browser vecchio: si va avanti senza */ }
    return bpTesto
      .replace(/[     ​⁠﻿]/g, ' ')
      .replace(/[··•․‧∙⋅・･]/g, '·')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* Le parole chiave di un valore: i numeri (personaggi, misure, modello) e
     le parole che distinguono un formato o un modello. Ordinate e unite in
     una stringa sola, cosi' due valori si confrontano con un ===. */
  const BP_PAROLE_CHIAVE = ['cornice', 'tela', 'puzzle', 'digital', 'portachiav', 'iphone', 'pro', 'max', 'plus', 'mini', 'air'];
  function bpParoleChiave(bpValore) {
    const bpTesto = bpNormalizza(bpValore);
    /* I numeri anche dentro le misure: "21x30cm" da' 21 e 30. */
    const bpTenuti = bpTesto.match(/\d+/g) || [];
    bpTesto.split(/[^a-zà-ÿ]+/).filter(Boolean).forEach(function (bpParola) {
      const bpRadice = BP_PAROLE_CHIAVE.find(function (bpR) {
        return bpR.length <= 4 ? bpParola === bpR : bpParola.indexOf(bpR) === 0;
      });
      if (bpRadice) bpTenuti.push(bpRadice);
    });
    return bpTenuti.sort().join('|');
  }

  /* L'indirizzo della libreria, reso ASSOLUTO. Shopify lo serve senza
     protocollo ("//bepirate.it/cdn/..."), e un worker avviato da un Blob
     non ha una base contro cui risolverlo: importScripts lo rifiuta come
     non valido. Torna '' se manca, non si legge o non e' http(s): in quel
     caso il worker non parte e resta il riquadro "Foto caricata". */
  function bpUrlAssolutoLibreria(bpUrl) {
    if (!bpUrl) return '';
    try {
      const bpAssoluto = new URL(bpUrl, location.href).href;
      return /^https?:/i.test(bpAssoluto) ? bpAssoluto : '';
    } catch (bpErrore) {
      return '';
    }
  }

  /* ---- Android: il Photo Picker di sistema, e il suo ripiego ----------
     Su Android 13 e successivi, quando accept elenca SOLO tipi immagine,
     Chrome apre il Photo Picker di sistema. Il picker consegna un file
     "per procura": nome uguale al numero della foto in galleria (i
     "1000218512.jpg" che vediamo) e peso letto dal suo archivio invece
     che dai byte. Quando i due non combaciano, OGNI lettura del file
     fallisce: anteprima rotta, caricamento su R2 annullato con
     ERR_UPLOAD_FILE_CHANGED, e al click il ripiego muore allo stesso
     modo con "Impossibile aggiungere al carrello".
     Il Photo Picker resta la prima scelta, perche' per la maggior parte
     delle foto funziona ed e' il selettore piu' comodo. Solo quando una
     foto non si lascia leggere (bpTogliFotoNonUsabile) accept diventa
     questo: basta UN tipo non immagine perche' Chrome apra il suo
     selettore normale (File, filtrato sulle immagini, con Foto e Drive
     nel menu), che consegna il file vero. Il tipo e' inventato di
     proposito: nessun file lo ha, quindi non allarga niente. SOLO su
     Android: su iPhone accept resta "image/*" del Liquid, che e' cio' che
     fa convertire a Safari le HEIC in JPG da solo. */
  const BP_ACCEPT_ANDROID = 'image/*,.heic,.heif,application/x-bepirate-foto';

  /* ---- Caricamento anticipato su R2 --------------------------------
     Le foto oggi viaggiano allegate al POST /cart/add.js, e il cliente
     aspetta quei byte fermo davanti al bottone: misurati 4-6 secondi
     con gli allegati contro 429 ms senza. Il tempo non si puo'
     togliere, ma si puo' SPOSTARE: appena una foto e' convertita parte
     da sola verso R2, mentre il cliente sceglie lo sfondo e scrive i
     dettagli. Al click restera' da mandare solo il gettone.

     QUESTO MATTONE COSTRUISCE SOLO IL TRASPORTO. bpAddToCart non e'
     toccato e continua ad allegare i file: finche' il mattone
     successivo non cambia il click, questi caricamenti sono lavoro in
     piu' che nessuno consuma. E' voluto: si collauda il trasporto da
     solo, con il carrello che funziona esattamente come prima.

     La porta risponde con un gettone e un URL firmato che vale 15
     minuti. Il PUT manda il File NUDO, mai un FormData: la firma
     include content-length, e un multipart aggiungerebbe boundary e
     intestazioni che cambiano il peso, facendo fallire la firma. Per
     la stessa ragione il file NON si tocca fra la chiamata alla porta
     e il PUT: quello che si dichiara e' quello che si manda. */
  const BP_URL_PREPARA_FOTO = 'https://pannello.bepirate.it/.netlify/functions/prepara-foto';

  /* Tetto della porta, 6 MB. Sta SOTTO i 7 MB per foto del server che
     scarica per il brief, di proposito: cio' che entra da qui deve
     essere gia' accettabile a valle. Una foto sopra questo tetto non
     viene nemmeno annunciata alla porta. */
  const BP_FOTO_TETTO_R2 = 6 * 1024 * 1024;

  /* Quante foto, al massimo, catturano SUBITO i byte in un ArrayBuffer per
     il PUT su R2 (22/10/2026, vedi bpCatturaByte): oltre questo numero si
     torna al comportamento di sempre, bpPutBlob rilegge bpVoce.file a ogni
     tentativo. Il motivo e' la memoria: un telefono vecchio con otto foto
     da ridisegnare (il massimo del modulo, 3 o piu' personaggi) non deve
     tenere in mano anche otto copie extra dei byte, fino a 6 MB l'una,
     tutte insieme. Cinque copie, trenta MB nel peggiore dei casi, e' il
     prezzo per non perdere una foto quando il riferimento del WebView
     muore (il guasto del 22/10 su Instagram iOS). */
  const BP_FOTO_CATTURA_MAX = 5;

  /* ---- Sopra il tetto: si riduce, MAI si allega -----------------------
     Una foto sopra i 6 MB prima veniva allegata al POST /cart/add.js al
     click. E' li' che nasceva il 413 di Shopify con le foto pesanti. Ora
     NESSUNA foto viaggia mai nel carrello: passano tutte da R2.
     Il tetto non si puo' alzare dal tema: lo stesso limite sta nella porta
     (crm/netlify/functions/prepara-foto.mjs, MAX_BYTE) e, a valle, il
     brief scarica al massimo 7 MB per foto e 18 MB in tutto
     (crm/netlify/lib/scarica-foto.mjs).
     Quindi SOLO le foto che dopo la preparazione restano sopra il tetto
     si riducono ancora, a passi, finche' ci stanno. Sotto il tetto il
     file resta quello di oggi, HEIC comprese (all'ordine arriva
     l'originale). Una HEIC sopra il tetto passa prima da heic2any, che si
     scarica SOLO in quel caso: Chrome da solo non la sa decodificare. */
  const BP_RIDUZIONI_TETTO = [
    { latoMax: 3000, qualita: 0.85 },
    { latoMax: 2500, qualita: 0.8 },
    { latoMax: 2000, qualita: 0.8 },
  ];
  const BP_HEIC2ANY_URL = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';

  /* Timeout del PUT. Serve per forza un AbortController: fetch da solo
     non scade MAI, e una connessione morta terrebbe la voce in
     caricamento per sempre, senza Riprova e senza errore. */
  const BP_PUT_TIMEOUT_MS = 60000;

  /* RETE LENTA O CHE CADE (21/10/2026): due clienti con "Load failed" e
     "Failed to fetch": la chiamata a prepara-foto non e' mai arrivata, rete
     del cliente. Prima la chiamata non aveva timeout e i tentativi erano due
     con una pausa fissa. Ora:
     - prepara-foto scade dopo 10 secondi (AbortController);
     - il PUT verso R2 scade in base al peso: 15 secondi come minimo, poi
       quanto serve a 60 KB al secondo, al massimo 90 (una connessione morta
       con una foto piccola non aspetta piu' un minuto intero);
     - quattro tentativi TOTALI per foto, con attesa crescente fra l'uno e
       l'altro (1, 2 e 4 secondi);
     - un tetto di 150 secondi complessivi per foto, oltre il quale non parte
       un altro tentativo. Una foto che cade tutti i tentativi diventa
       "fallita" e il cliente vede il Riprova. */
  const BP_PREPARA_TIMEOUT_MS = 10000;
  const BP_PUT_TIMEOUT_MIN_MS = 15000;
  const BP_PUT_TIMEOUT_MAX_MS = 90000;
  const BP_PUT_BYTE_AL_SECONDO = 60 * 1024;
  const BP_PUT_TENTATIVI = 4;
  const BP_PUT_ATTESE_MS = [1000, 2000, 4000];
  const BP_FOTO_BUDGET_MS = 150000;

  /* Attesa massima della ricarica del prodotto (bpRicaricaProdotto) e pausa
     fra i due giri di lettura di una foto (bpCopiaInMemoria). */
  const BP_RICARICA_TIMEOUT_MS = 8000;
  const BP_LETTURA_PAUSA_MS = 600;
  /* RICARICA CADUTA PER LA RETE (30/10/2026). Quando la variante non si trova
     nei dati della pagina e anche la ricarica da Shopify non arriva, la
     colpa e' della linea, non della combinazione: il cliente legge
     BP_TESTO_RETE_LENTA (mai "combinazione non disponibile") e il modulo
     riprova da solo dopo queste attese, poi di nuovo al clic e quando il
     telefono torna online. */
  const BP_RICARICA_RIPROVE_MS = [2000, 5000, 10000];
  /* Ogni quanto si controlla che le scelte in pagina siano quelle registrate
     dal modulo (bpRicalcolaSeServe). Costa due letture di radio. */
  const BP_CONTROLLO_SCELTE_MS = 3000;
  const BP_TESTO_RETE_LENTA = 'Connessione lenta, riprova tra qualche secondo.';

  /* Quante foto salgono insieme. Due: la conversione resta seriale
     perche' pesa sulla CPU, il caricamento e' rete e regge il
     parallelo, ma otto PUT insieme si ruberebbero la banda a vicenda
     e su una linea lenta arriverebbero tutti tardi. */
  const BP_CARICAMENTI_PARALLELI = 2;

  /* Quanto il click aspetta i gettoni ancora in volo prima di fermarsi
     e dire al cliente di riprovare fra poco. Era 20 secondi quando alla
     scadenza si ripiegava sull'allegare i file; il ripiego non esiste
     piu', quindi l'attesa copre un PUT lento intero (su un 4G lento
     misurati 21 secondi per 3,7 MB). Le foto partono appena convertite:
     al click sono quasi sempre gia' arrivate, e questa attesa conta solo
     sulle reti lente. */
  const BP_ATTESA_GETTONI_MS = 60000;

  /* Ogni quanto il click ricontrolla se i gettoni sono arrivati. Non e'
     una attesa attiva: fra un controllo e l'altro il browser fa il suo
     lavoro, ridisegna e porta avanti i caricamenti che stiamo
     aspettando. Un decimo di secondo e' impercettibile per chi guarda e
     costa duecento controlli in venti secondi, cioe' niente. */
  const BP_ATTESA_PASSO_MS = 100;

  /* ---- Ripristino delle foto al ritorno sulla pagina ----------------
     La memoria di sessione tiene il GETTONE di ogni foto gia' arrivata
     su R2, mai i byte. Un gettone da solo non si vede: questa porta lo
     trasforma in un indirizzo di lettura firmato, fino a otto gettoni
     in una chiamata sola, e da quell'indirizzo si riscaricano i byte.

     PERCHE' SI RISCARICANO, invece di mettere l'indirizzo dentro il tag
     immagine e basta. Un indirizzo firmato vale 600 secondi: dopo, il
     PRIMO ridisegno della griglia (una foto aggiunta, una tolta, un
     caricamento finito) rimetterebbe in un src un indirizzo ormai
     scaduto, e le miniature diventerebbero riquadri rotti mentre il
     cliente e' ancora li'. Con i byte in mano si ricostruisce un File
     vero: da quel momento la voce e' indistinguibile da una appena
     caricata, l'anteprima e' un objectURL locale che non scade, e il
     ripiego del click (che allega i file) funziona senza sapere niente
     di tutto questo. */
  const BP_URL_RILEGGI_FOTO = 'https://pannello.bepirate.it/.netlify/functions/rileggi-foto';

  /* Timeout della chiamata alla porta e di ogni scarico: fetch da solo
     non scade mai, e un ripristino appeso lascerebbe i segnaposto per
     sempre. Lo scarico ha piu' tempo perche' porta dei byte veri. */
  const BP_RILEGGI_TIMEOUT_MS = 15000;
  const BP_SCARICO_TIMEOUT_MS = 30000;

  /* Un solo ritentativo, e solo sugli errori di rete. Un 403 o un 404
     dicono che su R2 quel file non c'e' piu': riprovare darebbe lo
     stesso esito e ritarderebbe l'avviso al cliente. */
  const BP_SCARICO_TENTATIVI = 2;
  const BP_SCARICO_PAUSA_MS = 1500;

  /* Property del saltacoda sul RITRATTO: etichetta e valore ESATTI,
     copiati da OPTIS (progetto, punto 5). Il brief generator li legge
     alla lettera: non cambiare nemmeno uno spazio. */
  const BP_PROP_SALTACODA_NOME =
    'Ti serve il prima possibile? Aggiungi il Saltacoda e il disegno sarà pronto in 24 ore!';
  const BP_PROP_SALTACODA_VALORE = 'Sì! Aggiungi il Saltacoda (+ €5,00)';

  /* Property per la descrizione dello sfondo personalizzato. Nome
     NOSTRO (nessun vincolo OPTIS), tenuto ASCII PURO di proposito:
     i nomi campo non-ASCII si perdono nel multipart (lezione del
     saltacoda). Il valore UTF-8 viaggia nel body: sicuro. */
  const BP_PROP_SFONDO_DESCR = 'Descrivi lo sfondo personalizzato';

  /* Tetto di sicurezza del segnale "sequenza di aggiunta in corso" (vedi
     bpApriSequenzaCarrello): se per qualunque motivo il finally non
     arrivasse, dopo questo tempo il carrello torna a controllare gli
     orfani da solo. */
  const BP_SEQUENZA_CARRELLO_MAX_MS = 15000;

  /* Valore della descrizione quando il cliente sceglie il Personalizzato e
     lascia la casella vuota. FISSO NEL CODICE, non dal theme editor: e' un
     segnale per l'artista e per il brief, non un testo da vetrina, e deve
     restare identico ordine dopo ordine. */
  const BP_SFONDO_DESCR_VUOTA = 'Nessuna indicazione del cliente: sfondo a fantasia dell\'artista.';

  /* BP-MODALITA — properties della modalità Wanted, CONFERMATE su un
     ordine OPTIS vero del Manifesto. Il brief generator le legge
     alla lettera: non cambiare nemmeno uno spazio.
     - Il NOME è ASCII puro: viaggia nel multipart come gli altri.
     - La TAGLIA contiene l'apostrofo tipografico ’ (non-ASCII):
       nel multipart il nome si perderebbe (stessa lezione del
       saltacoda), quindi viaggia in JSON: dal 08/10/2026 dentro
       l'aggiunta unica di bpAddToCart (prima via bpWriteJsonProperties). */
  const BP_PROP_WANTED_NOME = 'Inserisci il nome sul manifesto';
  /* L'apostrofo tipografico U+2019 è scritto come escape \u2019
     per evitare che editor o encoding lo normalizzino in ' (ASCII). */
  const BP_PROP_WANTED_TAGLIA = 'Specifica l\u2019ammontare della taglia';

  /* ---- Il PNG ha un canale alpha? -----------------------------------
     Si legge l'INTESTAZIONE, non l'immagine: nessun decode, nessun
     canvas, una manciata di byte. Un PNG \u00e8 8 byte di firma, poi il
     chunk IHDR; il byte 25 \u00e8 il colour type:
       0 grigio, 2 RGB          -> nessun alpha, convertibile in JPEG
       3 palette                -> l'alpha pu\u00f2 esserci, in un chunk tRNS
                                   pi\u00f9 avanti. NON lo si va a cercare: si
                                   d\u00e0 per trasparente e si resta PNG. \u00c8
                                   la scelta prudente, e costa poco
                                   perch\u00e9 i PNG a palette sono rari e
                                   leggeri; sbagliare dall'altra parte
                                   vorrebbe dire uno sfondo trasparente
                                   che diventa nero.
       4 grigio+alpha, 6 RGBA   -> alpha, si resta PNG
     Qualunque intoppo nella lettura vale "s\u00ec, trasparente": nel dubbio
     si sceglie la strada che non rovina l'immagine. */
  async function bpPngHaAlpha(bpFile) {
    try {
      const bpTesta = new Uint8Array(await bpFile.slice(0, 26).arrayBuffer());
      if (bpTesta.length < 26) return true;
      if (bpTesta[0] !== 0x89 || bpTesta[1] !== 0x50) return true;
      const bpColourType = bpTesta[25];
      return bpColourType === 3 || bpColourType === 4 || bpColourType === 6;
    } catch (bpErrore) {
      return true;
    }
  }

  /* ---- Il browser onora imageOrientation: 'from-image'? --------------
     Dove non \u00e8 supportato, l'opzione viene IGNORATA IN SILENZIO: nessuna
     eccezione, quindi un try/catch non servirebbe a niente. L'unico modo
     onesto di saperlo \u00e8 provare su un campione noto.

     Sotto c'\u00e8 una JPEG di 1x2 px con EXIF orientation 6 (ruota di 90\u00b0):
     se il browser la applica, la bitmap esce 2x1 invece che 1x2. La
     sonda gira UNA volta sola e il risultato resta in cache. */
  const BP_EXIF_CAMPIONE =
    'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4QAiRXhpZgAATU0AKgAAAAgAAQES' +
    'AAMAAAABAAYAAAAAAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIs' +
    'IxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/wAALCAACAAEBAREA/8QAFAABAAAAAAAAAAAAAAAAAAAACf/E' +
    'ABQQAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQEAAD8AKp//2Q==';
  let bpExifPromessa = null;
  function bpExifSupportato() {
    if (bpExifPromessa) return bpExifPromessa;
    bpExifPromessa = (async function () {
      try {
        if (typeof createImageBitmap !== 'function') return false;
        const bpRisposta = await fetch(BP_EXIF_CAMPIONE);
        const bpBlob = await bpRisposta.blob();
        const bpBitmap = await createImageBitmap(bpBlob, { imageOrientation: 'from-image' });
        const bpRuotata = bpBitmap.width > bpBitmap.height;
        bpBitmap.close();
        return bpRuotata;
      } catch (bpErrore) {
        return false;
      }
    })();
    return bpExifPromessa;
  }

  /* ---- Decodifica orientata ------------------------------------------
     Due strade, stesso risultato: un'immagine gi\u00e0 girata come il
     telefono l'ha scattata.
     1. createImageBitmap con from-image, quando la sonda dice che il
        browser lo onora: veloce e fuori dal thread principale;
     2. altrimenti un <img> con decode(). Da anni tutti i browser
        applicano l'orientamento EXIF quando renderizzano un <img> (\u00e8 il
        default CSS image-orientation: from-image), quindi disegnarlo su
        canvas d\u00e0 l'immagine gi\u00e0 dritta.
     Torna { sorgente, larghezza, altezza, chiudi } cos\u00ec chi disegna non
     deve sapere da quale delle due strade arriva. */
  async function bpDecodificaOrientata(bpFile) {
    if (await bpExifSupportato()) {
      const bpBitmap = await createImageBitmap(bpFile, { imageOrientation: 'from-image' });
      return {
        sorgente: bpBitmap,
        larghezza: bpBitmap.width,
        altezza: bpBitmap.height,
        chiudi: function () { bpBitmap.close(); },
      };
    }
    const bpUrl = URL.createObjectURL(bpFile);
    try {
      const bpImg = new Image();
      bpImg.src = bpUrl;
      await bpImg.decode();
      return {
        sorgente: bpImg,
        larghezza: bpImg.naturalWidth,
        altezza: bpImg.naturalHeight,
        chiudi: function () { URL.revokeObjectURL(bpUrl); },
      };
    } catch (bpErrore) {
      URL.revokeObjectURL(bpUrl);
      throw bpErrore;
    }
  }

  /* ---- La conversione vera --------------------------------------------
     Torna SEMPRE { file, esito }, MAI un lancio: il chiamante non deve
     mai trovarsi senza foto.
       intatta    -> l'originale va bene cos\u00ec com'\u00e8
       convertita -> ridimensionata e/o ricompressa
       ripiego    -> qualcosa \u00e8 andato storto, si usa l'originale
     Il nome del file originale viene conservato in tutti e tre i casi.
     La bitmap si chiude nel finally: con otto foto in fila, non
     rilasciarla vuol dire tenere in memoria centinaia di MB.
     bpOpzioni serve SOLO alla riduzione sopra il tetto (bpRiduciSottoTetto):
     lato e qualita' di quel passo. Senza, tutto come sempre. */
  async function bpPreparaFoto(bpFile, bpOpzioni) {
    const bpTipo = (bpFile.type || '').toLowerCase();
    const bpEPng = bpTipo === 'image/png';
    const bpLatoMax = (bpOpzioni && bpOpzioni.latoMax) || BP_FOTO_LATO_MAX;
    const bpQualita = (bpOpzioni && bpOpzioni.qualita) || BP_FOTO_QUALITA;

    /* Sotto soglia e non-PNG: niente da guadagnare, si passa oltre
       senza nemmeno decodificare. Un PNG piccolo con alpha ricade qui
       per la stessa ragione. */
    if (!bpOpzioni && bpFile.size <= BP_FOTO_SOGLIA_INTATTA) {
      return { file: bpFile, esito: 'intatta' };
    }

    let bpDecodificata = null;
    try {
      /* Un PNG con trasparenza resta PNG: in JPEG l'alpha sparirebbe e
         lo sfondo diventerebbe nero. Si ridimensiona lo stesso, perch\u00e9
         un PNG da 12 MB sbatterebbe comunque sui tetti del server. */
      const bpMantieniPng = bpEPng && (await bpPngHaAlpha(bpFile));

      bpDecodificata = await bpDecodificaOrientata(bpFile);
      const bpLargo = bpDecodificata.larghezza;
      const bpAlto = bpDecodificata.altezza;
      if (!bpLargo || !bpAlto) return { file: bpFile, esito: 'ripiego' };

      /* MAI ingrandire: il fattore \u00e8 al massimo 1. */
      const bpLatoLungo = Math.max(bpLargo, bpAlto);
      const bpFattore = Math.min(1, bpLatoMax / bpLatoLungo);
      const bpNuovoLargo = Math.max(1, Math.round(bpLargo * bpFattore));
      const bpNuovoAlto = Math.max(1, Math.round(bpAlto * bpFattore));

      const bpCanvas = document.createElement('canvas');
      bpCanvas.width = bpNuovoLargo;
      bpCanvas.height = bpNuovoAlto;
      const bpCtx = bpCanvas.getContext('2d');
      if (!bpCtx) return { file: bpFile, esito: 'ripiego' };
      bpCtx.drawImage(bpDecodificata.sorgente, 0, 0, bpNuovoLargo, bpNuovoAlto);

      const bpMime = bpMantieniPng ? 'image/png' : 'image/jpeg';
      const bpBlob = await new Promise(function (bpRisolvi) {
        /* toBlob passa null se non ce la fa: si tratta come fallimento. */
        bpCanvas.toBlob(bpRisolvi, bpMime, bpMantieniPng ? undefined : bpQualita);
      });
      if (!bpBlob) return { file: bpFile, esito: 'ripiego' };

      /* Rete finale: se il risultato pesa pi\u00f9 dell'originale (capita coi
         PNG e con le foto gi\u00e0 molto compresse) si tiene l'originale. */
      if (bpBlob.size >= bpFile.size) {
        return { file: bpFile, esito: 'intatta' };
      }

      const bpConvertito = new File([bpBlob], bpFile.name, {
        type: bpMime,
        lastModified: bpFile.lastModified || Date.now(),
      });
      return { file: bpConvertito, esito: 'convertita' };
    } catch (bpErrore) {
      /* HEIC che il browser non sa decodificare, memoria finita, canvas
         sporcato: qualunque cosa sia, si carica l'originale. */
      console.warn('[bp-configuratore] Foto non convertita, si carica l\'originale:', bpFile.name, bpErrore);
      return { file: bpFile, esito: 'ripiego' };
    } finally {
      if (bpDecodificata) {
        try { bpDecodificata.chiudi(); } catch (bpErroreChiusura) { /* niente da fare */ }
      }
    }
  }

  /* ---- Riconoscere il formato senza fidarsi solo di file.type ---------
     Su alcuni Android file.type arriva VUOTO: per le HEIC, e per le foto
     senza estensione nel nome. Prima quei file venivano scartati come
     "non immagini". Ora si guardano, in quest'ordine, il tipo, poi
     l'estensione del nome, poi i primi byte del file (la firma del
     formato), che sono l'unica cosa che non mente. */
  const BP_ESTENSIONI_IMMAGINE = /\.(jpe?g|png|webp|gif|heic|heif|avif|bmp)$/i;

  function bpEHeic(bpFile) {
    const bpTipo = (bpFile.type || '').toLowerCase();
    return bpTipo === 'image/heic' || bpTipo === 'image/heif'
      || bpTipo === 'image/heic-sequence' || bpTipo === 'image/heif-sequence'
      || /\.(heic|heif)$/i.test(bpFile.name || '');
  }

  /* heic2any si scarica una volta sola, e SOLO quando una HEIC supera il
     tetto (vedi BP_RIDUZIONI_TETTO). Se lo scarico fallisce la promessa
     si azzera: la volta dopo si ritenta. */
  let bpHeic2anyPromessa = null;
  function bpCaricaHeic2any() {
    if (typeof window.heic2any === 'function') return Promise.resolve(window.heic2any);
    if (!bpHeic2anyPromessa) {
      bpHeic2anyPromessa = new Promise(function (bpRisolvi, bpRifiuta) {
        const bpScript = document.createElement('script');
        bpScript.src = BP_HEIC2ANY_URL;
        bpScript.async = true;
        bpScript.onload = function () {
          if (typeof window.heic2any === 'function') bpRisolvi(window.heic2any);
          else bpRifiuta(new Error('heic2any non disponibile dopo lo scarico'));
        };
        bpScript.onerror = function () { bpRifiuta(new Error('heic2any non scaricata')); };
        document.head.appendChild(bpScript);
      }).catch(function (bpErrore) {
        bpHeic2anyPromessa = null;
        throw bpErrore;
      });
    }
    return bpHeic2anyPromessa;
  }

  /* ---- Riduzione sopra il tetto ----------------------------------------
     Parte SOLO per una foto che dopo la preparazione normale pesa ancora
     piu' di BP_FOTO_TETTO_R2. Lavora sull'originale (la qualita' migliore
     da cui ripartire) e prova i passi di BP_RIDUZIONI_TETTO in ordine,
     fermandosi al primo che ci sta. Una HEIC diventa prima JPG a piena
     risoluzione con heic2any.
     Torna il File ridotto, oppure null se nemmeno l'ultimo passo basta o
     se la foto non si decodifica: allora la voce resta "non-caricabile" e
     il cliente viene avvisato, perche' allegarla al carrello non e' piu'
     una strada. Non lancia mai. */
  async function bpRiduciSottoTetto(bpFile) {
    try {
      let bpSorgente = bpFile;
      if (bpEHeic(bpFile)) {
        const bpHeic2any = await bpCaricaHeic2any();
        const bpUscita = await bpHeic2any({ blob: bpFile, toType: 'image/jpeg', quality: 0.92 });
        const bpJpeg = Array.isArray(bpUscita) ? bpUscita[0] : bpUscita;
        if (!bpJpeg || !bpJpeg.size) return null;
        bpSorgente = new File([bpJpeg], bpFile.name, {
          type: 'image/jpeg',
          lastModified: bpFile.lastModified || Date.now(),
        });
      }
      for (let bpI = 0; bpI < BP_RIDUZIONI_TETTO.length; bpI += 1) {
        const bpPasso = await bpPreparaFoto(bpSorgente, BP_RIDUZIONI_TETTO[bpI]);
        /* 'ripiego' vuol dire che la decodifica non e' riuscita: gli altri
           passi fallirebbero allo stesso modo. */
        if (bpPasso.esito === 'ripiego') return null;
        if (bpPasso.file.size <= BP_FOTO_TETTO_R2) return bpPasso.file;
      }
      return null;
    } catch (bpErrore) {
      console.warn('[bp-configuratore] Riduzione sotto il tetto non riuscita:', bpFile.name, bpErrore);
      return null;
    }
  }

  /* Prima scrematura, al momento della scelta, senza leggere niente:
     scarta solo cio' che si dichiara con certezza come non immagine
     (un PDF, un video). Un file senza tipo e senza estensione passa, e
     lo giudica la firma dopo la lettura. */
  function bpSembraImmagine(bpFile) {
    const bpTipo = (bpFile.type || '').toLowerCase();
    if (bpTipo.indexOf('image/') === 0) return true;
    if (BP_ESTENSIONI_IMMAGINE.test(bpFile.name || '')) return true;
    return bpTipo === '' || bpTipo === 'application/octet-stream';
  }

  /* Il tipo vero dai primi 12 byte. Torna '' se non e' un formato noto. */
  function bpTipoDaFirma(bpByte) {
    if (bpByte.length < 12) return '';
    if (bpByte[0] === 0xff && bpByte[1] === 0xd8 && bpByte[2] === 0xff) return 'image/jpeg';
    if (bpByte[0] === 0x89 && bpByte[1] === 0x50 && bpByte[2] === 0x4e && bpByte[3] === 0x47) return 'image/png';
    const bpAscii = function (bpDa, bpA) { return String.fromCharCode.apply(null, bpByte.slice(bpDa, bpA)); };
    if (bpAscii(0, 4) === 'RIFF' && bpAscii(8, 12) === 'WEBP') return 'image/webp';
    if (bpAscii(0, 3) === 'GIF') return 'image/gif';
    if (bpAscii(4, 8) === 'ftyp') {
      const bpMarca = bpAscii(8, 12);
      if (bpMarca === 'avif' || bpMarca === 'avis') return 'image/avif';
      if (/^(heic|heix|hevc|hevx|heim|heis|mif1|msf1)$/.test(bpMarca)) return 'image/heic';
    }
    return '';
  }

  /* ---- I byte in memoria, SUBITO ----------------------------------------
     Il File che arriva dal selettore e' un riferimento a un file del
     telefono, non i byte. Su Android quel riferimento puo' smettere di
     funzionare (Photo Picker, Google Foto, Drive): ogni lettura successiva
     fallisce e Chrome annulla gli invii con ERR_UPLOAD_FILE_CHANGED. Qui
     si leggono i byte UNA volta, appena scelto il file, e da li' in poi
     anteprima, conversione, caricamento su R2 e ripiego lavorano sulla
     copia in memoria, che non puo' piu' cambiare sotto i piedi.
     I BYTE NON SI TOCCANO: la copia e' identica al file scelto, cambia
     solo il tipo quando il telefono lo lascia vuoto (lo decide la firma).
     Lancia un errore con bpCausa:
       'illeggibile'  -> il telefono non ci ha dato i byte;
       'non-immagine' -> i byte ci sono ma non sono una foto. */
  /* LA LETTURA PROVA PIU' STRADE (20/10/2026). Prima c'era solo
     file.arrayBuffer(): se falliva, la foto era persa. Ora, in ordine:
     arrayBuffer, FileReader, Response(file); poi una pausa breve e lo stesso
     giro una seconda volta. I byte restano quelli del file: nessuna
     ricodifica. SU UN RIFERIMENTO DAVVERO MORTO (file cambiato o sparito
     dopo la scelta) nessuna strada funziona, provato sul banco con un
     NotReadableError vero: il secondo metodo salva solo i guasti
     passeggeri (file ancora in scrittura, sincronizzazione, poca memoria).
     Gli altri casi restano al messaggio con l'uscita WhatsApp. I nomi degli
     errori incontrati vanno nell'avviso al Capitano. */
  function bpLeggiConFileReader(bpFile) {
    return new Promise(function (bpOk, bpNo) {
      const bpLettore = new FileReader();
      bpLettore.onload = function () { bpOk(bpLettore.result); };
      bpLettore.onerror = function () { bpNo(bpLettore.error || new Error('FileReader')); };
      bpLettore.readAsArrayBuffer(bpFile);
    });
  }

  async function bpLeggiByte(bpFile) {
    const bpErrori = [];
    const bpStrade = [
      ['arrayBuffer', function () { return bpFile.arrayBuffer(); }],
      ['FileReader', function () { return bpLeggiConFileReader(bpFile); }],
      ['Response', function () { return new Response(bpFile).arrayBuffer(); }],
    ];
    for (let bpGiro = 1; bpGiro <= 2; bpGiro += 1) {
      if (bpGiro === 2) await bpAspetta(BP_LETTURA_PAUSA_MS);
      for (let bpI = 0; bpI < bpStrade.length; bpI += 1) {
        try {
          const bpByte = await bpStrade[bpI][1]();
          if (bpByte && bpByte.byteLength > 0) {
            if (bpErrori.length) console.warn('[bp-configuratore] Foto letta con ' + bpStrade[bpI][0] + ' al giro ' + bpGiro + ' dopo: ' + bpErrori.join(', '));
            return { byte: bpByte, errori: bpErrori };
          }
          bpErrori.push(bpStrade[bpI][0] + ':vuoto');
        } catch (bpErroreLettura) {
          bpErrori.push(bpStrade[bpI][0] + ':' + ((bpErroreLettura && bpErroreLettura.name) || 'errore'));
        }
      }
    }
    return { byte: null, errori: bpErrori };
  }

  async function bpCopiaInMemoria(bpFile) {
    const bpLetto = await bpLeggiByte(bpFile);
    const bpBuffer = bpLetto.byte;
    if (!bpBuffer) {
      const bpIlleggibile = new Error('foto non leggibile dal telefono (' + bpLetto.errori.join(', ') + ')');
      bpIlleggibile.bpCausa = 'illeggibile';
      throw bpIlleggibile;
    }
    if (!bpBuffer || bpBuffer.byteLength === 0) {
      const bpVuoto = new Error('foto vuota');
      bpVuoto.bpCausa = 'illeggibile';
      throw bpVuoto;
    }
    const bpFirma = bpTipoDaFirma(new Uint8Array(bpBuffer, 0, Math.min(12, bpBuffer.byteLength)));
    let bpTipo = (bpFile.type || '').toLowerCase();
    if (bpTipo.indexOf('image/') !== 0) {
      /* Tipo vuoto o generico: decide la firma. */
      if (!bpFirma) {
        const bpNonFoto = new Error('il file non e\' un\'immagine');
        bpNonFoto.bpCausa = 'non-immagine';
        throw bpNonFoto;
      }
      bpTipo = bpFirma;
    }
    return new File([bpBuffer], bpFile.name || 'foto', {
      type: bpTipo,
      lastModified: bpFile.lastModified || Date.now(),
    });
  }

  /* Copia i byte del file FINALE (dopo l'eventuale ridimensionamento) in un
     ArrayBuffer, SUBITO che la foto e' pronta (22/10/2026): i PUT su R2
     leggono da qui (bpVoce.bpByte), mai piu' da bpVoce.file. Se il
     riferimento muore dopo (il guasto del 22/10 su Instagram iOS, giri
     falliti in 0,0 secondi perche' fetch non apriva nemmeno il flusso del
     Blob) i byte sono gia' al sicuro e il quarto tentativo ha la stessa
     possibilita' di riuscire del primo.
     Fallisce in silenzio: bpVoce.bpByte resta vuoto e bpCaricaFoto ripiega
     sul comportamento di sempre (rilegge bpVoce.file), come se questa
     funzione non fosse mai stata chiamata. Nessuna foto si perde per un
     guasto qui dentro: e' una rete in piu', non un requisito. */
  async function bpCatturaByte(bpVoce) {
    try {
      bpVoce.bpByte = await bpVoce.file.arrayBuffer();
    } catch (bpErrore) {
      console.warn('[bp-configuratore] Cattura byte in memoria fallita, resta il ripiego su bpVoce.file:', bpErrore);
    }
  }


  /* ---- POST multipart con avanzamento reale ---------------------------
     Serve SOLO per la chiamata del ritratto, quella che si porta dietro
     le foto e dura secondi. fetch non espone l'avanzamento dell'upload:
     l'unico modo di sapere quanti byte sono davvero partiti e'
     XMLHttpRequest con upload.onprogress. Le altre chiamate del modulo
     restano fetch, perche' sono istantanee e non hanno niente da
     mostrare.

     La risposta imita quel poco di fetch che il chiamante usa davvero
     (ok, status, json()), cosi' il codice a valle resta identico: stessi
     rami di errore, stesso parse, stesso rollback. Cambia il trasporto,
     non il comportamento.

     Nessun Content-Type impostato a mano: il boundary del multipart lo
     scrive il browser, esattamente come faceva fetch. */
  function bpPostConProgresso(bpUrl, bpFormData, bpOnProgresso, bpTipoCorpo) {
    return new Promise(function (bpRisolvi, bpRifiuta) {
      const bpXhr = new XMLHttpRequest();
      bpXhr.open('POST', bpUrl, true);
      /* Una richiesta nostra: se cade, a segnalarla e' bpAvvisaCapitano con
         tutto dentro, non il wrapper di snippets/bp-errori.liquid (27/10/2026,
         un guasto = una segnalazione). */
      bpXhr.__bpDelConfiguratore = true;
      bpXhr.setRequestHeader('Accept', 'application/json');
      /* Corpo JSON (aggiunta unica, 08/10/2026): va dichiarato. Con un
         FormData invece il Content-Type lo mette il browser, col suo
         boundary, e non si tocca. */
      if (bpTipoCorpo) bpXhr.setRequestHeader('Content-Type', bpTipoCorpo);

      /* lengthComputable e' falso finche' il browser non sa il totale, e
         su alcuni proxy resta falso: in quel caso non si aggiorna nulla e
         la barra resta dov'e', invece di saltare a numeri inventati. */
      if (bpXhr.upload && typeof bpOnProgresso === 'function') {
        bpXhr.upload.onprogress = function (bpEvento) {
          if (bpEvento.lengthComputable && bpEvento.total > 0) {
            bpOnProgresso(bpEvento.loaded / bpEvento.total);
          }
        };
      }

      bpXhr.onload = function () {
        const bpTesto = bpXhr.responseText;
        bpRisolvi({
          ok: bpXhr.status >= 200 && bpXhr.status < 300,
          status: bpXhr.status,
          /* Il corpo grezzo, solo per l'avviso al Capitano quando l'invio
             fallisce (bpAvvisaCapitano): dice se Shopify ha risposto con
             un JSON, con una pagina HTML o con niente. */
          testo: bpTesto,
          /* Come fetch: rifiuta se il corpo non e' JSON, e il chiamante
             lo cattura gia' col suo try/catch. */
          json: function () {
            return Promise.resolve().then(function () { return JSON.parse(bpTesto); });
          },
        });
      };
      /* Guasto di rete: fetch lancerebbe, e qui si rifiuta. Il catch
         esterno di bpAddToCart mostra l'errore generico, come sempre. */
      bpXhr.onerror = function () { bpRifiuta(new Error('rete non raggiungibile')); };
      bpXhr.onabort = function () { bpRifiuta(new Error('richiesta interrotta')); };
      bpXhr.ontimeout = function () { bpRifiuta(new Error('richiesta scaduta')); };

      bpXhr.send(bpFormData);
    });
  }

  /* ---- AGGIUNTA AL CARRELLO CHE CADE PER LA RETE (27/10/2026) -----------
     Caso vero (Android 16, browser interno Instagram): foto gia' su R2, poi
     il POST a /cart/add.js cade dopo 6,4 s con "rete non raggiungibile",
     telefono online. Una rete che cade NON dice se la richiesta e' arrivata
     a Shopify: se e' arrivata la riga e' nel carrello e il cliente vede un
     errore per un'aggiunta riuscita; se non e' arrivata ed e' lui a
     riprovare, la ripetizione rischia di entrare due volte.

     Per questo, SOLO quando il POST cade per la rete (mai su una risposta
     di Shopify, 422 compreso, che ha il suo ramo):
     1. si legge /cart.js e si guarda se la quantita' della variante del
        ritratto e' salita rispetto a PRIMA dell'invio. Confronto per
        variante e non per proprieta': due aggiunte uguali di fila Shopify
        le fonde in una riga con quantita' 2, quindi "la riga c'e' gia'"
        non basta, serve "e' salita";
     2. se e' salita, l'aggiunta e' riuscita: si va avanti come dopo un
        successo (il drawer rilegge le sezioni da solo);
     3. se non e' salita, si aspetta 2 s (una richiesta ancora in volo ha il
        tempo di arrivare), si rilegge, e solo se ancora niente si riprova
        UNA volta. L'aggiunta e' tutto o niente (items in una chiamata), quindi
        guardare il ritratto basta anche con Saltacoda e Sfondo;
     4. se anche la riprova cade, si rilegge ancora una volta il carrello
        prima di dare l'errore: solo se la riga non c'e' il cliente vede il
        messaggio.
     Se il carrello non si lascia leggere non si indovina: si da' l'errore
     e basta, perche' riprovare alla cieca e' proprio il modo di avere il
     doppione. Senza il "prima" (lettura fallita) una riga gia' presente si
     conta come arrivata: nel peggiore dei casi manca un esemplare e il
     cliente lo vede nel carrello, mai uno in piu' da pagare. */
  const BP_CARRELLO_LETTURA_TIMEOUT_MS = 4000;
  const BP_ADD_RIPROVA_ATTESA_MS = 2000;

  /* Quantita' totale della variante nel carrello, o null se il carrello non
     si lascia leggere (rete, timeout, pagina non JSON). Non lancia mai. */
  async function bpQuantitaNelCarrello(bpIdVariante) {
    const bpControllore = new AbortController();
    const bpTimer = setTimeout(function () { bpControllore.abort(); }, BP_CARRELLO_LETTURA_TIMEOUT_MS);
    try {
      const bpRisposta = await fetch('/cart.js', {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: bpControllore.signal,
      });
      if (!bpRisposta.ok) return null;
      const bpCarrello = await bpRisposta.json();
      if (!bpCarrello || !Array.isArray(bpCarrello.items)) return null;
      let bpTotale = 0;
      bpCarrello.items.forEach(function (bpRiga) {
        if (Number(bpRiga.variant_id) === Number(bpIdVariante)) bpTotale += Number(bpRiga.quantity) || 0;
      });
      return bpTotale;
    } catch (bpErrore) {
      return null;
    } finally {
      clearTimeout(bpTimer);
    }
  }

  function bpAttendi(bpMs) {
    return new Promise(function (bpRisolvi) { setTimeout(bpRisolvi, bpMs); });
  }

  /* 'arrivata' | 'assente' | 'ignoto'. bpPrima e' la quantita' letta prima
     dell'invio (o null). Una lettura fallita si ripete una volta dopo la
     pausa: e' la stessa rete che e' appena caduta. */
  async function bpVerificaArrivo(bpIdVariante, bpPrima) {
    let bpOra = await bpQuantitaNelCarrello(bpIdVariante);
    if (bpOra === null) {
      await bpAttendi(BP_ADD_RIPROVA_ATTESA_MS);
      bpOra = await bpQuantitaNelCarrello(bpIdVariante);
    }
    if (bpOra === null) return { esito: 'ignoto', quantita: null };
    const bpArrivata = (bpPrima === null) ? bpOra > 0 : bpOra > bpPrima;
    return { esito: bpArrivata ? 'arrivata' : 'assente', quantita: bpOra };
  }

  /* Risposta finta, con la forma che il chiamante usa (ok, status, testo,
     json), per l'aggiunta che risulta gia' nel carrello: il JSON vuoto fa
     passare il ramo di successo e il drawer va a prendersi le sezioni. */
  function bpRispostaRecuperata() {
    return { ok: true, status: 200, testo: '', json: function () { return Promise.resolve({}); } };
  }

  /* Ritorna { risposta, recupero }: recupero e' null se il primo POST e'
     andato, altrimenti dice come e' finita. Se non c'e' modo di avere
     l'aggiunta lancia l'errore di rete, con bpRecupero che racconta i passi
     (per l'avviso al Capitano). */
  async function bpAggiungiConRecupero(bpUrl, bpCorpo, bpOnProgresso, bpIdVariante, bpPrima) {
    let bpErrorePrimo;
    try {
      return { risposta: await bpPostConProgresso(bpUrl, bpCorpo, bpOnProgresso, 'application/json'), recupero: null };
    } catch (bpErrore) {
      bpErrorePrimo = bpErrore;
    }

    const bpPrimoControllo = await bpVerificaArrivo(bpIdVariante, bpPrima);
    if (bpPrimoControllo.esito === 'arrivata') {
      return { risposta: bpRispostaRecuperata(), recupero: 'riga gia\' nel carrello dopo la rete caduta (quantita ' + bpPrimoControllo.quantita + ', prima ' + bpPrima + ')' };
    }
    if (bpPrimoControllo.esito === 'ignoto') {
      bpErrorePrimo.bpRecupero = 'carrello non leggibile, nessuna riprova';
      throw bpErrorePrimo;
    }

    await bpAttendi(BP_ADD_RIPROVA_ATTESA_MS);
    const bpSecondoControllo = await bpVerificaArrivo(bpIdVariante, bpPrima);
    if (bpSecondoControllo.esito === 'arrivata') {
      return { risposta: bpRispostaRecuperata(), recupero: 'riga arrivata in ritardo, nessuna riprova (quantita ' + bpSecondoControllo.quantita + ', prima ' + bpPrima + ')' };
    }
    if (bpSecondoControllo.esito === 'ignoto') {
      bpErrorePrimo.bpRecupero = 'carrello non leggibile dopo la pausa, nessuna riprova';
      throw bpErrorePrimo;
    }

    let bpErroreSecondo;
    try {
      const bpRispostaRiprova = await bpPostConProgresso(bpUrl, bpCorpo, bpOnProgresso, 'application/json');
      return { risposta: bpRispostaRiprova, recupero: 'riprovato dopo ' + BP_ADD_RIPROVA_ATTESA_MS + ' ms (primo errore: ' + bpErrorePrimo.message + ')' };
    } catch (bpErrore) {
      bpErroreSecondo = bpErrore;
    }

    const bpControlloFinale = await bpVerificaArrivo(bpIdVariante, bpPrima);
    if (bpControlloFinale.esito === 'arrivata') {
      const bpInPiu = (bpPrima !== null && bpControlloFinale.quantita - bpPrima > 1) ? ' | ATTENZIONE quantita ' + bpControlloFinale.quantita + ' contro ' + bpPrima + ' prima: entrata piu\' di una volta' : '';
      return { risposta: bpRispostaRecuperata(), recupero: 'seconda rete caduta ma riga nel carrello (quantita ' + bpControlloFinale.quantita + ', prima ' + bpPrima + ')' + bpInPiu };
    }
    bpErroreSecondo.bpRecupero = 'riprova fallita' + (bpErroreSecondo.message === bpErrorePrimo.message ? '' : ' (' + bpErroreSecondo.message + ')') + ', carrello ' + (bpControlloFinale.esito === 'ignoto' ? 'non leggibile' : 'senza la riga');
    throw bpErroreSecondo;
  }

  /* ---- PUT del file nudo su R2 ----------------------------------------
     Non e' la sorella gemella di bpPostConProgresso: quella parla con
     Shopify sulla STESSA origine e usa XMLHttpRequest per avere il
     progresso, questa parla con R2 in cross-origin e usa fetch. La
     differenza non e' estetica, e' l'unica cosa che fa funzionare il
     caricamento.

     PERCHE' fetch E NON XMLHttpRequest. Verificato dal vivo nella
     console del browser, a parita' di URL firmato, file, peso e
     Content-Type: fetch con quel Blob risponde 200, XMLHttpRequest
     risponde 403 e il browser lo riporta come errore CORS. Su una
     richiesta cross-origin XHR fa aggiungere al browser header che il
     CORS del bucket non ammette (la regola ammette solo content-type e
     content-length), e Cloudflare rifiuta la richiesta vera anche
     quando il preflight e' passato, rispondendo 403 senza intestazioni
     CORS. Con fetch si manda esattamente cio' che si scrive e non un
     byte di piu'.

     Da qui la regola: NESSUN header oltre a Content-Type. Nemmeno
     Accept, che sarebbe innocuo ovunque e qui sarebbe l'header di
     troppo che rimette il 403.

     Le altre due regole restano quelle di sempre:
     1. il corpo e' il File NUDO, mai un FormData: l'URL firmato
        vincola content-length, e il multipart aggiungerebbe boundary e
        intestazioni che cambiano il peso;
     2. il Content-Type e' identico a quello dichiarato alla porta,
        perche' e' firmato anche lui: un carattere diverso e la firma
        non combacia.

     IL TIMEOUT si fa con AbortController, perche' fetch da solo non
     scade mai: una connessione che muore a meta' lascerebbe la foto in
     caricamento per sempre, senza Riprova e senza errore. Il timer si
     pulisce SEMPRE nel finally, riuscita o no: un setTimeout vivo su
     una richiesta gia' finita terrebbe sveglia la pagina per un minuto
     buono per niente.

     NIENTE progresso, e non e' una rinuncia: questo caricamento gira
     in sottofondo mentre il cliente compila sfondo e dettagli, non
     c'e' nessuna attesa da raccontare, e una barra direbbe solo che
     sta succedendo qualcosa che al cliente non riguarda.

     Torna { ok, status } come prima. Niente lettura del corpo: R2 su
     un PUT riuscito risponde vuoto e non c'e' niente da leggere. */
  /* Il timeout del PUT segue il peso: vedi BP_PUT_TIMEOUT_MIN_MS. */
  function bpTimeoutPut(bpByte) {
    const bpServe = Math.round((Number(bpByte) || 0) / BP_PUT_BYTE_AL_SECONDO * 1000);
    return Math.min(BP_PUT_TIMEOUT_MAX_MS, Math.max(BP_PUT_TIMEOUT_MIN_MS, bpServe));
  }

  /* Un guasto di fetch (rete, CORS, file illeggibile...) con due facce
     (22/10/2026): il messaggio AMICO resta quello di sempre, ed e' l'unico
     che il cliente puo' vedere (bpVoce.erroreCaricamento, sotto la foto).
     Il nome e il messaggio VERI dell'eccezione (TypeError, AbortError,
     NotReadableError...) finiscono in bpDettaglio, che legge solo il diario
     per Telegram (bpGiri, mai renderizzato in pagina): "rete non
     raggiungibile" da solo non bastava a distinguere una rete morta da un
     rifiuto del browser, ed era il buco che impediva di capire un guasto
     visto il 22/10 su Instagram iOS (giri falliti in 0,0 secondi, troppo
     svelti per essere rete). */
  function bpErroreRete(bpScaduta, bpOriginale) {
    const bpGuasto = new Error(bpScaduta ? 'richiesta scaduta' : 'rete non raggiungibile');
    if (!bpScaduta) {
      const bpNome = (bpOriginale && bpOriginale.name) || 'Error';
      const bpMsg = (bpOriginale && bpOriginale.message) || '(senza messaggio)';
      bpGuasto.bpDettaglio = bpNome + ': ' + bpMsg;
    }
    return bpGuasto;
  }

  /* LA CHIAMATA A prepara-foto, con timeout (21/10/2026). fetch da solo non
     scade mai. Il timer copre anche la lettura della risposta: l'abort
     interrompe anche il corpo. Torna { status, dati } (dati solo se la
     risposta e' JSON valido), oppure lancia con 'richiesta scaduta' o
     'rete non raggiungibile'. */
  async function bpChiediPorta(bpContentType, bpContentLength) {
    const bpControllore = new AbortController();
    let bpScaduta = false;
    const bpTimer = setTimeout(function () {
      bpScaduta = true;
      bpControllore.abort();
    }, BP_PREPARA_TIMEOUT_MS);
    try {
      const bpRisposta = await fetch(BP_URL_PREPARA_FOTO, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ contentType: bpContentType, contentLength: bpContentLength }),
        signal: bpControllore.signal,
      });
      let bpDati = null;
      if (bpRisposta.ok) bpDati = await bpRisposta.json();
      return { status: bpRisposta.status, dati: bpDati };
    } catch (bpErrore) {
      throw bpErroreRete(bpScaduta, bpErrore);
    } finally {
      clearTimeout(bpTimer);
    }
  }

  /* bpFile e' un File/Blob (ripiego) o un ArrayBuffer gia' catturato
     (22/10/2026, vedi bpCatturaByte): l'uno ha .size, l'altro .byteLength,
     bpTimeoutPut vuole un numero solo. */
  function bpPesoCorpo(bpFile) {
    if (!bpFile) return 0;
    if (typeof bpFile.size === 'number') return bpFile.size;
    if (typeof bpFile.byteLength === 'number') return bpFile.byteLength;
    return 0;
  }

  async function bpPutBlob(bpUrl, bpFile, bpContentType) {
    const bpControllore = new AbortController();
    /* Distingue le due cause di abort: il nostro timer, oppure
       qualunque altro guasto di rete. Senza questa bandierina un
       timeout si racconterebbe come rete caduta, e chi legge il
       messaggio cercherebbe nel posto sbagliato. */
    let bpScaduta = false;
    const bpTimer = setTimeout(function () {
      bpScaduta = true;
      bpControllore.abort();
    }, bpTimeoutPut(bpPesoCorpo(bpFile)));

    try {
      const bpRisposta = await fetch(bpUrl, {
        method: 'PUT',
        headers: { 'Content-Type': bpContentType },
        body: bpFile,
        signal: bpControllore.signal,
      });
      return { ok: bpRisposta.ok, status: bpRisposta.status };
    } catch (bpErrore) {
      /* Stessi messaggi della sorella, cosi' bpCaricaFoto non deve
         sapere quale trasporto ha fallito. */
      throw bpErroreRete(bpScaduta, bpErrore);
    } finally {
      clearTimeout(bpTimer);
    }
  }

  /* Pausa fra due tentativi di caricamento. */
  function bpAspetta(bpMs) {
    return new Promise(function (bpRisolvi) { setTimeout(bpRisolvi, bpMs); });
  }

  /* 10012 -> "10.0s", per il diario dei tentativi negli avvisi. */
  function bpFormatoDurata(bpMs) {
    return (Math.round(bpMs / 100) / 10).toFixed(1) + 's';
  }

  /* ---- Gli indirizzi di lettura dei gettoni salvati -------------------
     UNA chiamata sola con tutti i gettoni: la porta ne regge otto, che e'
     anche il massimo di foto del modulo, e otto chiamate separate
     sarebbero otto giri di rete per una schermata sola.

     Torna una mappa gettone verso indirizzo. I gettoni che la porta
     scarta (fuori forma) semplicemente non compaiono nella mappa, ed e'
     il chiamante a decidere cosa farne.

     LANCIA se la porta non risponde o risponde storto: chi chiama lo
     tratta come un guasto di rete, cioe' tiene le voci col segnaposto.
     La porta non dice mai se un gettone esiste davvero su R2: quello si
     scopre solo scaricando. */
  async function bpChiediIndirizziFoto(bpGettoni) {
    const bpControllore = new AbortController();
    let bpScaduta = false;
    const bpTimer = setTimeout(function () {
      bpScaduta = true;
      bpControllore.abort();
    }, BP_RILEGGI_TIMEOUT_MS);

    try {
      const bpRisposta = await fetch(BP_URL_RILEGGI_FOTO, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ gettoni: bpGettoni }),
        signal: bpControllore.signal,
      });
      if (!bpRisposta.ok) {
        throw new Error('la porta ha risposto ' + bpRisposta.status);
      }
      const bpDati = await bpRisposta.json();
      const bpElenco = (bpDati && Array.isArray(bpDati.foto)) ? bpDati.foto : [];
      const bpMappa = {};
      bpElenco.forEach(function (bpVoce) {
        if (bpVoce && typeof bpVoce.gettone === 'string' && typeof bpVoce.url === 'string') {
          bpMappa[bpVoce.gettone] = bpVoce.url;
        }
      });
      return bpMappa;
    } catch (bpErrore) {
      if (bpScaduta) throw new Error('richiesta scaduta');
      throw new Error((bpErrore && bpErrore.message) ? bpErrore.message : 'rete non raggiungibile');
    } finally {
      clearTimeout(bpTimer);
    }
  }

  /* ---- I byte di una foto gia' su R2 ----------------------------------
     Scarica dall'indirizzo firmato e torna il Blob. Nessun header
     aggiunto, per la stessa ragione del PUT qui sopra: la firma viaggia
     nell'indirizzo, e un header di troppo su una richiesta cross-origin
     si prende un 403 dal bucket.

     DUE GUASTI DIVERSI, e la differenza decide il destino della voce:
     - "sparita": risposta 403 o 404. Su R2 quel file non c'e' piu' (la
       scopa notturna, un PUT mai arrivato). Il gettone e' morto, e un
       ordine che lo portasse si fermerebbe in assistenza;
     - "rete": tutto il resto, timeout compreso. Il file con ogni
       probabilita' c'e' ancora, e' il viaggio che non e' riuscito.
     Chi chiama ritenta solo il secondo. */
  async function bpScaricaFotoSalvata(bpUrl) {
    const bpControllore = new AbortController();
    let bpScaduta = false;
    const bpTimer = setTimeout(function () {
      bpScaduta = true;
      bpControllore.abort();
    }, BP_SCARICO_TIMEOUT_MS);

    try {
      const bpRisposta = await fetch(bpUrl, { signal: bpControllore.signal });
      if (bpRisposta.status === 403 || bpRisposta.status === 404) {
        const bpMorta = new Error('la foto non e piu disponibile (' + bpRisposta.status + ')');
        bpMorta.bpCausa = 'sparita';
        throw bpMorta;
      }
      if (!bpRisposta.ok) {
        const bpRifiutata = new Error('scarico rifiutato (' + bpRisposta.status + ')');
        bpRifiutata.bpCausa = 'rete';
        throw bpRifiutata;
      }
      return await bpRisposta.blob();
    } catch (bpErrore) {
      /* Un guasto gia' classificato passa com'e': riclassificarlo qui
         trasformerebbe un file sparito in un problema di rete, e la
         voce resterebbe nel modulo con un gettone morto. */
      if (bpErrore && bpErrore.bpCausa) throw bpErrore;
      const bpGuasto = new Error(bpScaduta ? 'richiesta scaduta' : 'rete non raggiungibile');
      bpGuasto.bpCausa = 'rete';
      throw bpGuasto;
    } finally {
      clearTimeout(bpTimer);
    }
  }

  /* ---- MEMORIA DI SESSIONE -----------------------------------------
     Il cliente compila il modulo, aggiunge al carrello, va a vedere il
     drawer, magari apre un altro prodotto e torna indietro. Fino a oggi
     quel ritorno era una pagina bianca: verificato dal vivo, questo sito
     NON va in bfcache (l'heap del JavaScript muore a ogni navigazione),
     quindi quello che tornava era solo il ripristino dei campi form del
     browser, che su una ricarica vera non c'e' nemmeno. Qui si rimette
     in piedi lo stesso stato a mano.

     SOLO sessionStorage, MAI localStorage. Nei dettagli per gli artisti
     il cliente scrive nomi di persone, ricorrenze, a volte cose molto
     private. Quel testo deve morire quando si chiude la scheda, e
     sessionStorage e' esattamente quello: una casa che si svuota da
     sola. localStorage resterebbe sul disco a tempo indeterminato.

     DELLE FOTO SI SALVA IL GETTONE, MAI I BYTE. I byte non ci
     starebbero comunque (otto foto convertite fanno ~16 MB contro i ~5
     del tetto di sessionStorage) e l'unico posto che li reggerebbe,
     IndexedDB, non si svuota da solo: sarebbero foto di famiglie
     lasciate sul disco. Si salvano invece quattro dati per foto, tutti
     innocui da soli: il gettone, il nome del file, il tipo e il peso.
     Il gettone non apre niente per conto suo, serve un indirizzo
     firmato dal server; nome, tipo e peso non sono un di piu', sono
     quello che serve a ricostruire un File identico quando i byte
     tornano indietro, e il nome e' anche cio' che il cliente legge
     sotto la foto.

     FINO A IERI IL GETTONE NON SI SALVAVA, ed era giusto: non esisteva
     nessun modo di trasformarlo in un'anteprima, quindi il cliente si
     sarebbe ritrovato "tre foto pronte" senza vederne nessuna. Adesso
     quel modo esiste (la porta rileggi-foto piu' lo scarico dei byte),
     e le miniature tornano davvero.

     RESTA IL PREZZO, ed e' accettato: se il cliente aggiunge al
     carrello, torna indietro e aggiunge di nuovo, due ordini diversi
     portano lo stesso file su R2. Non si rompe niente e nessuno dei due
     ordini ci perde.

     SI SALVANO I VALORI DELLE OPZIONI, mai l'id della variante. Un id
     e' una scorciatoia che smette di funzionare in silenzio quando il
     catalogo cambia: resusciterebbe un prezzo che non esiste piu'. I
     valori invece ripassano sempre da bpFindVariant, come una scelta
     fatta a mano in quel momento.

     LA MEMORIA NON CORREGGE MAI, RIEMPIE SOLO. Se in pagina una scelta
     c'e' gia', la memoria non la tocca. E' una regola sola e risolve da
     sé tutti i casi in cui qualcuno ha gia' deciso prima di lei: il
     link con ?variant= (che il Liquid preseleziona e che deve vincere,
     e' una scelta arrivata dalle ads), l'opzione con un valore solo, e
     il ritorno indietro del browser, dove i campi sono gia' ripristinati
     e riscriverli sarebbe lavoro inutile.

     LA MEMORIA E' UNA FOTOCOPIA DELLO STATO VIVO, non un archivio di
     cio' che c'era prima: si riscrive dopo ogni interazione e dopo ogni
     add riuscito, quindi fotografa anche lo svuotamento delle foto e lo
     spegnimento del saltacoda. Al ritorno dal checkout non resuscita
     niente che il modulo avesse gia' buttato.

     NON DEVE MAI ARRIVARE AL BOTTONE. In navigazione privata e a quota
     piena sessionStorage lancia. Ogni lettura e ogni scrittura stanno
     dentro un try/catch che ingoia tutto: peggio di una memoria persa
     c'e' solo un configuratore rotto per colpa di una comodita'. */
  const BP_MEMORIA_PREFISSO = 'bpCfg:';

  /* La forma di cio' che si salva. Se un domani cambia, questo numero
     cambia con lei e le memorie vecchie vengono buttate invece di
     essere lette male: una chiave in piu' o in meno letta a caso
     rimetterebbe in pagina una scelta che non e' mai stata fatta.
     VERSIONE 2: si e' aggiunto l'elenco delle foto (gettone, nome, tipo,
     peso). Le memorie di versione 1 non lo hanno e vengono buttate, che
     e' esattamente cio' che si vuole: meglio ripartire senza foto che
     leggere a caso una forma che non conosciamo. */
  const BP_MEMORIA_VERSIONE = 2;

  /* Ventiquattro ore, controllate anche dentro la stessa scheda.
     sessionStorage di suo muore solo con la scheda, e una scheda lasciata
     aperta tre giorni rimetterebbe in pagina le scelte di martedi'. */
  const BP_MEMORIA_VITA_MS = 24 * 60 * 60 * 1000;

  function bpMemoriaCancella(bpChiave) {
    try {
      window.sessionStorage.removeItem(bpChiave);
    } catch (bpErrore) {
      /* niente: una memoria che non si cancella e' un fastidio, non un
         guasto, e scade comunque da sola */
    }
  }

  /* Torna l'oggetto salvato, oppure null. Null e' anche la risposta per
     una memoria scaduta, di un'altra versione, illeggibile o proibita:
     chi chiama non deve mai distinguere i casi, per lui "non c'e'" e
     "non si puo' leggere" chiedono la stessa cosa, cioe' lasciare la
     pagina com'e'. */
  function bpMemoriaLeggi(bpChiave) {
    try {
      const bpGrezzo = window.sessionStorage.getItem(bpChiave);
      if (!bpGrezzo) return null;
      const bpDati = JSON.parse(bpGrezzo);
      if (!bpDati || typeof bpDati !== 'object') {
        bpMemoriaCancella(bpChiave);
        return null;
      }
      if (bpDati.v !== BP_MEMORIA_VERSIONE) {
        bpMemoriaCancella(bpChiave);
        return null;
      }
      if (typeof bpDati.t !== 'number' || (Date.now() - bpDati.t) > BP_MEMORIA_VITA_MS) {
        bpMemoriaCancella(bpChiave);
        return null;
      }
      return bpDati;
    } catch (bpErrore) {
      /* JSON storto, storage proibito: si fa finta che non ci sia
         niente. Nessun console.warn: questo giro capita a ogni
         apertura di pagina in incognito e non e' una notizia. */
      return null;
    }
  }

  function bpMemoriaScrivi(bpChiave, bpDati) {
    try {
      bpDati.v = BP_MEMORIA_VERSIONE;
      bpDati.t = Date.now();
      window.sessionStorage.setItem(bpChiave, JSON.stringify(bpDati));
    } catch (bpErrore) {
      /* Incognito, quota piena, storage disattivato dall'utente: la
         memoria semplicemente non esiste e il modulo continua a
         funzionare come il giorno prima che esistesse. */
    }
  }

  class BPConfiguratore extends HTMLElement {
    connectedCallback() {
      this.bpProduct = this.bpReadProductData();
      this.bpPriceEl = this.querySelector('[data-bp-price]');
      this.bpUnavailableEl = this.querySelector('[data-bp-unavailable]');
      this.bpAtcEl = this.querySelector('[data-bp-atc]');
      this.bpErrorEl = this.querySelector('[data-bp-error]');
      this.bpCurrentVariant = null;
      this.bpBusy = false;
      this.bpSfondoNome = null;
      this.bpDettagli = '';
      /* Vero appena dopo un add-to-cart riuscito, finche' qualcosa non
         rende il ritratto diverso da quello appena ordinato (foto
         aggiunte o tolte, cambio di opzione, dettagli, sfondo, nome,
         saltacoda): accende l'avviso "gia' nel carrello" sotto il
         bottone. NON entra MAI in bpMemoriaSalva ne' in
         bpMemoriaRipristina: nasce sempre falso a ogni caricamento
         della pagina, anche tornando da un ricaricamento con la
         memoria piena, perche' "questo ritratto e' gia' nel carrello"
         e' vero solo nel momento in cui e' appena successo, non dopo
         un giro di pagina. */
      this.bpUltimoOrdineAggiunto = false;
      /* Passo 4: quale delle due schede e' scelta ('fatevoi', 'scrivo', o
         stringa vuota = nessuna, lo stato iniziale). bpDettagliMemoria
         tiene da parte il testo gia' scritto quando il cliente passa a
         "Fate voi": tornando su "Scrivo io" lo ritrova dov'era. */
      this.bpDettagliModo = '';
      this.bpDettagliMemoria = '';
      /* La tappa 'manifesto' non nasce mai completata da sola: e' una
         checkbox, e lasciarla spenta e' una scelta legittima quanto
         accenderla, quindi l'unico modo di sapere che il cliente ci e'
         passato e' registrare il tocco.
         LE TAPPE 'variante' NON HANNO PIU' BISOGNO DI NIENTE DEL GENERE.
         Prima serviva un registro dei tocchi perche' Shopify
         preselezionava sempre una variante e la tappa sarebbe nata
         completata da sola. Ora i selettori nascono vuoti: una scelta
         che c'e' E' la prova che il cliente l'ha fatta, e vale anche al
         ritorno indietro del browser, dove un registro in memoria
         sarebbe ripartito vuoto mentre il radio era gia' ripristinato.
         La tappa 'taglia' resta com'era: e' facoltativa, il bottone non
         la richiede mai, e pretendere un'interazione la terrebbe su
         "sei qui" anche quando il cliente la salta a ragione. */
      this.bpManifestoToccato = false;
      this.bpSaltacoda = false;
      this.bpSfondoDescr = '';
      this.bpWantedNome = '';
      this.bpWantedTaglia = '';
      /* Ogni voce è { originale, file, stato, esito }, non un File nudo:
         "file" è quello che va nel multipart e durante la conversione
         punta ancora all'originale, così premere il bottone in quel
         momento carica comunque qualcosa di valido. */
      this.bpFotoFiles = [];
      /* Anteprime delle HEIC: coda, una alla volta, un worker solo. */
      this.bpCodaAnteprime = [];
      this.bpAnteprimaOccupata = false;
      this.bpHeicWorker = null;
      this.bpHeicWorkerUrl = null;
      this.bpFotoUrls = [];
      this.bpFotoMsgIsOverflow = false;
      /* Le conversioni girano UNA ALLA VOLTA, incatenate a questa
         promessa: otto foto insieme non devono aprire otto canvas. Il
         bottone la aspetta prima di costruire il multipart. */
      this.bpCodaConversione = Promise.resolve();
      /* Il caricamento su R2 ha una coda SUA, separata e indipendente
         da quella della conversione: la' si aspetta la CPU e si va in
         fila, qui si aspetta la rete e si va in due. Sono due file di
         attesa diverse perche' misurano cose diverse. La coda e' un
         semplice elenco di voci in attesa piu' un contatore di quelle
         in volo: aggiungere foto mentre e' in corso la allunga senza
         disturbare i caricamenti gia' partiti. */
      this.bpCodaCaricamento = [];
      this.bpCaricamentiAttivi = 0;

      this.bpFotoGridEl = this.querySelector('[data-bp-foto-grid]');
      this.bpFotoInputEl = this.querySelector('[data-bp-foto-input]');
      this.bpFotoAddEl = this.querySelector('[data-bp-foto-add]');
      this.bpFotoCounterEl = this.querySelector('[data-bp-foto-counter]');
      this.bpFotoMsgEl = this.querySelector('[data-bp-foto-msg]');
      /* Le due righe di errore sotto i campi obbligatori. NON sono
         bpFotoMsgEl: quello e' il canale degli avvisi di caricamento
         e se ne scrivono gia' quattro diversi, che si sovrascrivono
         fra loro. Questi due sono nostri e nessun altro li tocca. */
      this.bpErroreNomeEl = this.querySelector('[data-bp-errore-nome]');
      this.bpErroreFotoEl = this.querySelector('[data-bp-errore-foto]');
      /* Passo 4: il contenitore delle due schede (quello che si segna in
         rosso se il cliente non sceglie) e la sua riga di errore, gemelli
         di bpFotoAddEl e bpErroreFotoEl. */
      this.bpDettagliSchedeEl = this.querySelector('[data-bp-dettagli-schede]');
      this.bpErroreDettagliEl = this.querySelector('[data-bp-errore-dettagli]');
      this.bpFotoProgressoEl = this.querySelector('[data-bp-foto-progresso]');
      this.bpFotoProgressoRiempiEl = this.querySelector('[data-bp-foto-progresso-riempi]');
      this.bpFotoProgressoTestoEl = this.querySelector('[data-bp-foto-progresso-testo]');
      this.bpAtcHintEl = this.querySelector('[data-bp-atc-hint]');
      /* Riquadro totale sopra il bottone: assente se spento nell'editor,
         e allora bpAggiornaTotale esce subito. */
      this.bpTotaleEl = this.querySelector('[data-bp-totale]');

      if (!this.bpProduct || !this.bpPriceEl) {
        /* Il configuratore non parte: il cliente non vede il modulo. Avviso
           diretto, senza lo stato (che senza dati prodotto non si legge). */
        try {
          if (typeof window.bpCanaleAvvisi === 'function') {
            window.bpCanaleAvvisi('configuratore non parte', [
              '[bp-configuratore] Aggiunta al carrello fallita: configuratore non parte | dati prodotto ' + (this.bpProduct ? 'ok' : 'NON leggibili')
              + ' | prezzo ' + (this.bpPriceEl ? 'ok' : 'MANCANTE') + ' | browser=' + (navigator.userAgent || '?') + ' | url=' + window.location.href,
            ], { file: 'bp-configuratore.js' });
          } else {
            bpSegnalaSentinella('configuratore non parte (dati prodotto ' + (this.bpProduct ? 'ok' : 'NON leggibili') + ')');
          }
        } catch (bpErrore) { /* niente da fare */ }
        return;
      }

      this.bpMoney = this.bpCreateMoneyFormatter();
      /* PRIMA DI TUTTO IL RESTO: i formati nascosti escono dall'elenco delle
         varianti prima che la memoria, le preselezioni o un calcolo qualunque
         possano vederli. */
      this.bpApplicaFormatiNascosti();
      /* I tre gestori veri restano quelli di sempre; bpConMemoria ci
         mette intorno il salvataggio. Avvolgerli qui, invece di
         chiamare bpMemoriaSalva dentro i gestori, serve a una cosa
         precisa: quei gestori sono pieni di return anticipati, e ogni
         ramo che esce prima si porterebbe via il salvataggio. Cosi' non
         c'e' nessun ramo da ricordarsi. */
      this.bpBoundOnChange = this.bpConMemoria(this.bpOnChange);
      this.addEventListener('change', this.bpBoundOnChange);
      this.bpBoundOnClick = this.bpConMemoria(this.bpOnClick);
      this.addEventListener('click', this.bpBoundOnClick);
      this.bpBoundOnInput = this.bpConMemoria(this.bpOnInput);
      this.addEventListener('input', this.bpBoundOnInput);

      /* LA MEMORIA DI SESSIONE VA RIMESSA QUI, PRIMA della rilettura
         del DOM qui sotto, e l'ordine non e' casuale: il ripristino
         scrive SOLO nei campi della pagina, non nello stato interno, e
         subito dopo la rilettura li raccoglie e riallinea lo stato da
         sola. Un solo posto che traduce pagina in stato, come prima.
         Le varianti sono le prime a tornare, dentro bpMemoriaRipristina:
         il limite delle foto si calcola dalle opzioni scelte, e un
         ordine diverso lo calcolerebbe sul modulo ancora vuoto. */
      /* OGNI PASSO DELL'AVVIO E' ISOLATO (14/10/2026, caso Android
         Instagram). Prima un errore in uno qualsiasi dei passi qui sotto
         interrompeva tutto l'avvio, e bpUpdate in fondo non girava piu': le
         scelte in pagina c'erano (memoria, preselezione) ma la variante del
         modulo restava vuota, e al clic "combinazione inesistente". Ora un
         passo che cade si segnala al Capitano e l'avvio continua; bpUpdate
         gira sempre. */
      const bpModuloAvvio = this;
      const bpPasso = function (bpNome, bpFunzione) {
        try {
          bpFunzione.call(bpModuloAvvio);
        } catch (bpErrore) {
          console.warn('[bp-configuratore] Avvio, passo "' + bpNome + '" fallito:', bpErrore);
          bpErroreJsConfiguratore('avvio, passo ' + bpNome + ': ' + ((bpErrore && bpErrore.message) || String(bpErrore)), 'avvio del modulo, continuato');
        }
      };

      this.bpAvvioInCorso = true;
      bpPasso('memoria', function () { this.bpMemoriaRipristina(); });
      /* Subito DOPO la memoria e prima della rilettura: il numero
         preselezionato riempie solo cio' che nessuno ha ancora deciso. */
      bpPasso('numero preselezionato', function () { this.bpPreselezionaNumero(); });
      /* Dopo il numero, perche' la disponibilita' del formato si controlla
         sulla variante "numero scelto + quel formato". */
      bpPasso('formato preselezionato', function () { this.bpPreselezionaFormato(); });
      /* Per ultimo: se il link o la memoria puntavano a un formato nascosto e
         la preselezione non ha riempito il posto, ci pensa il primo visibile. */
      bpPasso('formato di riserva', function () { this.bpFormatoDiRiserva(); });

      /* Il browser può ripristinare valori già inseriti (es. tornando
         indietro nella cronologia): si rileggono sfondo e dettagli. */
      bpPasso('rilettura dei campi', function () {
        const bpSfondoChecked = this.querySelector('input[data-bp-sfondo-input]:checked');
        if (bpSfondoChecked) this.bpSetSfondo(bpSfondoChecked.value);
        const bpDettagliEl = this.querySelector('[data-bp-dettagli-input]');
        if (bpDettagliEl && bpDettagliEl.value) this.bpSetDettagli(bpDettagliEl.value);
        /* Stessa strada dello sfondo per la scelta del passo 4: il browser
           ripristina da solo il radio spuntato, qui si rilegge per
           riallineare lo stato interno e riaccendere la parte giusta. */
        const bpDettagliModoEl = this.querySelector('input[data-bp-dettagli-modo-input]:checked');
        if (bpDettagliModoEl) this.bpSetDettagliModo(bpDettagliModoEl.value, { bpDaRipristino: true });
        const bpSaltacodaEl = this.querySelector('input[data-bp-saltacoda-input]');
        if (bpSaltacodaEl && bpSaltacodaEl.checked) this.bpSetSaltacoda(true);
        const bpSfondoDescrEl = this.querySelector('[data-bp-sfondo-descr-input]');
        if (bpSfondoDescrEl && bpSfondoDescrEl.value) this.bpSetSfondoDescr(bpSfondoDescrEl.value);
        this.bpToggleSfondoDescr();
        const bpWantedNomeEl = this.querySelector('[data-bp-wanted-nome-input]');
        if (bpWantedNomeEl && bpWantedNomeEl.value) this.bpSetWantedNome(bpWantedNomeEl.value);
        const bpWantedTagliaEl = this.querySelector('[data-bp-wanted-taglia-input]');
        if (bpWantedTagliaEl && bpWantedTagliaEl.value) this.bpSetWantedTaglia(bpWantedTagliaEl.value);
      });
      /* il browser può ripristinare l'interruttore Manifesto acceso */
      bpPasso('manifesto', function () { this.bpToggleWantedFields(); });
      bpPasso('lente', function () { this.bpInitZoom(); });

      /* Riconnessione (es. theme editor): la griglia anteprime nel DOM
         potrebbe essere sporca; si ricostruisce dallo stato. */
      bpPasso('anteprime foto', function () { this.bpRenderFoto(); });
      this.bpAvvioInCorso = false;
      bpPasso('variante', function () { this.bpUpdate(); });

      /* RIALLINEAMENTO TARDIVO: se il browser rimette le scelte DOPO l'avvio
         (ritorno indietro, pagina riaperta dall'app) senza un "change", a
         pagina caricata e a ogni pageshow si controlla che la variante del
         modulo sia quella delle scelte in pagina, e se no si ricalcola. */
      if (!this.bpRiallineaAscoltatore) {
        this.bpRiallineaAscoltatore = function () {
          try { bpModuloAvvio.bpRiallineaSeServe(); } catch (bpErrore) { /* il clic ricalcola comunque */ }
        };
        window.addEventListener('load', this.bpRiallineaAscoltatore);
        window.addEventListener('pageshow', this.bpRiallineaAscoltatore);
      }

      /* SCELTE NON REGISTRATE (02/11/2026, caso Xiaomi sul Manifesto): un
         radio spuntato senza "change" non arriva a bpUpdate, e il cliente
         vedrebbe "scegli il numero" col numero gia' scelto. Non si sa ancora
         chi lo spunta (non e' il ripristino di Chrome nelle prove), quindi il
         modulo controlla da solo: poco dopo l'avvio, quando la scheda torna
         visibile e ogni BP_CONTROLLO_SCELTE_MS finche' e' visibile. */
      if (!this.bpControlloScelteAscoltatore) {
        this.bpControlloScelteAscoltatore = function () {
          if (document.visibilityState === 'hidden') return;
          try { bpModuloAvvio.bpRicalcolaSeServe('scheda tornata visibile'); } catch (bpErrore) { /* il clic ricalcola comunque */ }
        };
        document.addEventListener('visibilitychange', this.bpControlloScelteAscoltatore);
        this.bpControlloScelteTimer = setInterval(function () {
          if (document.visibilityState === 'hidden') return;
          try { bpModuloAvvio.bpRicalcolaSeServe('controllo periodico'); } catch (bpErrore) { /* il clic ricalcola comunque */ }
        }, BP_CONTROLLO_SCELTE_MS);
        setTimeout(function () {
          try { bpModuloAvvio.bpRicalcolaSeServe('fine avvio'); } catch (bpErrore) { /* il clic ricalcola comunque */ }
        }, 1500);
      }
    }

    /* Vero se le scelte in pagina sono complete e diverse dalle ultime viste
       da bpUpdate, che le annota per prima cosa: non puo' esserci un ciclo,
       dopo un bpUpdate qui si torna falso. Una variante che manca davvero
       (ricarica in corso, rete, riga rossa) non conta: quelle scelte bpUpdate
       le ha viste e il messaggio l'ha gia' dato. */
    bpScelteNonRegistrate() {
      if (this.bpScelteViste === undefined || this.bpAvvioInCorso) return false;
      const bpScelte = this.bpLeggiScelte();
      if (bpScelte.indexOf(null) !== -1) return false;
      return JSON.stringify(bpScelte) !== this.bpScelteViste;
    }

    /* Registra le scelte passando da bpUpdate (variante, prezzi, totale,
       ricarica e messaggi) e lo dice al Capitano. Mai a modulo occupato:
       durante un'aggiunta ci riprova il controllo successivo. Torna vero se
       ha ricalcolato. */
    bpRicalcolaSeServe(bpDove) {
      if (!this.bpProduct || !this.isConnected || this.bpBusy || this.bpRisoluzioneInCorso) return false;
      if (!this.bpScelteNonRegistrate()) return false;
      console.warn('[bp-configuratore] Scelte in pagina non registrate dal modulo (' + bpDove + '): ricalcolo.');
      this.bpUpdate();
      this.bpMemoriaSalva();
      /* "Recuperato" solo se la variante c'e'. Se manca, bpUpdate sta
         ricaricando il prodotto: la notifica aspetta l'esito
         (bpRicaricaERidisegna); se la variante non arriva restano gli avvisi
         di quel percorso, rete o variante mancante. */
      if (this.bpCurrentVariant) this.bpAvvisaRicalcolo(bpDove);
      else this.bpRicalcoloInAttesa = bpDove;
      return true;
    }

    /* Notifica normale, una sola per pagina: il cliente non ha perso niente,
       ma serve sapere quanto succede e su quali telefoni. */
    bpAvvisaRicalcolo(bpDove) {
      this.bpRicalcoloInAttesa = null;
      if (this.bpRicalcoloAvvisato) return;
      this.bpRicalcoloAvvisato = true;
      const bpUa = String(navigator.userAgent || '');
      const bpModello = /Android [^;)]*;\s*([^;)]+)/.exec(bpUa) || /(iPhone|iPad)/.exec(bpUa);
      const bpPercorso = (window.location.pathname || '').split('/products/')[1] || '';
      const bpV = this.bpCurrentVariant;
      this.bpAvvisaCapitano(
        'totale ricalcolato',
        'dove=' + bpDove
        + ' | prodotto=' + (bpPercorso.split('/')[0] || '?')
        + ' | scelte=' + this.bpLeggiScelte().join(' / ')
        + ' | variante=' + (bpV ? bpV.id : 'nessuna')
        + ' | telefono=' + (bpModello ? bpModello[1].trim() : 'non indicato')
        + ' | schermo=' + (window.screen ? window.screen.width + 'x' + window.screen.height : '?'),
        { recuperato: true, prefisso: 'Scelta registrata in ritardo' }
      );
    }

    bpRiallineaSeServe() {
      if (!this.bpProduct || !this.isConnected) return;
      if (this.bpRicalcolaSeServe('pagina caricata o riaperta')) return;
      const bpScelte = this.bpLeggiScelte();
      const bpCompleta = bpScelte.indexOf(null) === -1;
      const bpCoerente = bpCompleta
        ? !!this.bpCurrentVariant && this.bpFindVariant(bpScelte) === this.bpCurrentVariant
        : !this.bpCurrentVariant;
      if (!bpCoerente) {
        console.warn('[bp-configuratore] Scelte in pagina e variante del modulo non coincidevano: ricalcolo.');
        this.bpUpdate();
      }
    }

    disconnectedCallback() {
      /* Un worker delle anteprime HEIC non deve sopravvivere al modulo. */
      if (typeof this.bpChiudiWorkerHeic === 'function') this.bpChiudiWorkerHeic();
      if (this.bpBoundOnChange) {
        this.removeEventListener('change', this.bpBoundOnChange);
      }
      if (this.bpBoundOnClick) {
        this.removeEventListener('click', this.bpBoundOnClick);
      }
      if (this.bpBoundOnInput) {
        this.removeEventListener('input', this.bpBoundOnInput);
      }
      /* Il riallineamento tardivo ascolta la finestra, che sopravvive al blocco. */
      if (this.bpRiallineaAscoltatore) {
        window.removeEventListener('load', this.bpRiallineaAscoltatore);
        window.removeEventListener('pageshow', this.bpRiallineaAscoltatore);
        this.bpRiallineaAscoltatore = null;
      }
      if (this.bpControlloScelteAscoltatore) {
        document.removeEventListener('visibilitychange', this.bpControlloScelteAscoltatore);
        clearInterval(this.bpControlloScelteTimer);
        this.bpControlloScelteAscoltatore = null;
      }
      /* niente objectURL orfani in memoria */
      if (this.bpFotoUrls) {
        this.bpFotoUrls.forEach(function (bpUrl) { URL.revokeObjectURL(bpUrl); });
        this.bpFotoUrls = [];
      }
      /* Lo zoom mette il suo ascoltatore sul DOCUMENTO, che sopravvive al
         blocco: se il theme editor lo stacca a riquadro aperto, senza
         questa riga l'Esc continuerebbe a parlare a un modulo morto. */
      if (this.bpBoundZoomTasto) {
        document.removeEventListener('keydown', this.bpBoundZoomTasto);
      }
      /* Stessa ragione per il blocco dello scorrimento: e' sul documento,
         e un blocco staccato a riquadro aperto lascerebbe la pagina
         ferma per sempre. */
      if (this.bpZoomEl && !this.bpZoomEl.hidden) {
        document.documentElement.classList.remove('bp-cfg-zoom-aperto');
      }
    }

    /* --- zoom immagine delle schede -------------------------------------- */

    /* Tutto lo zoom vive qui dentro: non tocca prezzo, varianti, foto ne'
       carrello. L'unico punto di contatto col resto del modulo e' che i
       bottoni lente stanno DENTRO la label della scheda, quindi ogni loro
       click va fermato prima che il browser lo giri al radio del formato. */
    bpInitZoom() {
      this.bpZoomEl = this.querySelector('[data-bp-zoom]');
      if (!this.bpZoomEl) return;
      this.bpZoomImgEl = this.bpZoomEl.querySelector('[data-bp-zoom-img]');
      this.bpZoomChiudiEl = this.bpZoomEl.querySelector('[data-bp-zoom-chiudi]');
      /* I tre pezzi facoltativi: una pagina col Liquid vecchio non li ha,
         e allora il riquadro fa quello che faceva prima. */
      this.bpZoomDescrEl = this.bpZoomEl.querySelector('[data-bp-zoom-descr]');
      this.bpZoomSubitoEl = this.bpZoomEl.querySelector('[data-bp-zoom-subito]');
      this.bpZoomScegliEl = this.bpZoomEl.querySelector('[data-bp-zoom-scelgo]');
      this.bpZoomSceglie = null;
      /* Conta le aperture. Serve a una cosa sola ma importante: quando
         l'immagine grande arriva, si controlla che sia ancora quella
         chiesta. Su una rete lenta il cliente fa in tempo a chiudere e ad
         aprire un altro sfondo, e senza questo numero la vecchia
         comparirebbe sopra la nuova. */
      this.bpZoomGiro = 0;
      if (!this.bpZoomImgEl || !this.bpZoomChiudiEl) return;

      this.bpZoomTornaA = null;
      this.bpBoundZoomTasto = this.bpZoomTasto.bind(this);
      const bpModulo = this;

      this.querySelectorAll('[data-bp-zoom-apri]').forEach(function (bpBottone) {
        bpBottone.addEventListener('click', function (bpEvento) {
          /* Le due righe che tengono separata la lente dalla scelta del
             formato: preventDefault toglie alla label la sua attivazione,
             stopPropagation impedisce al click di arrivare al gestore
             generale del modulo. Servono per le lenti delle SCHEDE, che
             stanno dentro l'etichetta; quella degli sfondi sta fuori e
             non ne avrebbe bisogno, ma tenerle non costa niente. */
          bpEvento.preventDefault();
          bpEvento.stopPropagation();
          /* Il vicinato della lente: la cella per uno sfondo,
             l'etichetta per una scheda del formato. Da li' si prendono
             due cose che il bottone non ha bisogno di ripetere negli
             attributi: la MINIATURA gia' in pagina, che si mostra
             all'istante, e il pulsante di scelta, che serve al bottone
             "Scelgo questo". Una scheda del formato non ha nessun
             pulsante di sfondo, quindi li' quel bottone non comparira'. */
          const bpVicino = bpBottone.closest('.bp-configuratore__sfondo-cella, label');
          const bpMiniatura = bpVicino ? bpVicino.querySelector('img') : null;
          bpModulo.bpZoomApri({
            subito: bpMiniatura ? (bpMiniatura.currentSrc || bpMiniatura.src || '') : '',
            src: bpBottone.getAttribute('data-bp-zoom-src') || '',
            srcset: bpBottone.getAttribute('data-bp-zoom-srcset') || '',
            sizes: bpBottone.getAttribute('data-bp-zoom-sizes') || '',
            alt: bpBottone.getAttribute('data-bp-zoom-alt') || '',
            descr: bpBottone.getAttribute('data-bp-zoom-descr') || '',
            tornaA: bpBottone,
            sceglie: bpVicino ? bpVicino.querySelector('input[data-bp-sfondo-input]') : null,
          });
        });
      });

      /* "Scelgo questo": sceglie lo sfondo dell'anteprima aperta e chiude.
         La scelta si fa con un click sul pulsante vero, non scrivendo
         checked a mano: cosi' passa dalla strada di sempre (l'evento
         change, bpSetSfondo, la rotta, la memoria) e non ci sono due
         modi diversi di scegliere uno sfondo da tenere allineati.
         Se quello sfondo e' gia' scelto non si clicca niente: un click su
         un radio gia' spuntato non farebbe scattare nessun cambiamento,
         ma tanto vale dirlo qui. */
      if (this.bpZoomScegliEl) {
        this.bpZoomScegliEl.addEventListener('click', function (bpEvento) {
          bpEvento.preventDefault();
          bpEvento.stopPropagation();
          const bpRadio = bpModulo.bpZoomSceglie;
          if (bpRadio && !bpRadio.checked) bpRadio.click();
          bpModulo.bpZoomChiudi();
        });
      }

      this.bpZoomChiudiEl.addEventListener('click', function (bpEvento) {
        bpEvento.preventDefault();
        bpEvento.stopPropagation();
        bpModulo.bpZoomChiudi();
      });

      /* Chiude ogni tocco FUORI DALL'IMMAGINE: il fondo scuro, la riga
         di descrizione, il margine del riquadro. Il confronto NON e' con
         una singola immagine ma con la tela che le contiene: le immagini
         sono due, la miniatura e la grande, e quella che il dito tocca
         cambia a seconda di quale e' arrivata. Confrontando con la sola
         grande, un tocco sulla miniatura chiudeva l'anteprima appena
         aperta. La X e "Scelgo questo" hanno i loro ascoltatori, che
         fermano la propagazione. */
      this.bpZoomEl.addEventListener('click', function (bpEvento) {
        if (!bpEvento.target.closest('.bp-configuratore__zoom-tela')) bpModulo.bpZoomChiudi();
      });
    }

    /* Lo stesso riquadro serve due usi: la lente delle schede del formato
       e l'anteprima degli sfondi. La descrizione e' facoltativa: vuota,
       la riga sotto l'immagine sparisce e il riquadro e' quello di sempre.
       Se il riquadro non esiste (bpInitZoom e' uscito senza aggancio) non
       si apre niente e non si lancia niente: e' solo da guardare, e la
       sua assenza non deve toccare la scelta.
       PRIMA LA MINIATURA, POI LA GRANDE, ed e' la correzione della
       lentezza: non si aspetta piu' niente dalla rete per far vedere
       qualcosa. La miniatura e' gia' scaricata e disegnata in pagina,
       quindi compare col riquadro; la grande parte adesso, e quando
       arriva si sovrappone. Il browser sceglie da solo quale misura
       scaricare (srcset), invece dei 1400 px fissi di prima. */
    bpZoomApri(bpDati) {
      if (!bpDati || !this.bpZoomEl || !this.bpBoundZoomTasto) return;
      const bpSubito = bpDati.subito || '';
      const bpSrc = bpDati.src || '';
      const bpSrcset = bpDati.srcset || '';
      if (!bpSubito && !bpSrc && !bpSrcset) return;

      const bpModulo = this;
      this.bpZoomGiro += 1;
      const bpGiro = this.bpZoomGiro;

      /* La grande riparte da zero a ogni apertura: senza togliere gli
         attributi vecchi resterebbe a schermo l'immagine di prima. */
      this.bpZoomEl.classList.remove('bp-configuratore__zoom--pronta');
      this.bpZoomEl.classList.toggle('bp-configuratore__zoom--senza-subito', bpSubito === '');
      this.bpZoomImgEl.onload = null;
      this.bpZoomImgEl.removeAttribute('srcset');
      this.bpZoomImgEl.removeAttribute('sizes');
      this.bpZoomImgEl.removeAttribute('src');

      const bpMostraGrande = function () {
        /* Arrivata tardi, mentre il cliente guardava gia' un altro
           sfondo: si lascia cadere. */
        if (bpGiro !== bpModulo.bpZoomGiro) return;
        bpModulo.bpZoomEl.classList.add('bp-configuratore__zoom--pronta');
      };
      this.bpZoomImgEl.onload = bpMostraGrande;
      this.bpZoomImgEl.setAttribute('alt', bpDati.alt || '');
      if (bpSrcset) {
        if (bpDati.sizes) this.bpZoomImgEl.setAttribute('sizes', bpDati.sizes);
        this.bpZoomImgEl.setAttribute('srcset', bpSrcset);
      } else if (bpSrc) {
        this.bpZoomImgEl.setAttribute('src', bpSrc);
      }
      /* Gia' in cache: il carico puo' essere finito prima che
         l'ascoltatore ci fosse, e allora l'evento non arriva piu'. */
      if (this.bpZoomImgEl.complete && this.bpZoomImgEl.naturalWidth > 0) bpMostraGrande();

      /* LA MINIATURA SI METTE DOPO, e l'ordine e' voluto: qui sopra parte
         la richiesta di rete, che e' la cosa lunga, e solo dopo si da' al
         browser il lavoro di disegnare la miniatura. Al contrario, il
         disegno della miniatura (decodifica e impaginazione, su un
         telefono lento si sentono) rimandava di un pezzo la partenza
         della richiesta, e l'immagine nitida arrivava piu' tardi. */
      if (this.bpZoomSubitoEl) {
        this.bpZoomSubitoEl.setAttribute('alt', bpDati.alt || '');
        if (bpSubito) this.bpZoomSubitoEl.setAttribute('src', bpSubito);
        else this.bpZoomSubitoEl.removeAttribute('src');
      }

      /* Il bottone che sceglie: solo per gli sfondi, mai per le schede
         del formato, che non hanno niente da scegliere qui. */
      this.bpZoomSceglie = bpDati.sceglie || null;
      if (this.bpZoomScegliEl) this.bpZoomScegliEl.hidden = !this.bpZoomSceglie;

      const bpTesto = (bpDati.descr || '').trim();
      if (this.bpZoomDescrEl) {
        this.bpZoomDescrEl.textContent = bpTesto;
        this.bpZoomDescrEl.hidden = bpTesto === '';
      }
      this.bpZoomEl.classList.toggle('bp-configuratore__zoom--con-descr', bpTesto !== '');
      this.bpZoomEl.hidden = false;
      /* Pagina ferma sotto: finche' il riquadro e' aperto il documento
         non scorre. Si toglie in bpZoomChiudi e, per un blocco staccato
         a riquadro aperto, in disconnectedCallback. */
      document.documentElement.classList.add('bp-cfg-zoom-aperto');
      this.bpZoomTornaA = bpDati.tornaA || null;
      this.bpZoomChiudiEl.focus();
      /* Esc ascoltato sul documento e non sul riquadro: dopo un click sul
         fondo scuro il fuoco puo' non essere piu' dentro il riquadro, e un
         ascoltatore locale non sentirebbe piu' niente. */
      document.addEventListener('keydown', this.bpBoundZoomTasto);
    }

    bpZoomChiudi() {
      if (!this.bpZoomEl || this.bpZoomEl.hidden) return;
      this.bpZoomEl.hidden = true;
      document.documentElement.classList.remove('bp-cfg-zoom-aperto');
      document.removeEventListener('keydown', this.bpBoundZoomTasto);
      /* Nessuna immagine grande in arrivo puo' piu' comparire: alzare il
         contatore rende vecchio qualunque carico ancora per strada. */
      this.bpZoomGiro += 1;
      this.bpZoomSceglie = null;
      /* Il fuoco torna a chi ha aperto: per l'anteprima e' la lente.
         preventScroll perche' la pagina e' rimasta dov'era e non deve
         saltare. */
      if (this.bpZoomTornaA) {
        this.bpZoomTornaA.focus({ preventScroll: true });
        this.bpZoomTornaA = null;
      }
    }

    bpZoomTasto(bpEvento) {
      if (bpEvento.key === 'Escape') this.bpZoomChiudi();
    }

    /* --- setup --------------------------------------------------------- */

    bpReadProductData() {
      const bpScript = this.querySelector('script[data-bp-product]');
      if (!bpScript) return null;
      try {
        const bpData = JSON.parse(bpScript.textContent);
        if (!bpData || !Array.isArray(bpData.variants) || !Array.isArray(bpData.options)) {
          return null;
        }
        return bpData;
      } catch (bpError) {
        console.warn('[bp-configuratore] Dati prodotto non leggibili:', bpError);
        return null;
      }
    }

    /* IL FORMATO DEL PREZZO, e perche' NON si usa style:'currency'.
       Intl con style:'currency' e locale it-IT produce "14,90 €", cioe'
       simbolo DOPO il numero con spazio unificatore in mezzo. Il render
       server di Shopify, con la formattazione valuta impostata su questo
       negozio, scrive invece "€14,90", simbolo PRIMA e senza spazio.
       Finche' i due formati erano diversi, il prezzo in alto lampeggiava
       a ogni caricamento: il server scriveva il suo, poi bpUpdate partiva
       in fase di inizializzazione e bpAggiornaPrezzoTema lo sovrascriveva
       col nostro, e mezzo secondo dopo il cliente vedeva il numero
       cambiare forma sotto gli occhi proprio mentre decideva se comprare.
       Qui si formatta quindi SOLO il numero (separatori e due decimali
       all'italiana, che Intl fa benissimo) e il simbolo si antepone a
       mano, ottenendo una stringa identica a quella del server: la
       riscrittura continua ad avvenire, ma diventa invisibile perche'
       scrive esattamente cio' che c'era gia'.
       Torna un oggetto con lo stesso metodo format(numero) di prima,
       cosi' bpFormatPrice e tutti i chiamanti restano invariati.
       Se un domani il negozio vendesse in un'altra valuta, il simbolo
       va aggiunto alla mappa qui sotto insieme al formato deciso nelle
       impostazioni Shopify: i due devono sempre coincidere. */
    bpCreateMoneyFormatter() {
      const bpCurrency = this.dataset.bpCurrency || 'EUR';
      const BP_SIMBOLI = { EUR: '\u20AC', USD: '$', GBP: '\u00A3' };
      const bpSimbolo = BP_SIMBOLI[bpCurrency] || '\u20AC';

      let bpNumero = null;
      try {
        bpNumero = new Intl.NumberFormat('it-IT', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } catch (bpError) {
        /* Intl indisponibile o locale rifiutato: si formatta a mano,
           che per due decimali e' esattamente lo stesso risultato. */
        bpNumero = null;
      }

      return {
        format: function (bpValore) {
          const bpTesto = bpNumero
            ? bpNumero.format(bpValore)
            : bpValore.toFixed(2).replace('.', ',');
          return bpSimbolo + bpTesto;
        },
      };
    }

    /* --- memoria di sessione -------------------------------------------- */

    /* LA CHIAVE: id del prodotto PIU' id del blocco.
       L'id del prodotto separa i cinque prodotti, ed e' l'unico dato che
       lo fa davvero. Il block.id no: nei template JSON Ritratto, Puzzle e
       Portachiavi hanno tutti e tre la stessa chiave di blocco
       (bp_configuratore_cqeKjF), e dal vivo li separa solo un prefisso
       che Shopify ci mette davanti, opaco e non documentato. L'id del
       prodotto invece e' gia' in pagina, dentro data-bp-product, e non
       cambia mai: ne' rinominando il prodotto, ne' risalvando il tema.
       Il block.id c'e' lo stesso, in coda, per il caso di due
       configuratori dello stesso prodotto nella stessa pagina: oggi non
       capita, ma l'editor permette di duplicare un blocco e due moduli
       che si scrivono addosso sarebbero un guasto difficile da capire.
       Senza uno dei due non si salva niente: meglio nessuna memoria che
       una memoria condivisa fra prodotti diversi. */
    bpMemoriaChiave() {
      const bpProdotto = this.bpProduct && this.bpProduct.id;
      const bpBlocco = this.dataset.blockId;
      if (!bpProdotto || !bpBlocco) return null;
      return BP_MEMORIA_PREFISSO + bpProdotto + ':' + bpBlocco;
    }

    /* Nel theme editor la memoria non esiste, ne' in lettura ne' in
       scrittura. In lettura per la stessa ragione della preselezione:
       chi configura il blocco deve vedere il modulo com'e' fatto, non
       com'era rimasto l'ultima volta che ci ha giocato. In scrittura
       perche' una memoria che nessuno rileggera' mai e' solo spazzatura,
       e perche' una regola sola si sbaglia meno di due. */
    bpMemoriaAttiva() {
      if (window.Shopify && window.Shopify.designMode) return false;
      return this.bpMemoriaChiave() !== null;
    }

    /* Avvolge un gestore di eventi col salvataggio. Il gestore gira
       identico a prima, poi si fotografa lo stato: qualunque cosa abbia
       cambiato, la memoria la vede. */
    bpConMemoria(bpGestore) {
      const bpModulo = this;
      return function (bpEvent) {
        bpGestore.call(bpModulo, bpEvent);
        bpModulo.bpMemoriaSalva();
      };
    }

    /* Le foto da salvare: SOLO quelle che hanno gia' un gettone, cioe'
       quelle arrivate su R2. Una foto ancora in viaggio non si salva:
       al ritorno non avrebbe nessun indirizzo da cui tornare, e una
       voce senza anteprima ne' byte sarebbe solo un posto occupato nel
       conteggio.

       IL NOME viene dall'originale scelto dal cliente (e' quello che
       legge lui, ed e' anche il nome con cui il file viaggia nel
       ripiego), il TIPO e il PESO dal file convertito, che e' quello
       che sta davvero su R2. Una voce gia' ripristinata i suoi tre dati
       ce li ha addosso dalla memoria precedente e li ripropone tali e
       quali, anche quando i byte non sono ancora tornati. */
    bpMemoriaFoto() {
      const bpFuori = [];
      const bpVoci = this.bpFotoFiles || [];
      for (let bpI = 0; bpI < bpVoci.length; bpI += 1) {
        const bpVoce = bpVoci[bpI];
        if (!bpVoce || bpVoce.stato !== 'caricata') continue;
        if (typeof bpVoce.gettone !== 'string' || bpVoce.gettone === '') continue;
        const bpNome = bpVoce.originale ? bpVoce.originale.name : bpVoce.nome;
        if (typeof bpNome !== 'string' || bpNome === '') continue;
        const bpTipo = bpVoce.file ? bpVoce.file.type : bpVoce.tipo;
        const bpPeso = bpVoce.file ? bpVoce.file.size : bpVoce.peso;
        bpFuori.push({
          gettone: bpVoce.gettone,
          nome: bpNome,
          tipo: (typeof bpTipo === 'string') ? bpTipo : '',
          peso: (typeof bpPeso === 'number') ? bpPeso : 0,
        });
      }
      return bpFuori;
    }

    /* La fotocopia dello stato vivo. Niente byte e niente id di
       variante: i valori scelti, i testi scritti, e delle foto i soli
       gettoni con cui ricostruirle.
       La verita' si legge dove sta: le opzioni e i due interruttori
       dalla pagina (e' li' che vivono), il resto dallo stato interno. */
    bpMemoriaSalva() {
      if (!this.bpMemoriaAttiva()) return;
      const bpToggle = this.querySelector('input[data-bp-wanted-toggle]');
      const bpSaltacodaEl = this.querySelector('input[data-bp-saltacoda-input]');
      bpMemoriaScrivi(this.bpMemoriaChiave(), {
        /* bpLeggiScelte torna un null per ogni opzione non ancora
           scelta: si salvano anche quelli, cosi' un modulo compilato a
           meta' torna compilato a meta' e non a caso. */
        opzioni: this.bpLeggiScelte(),
        dettagli: this.bpDettagli,
        dettagliModo: this.bpDettagliModo,
        sfondo: this.bpSfondoNome,
        sfondoDescr: this.bpSfondoDescr,
        wantedNome: this.bpWantedNome,
        wantedTaglia: this.bpWantedTaglia,
        manifesto: !!(bpToggle && bpToggle.checked),
        /* Il tocco dell'interruttore Manifesto e' l'unica cosa salvata
           che non abbia un campo in pagina da cui rileggerla: e' lo
           stato interno che dice alla rotta se quella tappa e' stata
           affrontata. Senza, al ritorno la tappa resterebbe su "sei
           qui" anche per chi l'aveva gia' decisa. */
        manifestoToccato: this.bpManifestoToccato === true,
        saltacoda: !!(bpSaltacodaEl && bpSaltacodaEl.checked),
        foto: this.bpMemoriaFoto(),
      });
    }

    /* Rimette in pagina cio' che era stato salvato. Scrive SOLO nei
       campi, mai nello stato interno (l'unica eccezione e' il tocco
       dell'interruttore Manifesto, che un campo non ce l'ha), e non
       lancia nessun evento: ci pensa la rilettura del DOM in
       connectedCallback, subito dopo, che e' gia' il posto dove la
       pagina diventa stato.
       LE VARIANTI PER PRIME, sempre: il limite delle foto si calcola
       dalle opzioni scelte, e riempirle dopo lo lascerebbe calcolato
       sul modulo vuoto. */
    /* NUMERO PRESELEZIONATO ALL'APERTURA (decisione del Capitano): la
       pagina si apre con "1" gia' scelto, cosi' il prezzo in alto (quello
       di 1 personaggio) corrisponde a una scelta che il cliente vede. Il
       formato no: resta da scegliere.
       Il valore arriva dall'editor (data-bp-numero-preselezionato, "1");
       attributo assente = spento. Si cerca il radio del PRIMO selettore
       il cui valore comincia con quel numero ("1 Personaggio").
       CHI HA GIA' DECISO VINCE, come per la memoria: se un radio del
       numero e' gia' spuntato (memoria di sessione rimessa qui sopra,
       ?variant= preselezionato dal Liquid, ritorno indietro del browser)
       non si tocca niente.
       SOLO IL CAMPO, NESSUN EVENTO: la rilettura e bpUpdate in fondo a
       connectedCallback fanno il resto (eco, rotta, prezzi, etichetta,
       Totale) esattamente come per un "1" arrivato dalla memoria. Senza
       evento non parte il salvataggio in memoria e non parte nessuno
       scorrimento: la pagina non si muove da sola. */
    bpPreselezionaNumero() {
      const bpVoluto = (this.getAttribute('data-bp-numero-preselezionato') || '').trim();
      if (bpVoluto === '') return;
      const bpRadio = Array.prototype.slice.call(
        this.querySelectorAll('input[type="radio"][data-bp-option-index="0"]')
      );
      if (bpRadio.length === 0) return;
      if (bpRadio.some(function (bpR) { return bpR.checked; })) return;
      const bpScelto = bpRadio.find(function (bpR) {
        return parseInt(bpR.value, 10) === parseInt(bpVoluto, 10);
      });
      if (!bpScelto) {
        console.warn('[bp-configuratore] Numero preselezionato "' + bpVoluto + '" non trovato fra i numeri del prodotto.');
        return;
      }
      bpScelto.checked = true;
      /* Il numero l'ha messo la preselezione, non il cliente: finche' resta
         cosi' sotto i numeri c'e' in piu' la frase sul prezzo. La spegne il
         primo tocco su un numero (bpOnClick). */
      this.bpNumeroPreselAttivo = true;
    }

    /* FORMATO PRESELEZIONATO ALL'APERTURA (decisione del Capitano, Ritratto e
       Manifesto: la Cornice). Stessa regola del numero: RIEMPIE SOLO, NON
       CORREGGE. Se il secondo selettore ha gia' una scelta (memoria di
       sessione, ?variant= preselezionato dal Liquid, ritorno indietro del
       browser) non si tocca niente.
       Lo slot dell'editor arriva gia' tradotto dal Liquid nel valore vero
       della variante (data-bp-formato-preselezionato-valore), nell'ordine di
       Shopify: l'ordine a schermo delle card non conta. Valore vuoto con
       slot impostato = slot che non esiste: console.warn e niente.
       Si preseleziona solo una combinazione che si puo' comprare: la
       variante "numero scelto (o il primo) + quel formato" deve esistere ed
       essere disponibile, altrimenti console.warn e formato vuoto.
       Come per il numero, SOLO IL CAMPO e nessun evento: bpUpdate in fondo a
       connectedCallback fa il resto (prezzo, barrato, etichetta, Totale). */
    bpPreselezionaFormato() {
      const bpSlot = (this.getAttribute('data-bp-formato-preselezionato') || '').trim();
      if (bpSlot === '') return;
      if (!this.bpProduct || !Array.isArray(this.bpProduct.options) || this.bpProduct.options.length !== 2) return;
      const bpValore = this.getAttribute('data-bp-formato-preselezionato-valore') || '';
      if (bpValore === '') {
        console.warn('[bp-configuratore] Formato preselezionato: lo slot "' + bpSlot + '" non esiste per questo prodotto.');
        return;
      }
      if (this.bpLeggiScelte()[1] != null) return;
      const bpNumero = this.bpNumeroPerPrezzi();
      const bpVariante = bpNumero != null ? this.bpFindVariant([bpNumero, bpValore]) : null;
      if (!bpVariante || bpVariante.available === false) {
        console.warn('[bp-configuratore] Formato preselezionato: "' + bpNumero + ' / ' + bpValore + '" non esiste o non e\' disponibile.');
        return;
      }
      const bpRadio = Array.prototype.slice.call(
        this.querySelectorAll('input[type="radio"][data-bp-option-index="1"]')
      ).find(function (bpR) { return bpR.value === bpValore; });
      if (bpRadio) {
        bpRadio.checked = true;
        return;
      }
      const bpTendina = this.querySelector('select[data-bp-option-index="1"]');
      const bpOpzione = bpTendina ? Array.prototype.find.call(bpTendina.options, function (bpO) { return bpO.value === bpValore; }) : null;
      if (bpOpzione) {
        bpTendina.value = bpValore;
        return;
      }
      console.warn('[bp-configuratore] Formato preselezionato: "' + bpValore + '" non e\' fra le scelte in pagina.');
    }

    /* FORMATI NASCOSTI (impostazione "Formati nascosti", 05/10/2026). Il
       Liquid non stampa il formato nascosto (nessun radio, nessuna card,
       nessuna option) e passa qui i suoi valori veri in
       data-bp-formati-nascosti, come elenco JSON. Qui lo si toglie da tutto
       cio' che il modulo calcola.
       LE VARIANTI SI TOLGONO DALL'ELENCO, e basta: bpFindVariant,
       bpVariantePiuEconomicaPer, bpPrezzoPerSceltaParziale, i prezzi sulle
       card, il prezzo in alto, l'etichetta, la pillola e il Totale leggono
       tutti da this.bpProduct.variants. Un formato che li' non c'e' non
       entra in nessun conto, e una combinazione che lo contiene "non
       esiste" come qualunque altra, quindi non puo' mai finire nel carrello.
       Le tolte restano in bpVariantiNascoste: servono solo a riconoscere un
       ?variant= che le punta. Su Shopify non cambia niente.
       Solo prodotti a DUE opzioni, dove il secondo selettore e' quello dei
       formati. Elenco illeggibile, che non corrisponde a nessuna variante o
       che svuoterebbe il prodotto: si segnala e non si tocca niente. */
    bpApplicaFormatiNascosti() {
      this.bpFormatiNascosti = [];
      this.bpVariantiNascoste = [];
      /* Vero se il link o la memoria puntavano a un formato nascosto: allora
         bpFormatoDiRiserva deve riempire il posto lasciato vuoto. */
      this.bpFormatoSpostato = false;
      const bpGrezzo = this.getAttribute('data-bp-formati-nascosti');
      if (!bpGrezzo) return;
      if (!this.bpProduct || !Array.isArray(this.bpProduct.options) || this.bpProduct.options.length !== 2) return;
      let bpLista = null;
      try {
        bpLista = JSON.parse(bpGrezzo);
      } catch (bpErrore) {
        bpLista = null;
      }
      if (!Array.isArray(bpLista)) {
        console.warn('[bp-configuratore] Formati nascosti: elenco non leggibile, nessun formato nascosto.');
        return;
      }
      const bpValori = bpLista.filter(function (bpV) { return typeof bpV === 'string' && bpV !== ''; });
      if (bpValori.length === 0) return;
      const bpTutte = this.bpProduct.variants;
      const bpNascoste = bpTutte.filter(function (bpV) {
        return Array.isArray(bpV.options) && bpValori.indexOf(bpV.options[1]) !== -1;
      });
      if (bpNascoste.length === 0) {
        console.warn('[bp-configuratore] Formati nascosti: nessuna variante con questi formati, nessun formato nascosto.');
        return;
      }
      if (bpNascoste.length === bpTutte.length) {
        console.warn('[bp-configuratore] Formati nascosti: coprirebbero tutte le varianti, impostazione ignorata.');
        return;
      }
      this.bpFormatiNascosti = bpValori;
      this.bpVariantiNascoste = bpNascoste;
      this.bpProduct.variants = bpTutte.filter(function (bpV) { return bpNascoste.indexOf(bpV) === -1; });
      this.bpControllaLinkNascosto();
    }

    bpEFormatoNascosto(bpValore) {
      return typeof bpValore === 'string' && Array.isArray(this.bpFormatiNascosti)
        && this.bpFormatiNascosti.indexOf(bpValore) !== -1;
    }

    /* Un link con ?variant= che punta a una variante di un formato nascosto
       (le ads vecchie ce ne portano). Il Liquid ha spuntato il numero di
       quella variante, e va bene cosi'; il formato non ha nessun radio da
       spuntare e resta vuoto, ci pensa la preselezione o il primo visibile.
       Qui si fa solo il segno e la riga in console. */
    bpControllaLinkNascosto() {
      let bpId = null;
      try {
        bpId = new URLSearchParams(window.location.search).get('variant');
      } catch (bpErrore) {
        bpId = null;
      }
      if (!bpId) return;
      const bpTrovata = this.bpVariantiNascoste.find(function (bpV) { return String(bpV.id) === bpId; });
      if (!bpTrovata) return;
      this.bpFormatoSpostato = true;
      console.warn('[bp-configuratore] Il link ?variant=' + bpId + ' punta al formato nascosto "' + bpTrovata.options[1] + '": si passa al formato preselezionato o al primo visibile.');
    }

    /* Se il link o la memoria puntavano a un formato nascosto e dopo la
       preselezione il secondo selettore e' ancora vuoto, sceglie il PRIMO
       formato visibile che si puo' comprare col numero scelto (o, senza
       numero, col primo numero), nell'ordine di Shopify. Stessa regola
       delle altre preselezioni: SOLO IL CAMPO, nessun evento, e mai al
       posto di una scelta gia' fatta. */
    bpFormatoDiRiserva() {
      if (!this.bpFormatoSpostato) return;
      if (this.bpLeggiScelte()[1] != null) return;
      const bpNumero = this.bpNumeroPerPrezzi();
      const bpModulo = this;
      const bpComprabile = function (bpValore) {
        const bpVariante = bpNumero != null ? bpModulo.bpFindVariant([bpNumero, bpValore]) : null;
        return !!bpVariante && bpVariante.available !== false;
      };
      const bpRadio = Array.prototype.slice.call(
        this.querySelectorAll('input[type="radio"][data-bp-option-index="1"]')
      ).find(function (bpR) { return bpComprabile(bpR.value); });
      if (bpRadio) {
        bpRadio.checked = true;
        console.warn('[bp-configuratore] Formato nascosto richiesto: scelto "' + bpRadio.value + '".');
        return;
      }
      const bpTendina = this.querySelector('select[data-bp-option-index="1"]');
      const bpOpzione = bpTendina
        ? Array.prototype.find.call(bpTendina.options, function (bpO) { return bpO.value !== '' && bpComprabile(bpO.value); })
        : null;
      if (bpOpzione) {
        bpTendina.value = bpOpzione.value;
        console.warn('[bp-configuratore] Formato nascosto richiesto: scelto "' + bpOpzione.value + '".');
        return;
      }
      console.warn('[bp-configuratore] Formato nascosto richiesto: nessun formato visibile acquistabile, il formato resta da scegliere.');
    }

    bpMemoriaRipristina() {
      if (!this.bpMemoriaAttiva()) return;
      const bpDati = bpMemoriaLeggi(this.bpMemoriaChiave());
      if (!bpDati) return;

      /* Una scelta salvata su un formato nascosto (la sessione e' di prima
         che lo si nascondesse) non si rimette: il radio non esiste, ma la
         scelta si tiene fuori apposta e si dice in console. */
      if (Array.isArray(bpDati.opzioni) && this.bpEFormatoNascosto(bpDati.opzioni[1])) {
        console.warn('[bp-configuratore] La scelta salvata e\' il formato nascosto "' + bpDati.opzioni[1] + '": si passa al formato preselezionato o al primo visibile.');
        bpDati.opzioni[1] = null;
        this.bpFormatoSpostato = true;
      }

      if (Array.isArray(bpDati.opzioni)) {
        for (let bpIndex = 0; bpIndex < bpDati.opzioni.length; bpIndex += 1) {
          this.bpRimettiOpzione(bpIndex, bpDati.opzioni[bpIndex]);
        }
      }

      this.bpRimettiRadio('input[data-bp-dettagli-modo-input]', bpDati.dettagliModo);
      this.bpRimettiTesto('[data-bp-dettagli-input]', bpDati.dettagli);
      this.bpRimettiRadio('input[data-bp-sfondo-input]', bpDati.sfondo);
      this.bpRimettiTesto('[data-bp-sfondo-descr-input]', bpDati.sfondoDescr);
      this.bpRimettiTesto('[data-bp-wanted-nome-input]', bpDati.wantedNome);
      this.bpRimettiTesto('[data-bp-wanted-taglia-input]', bpDati.wantedTaglia);
      this.bpRimettiInterruttore('input[data-bp-wanted-toggle]', bpDati.manifesto);
      this.bpRimettiInterruttore('input[data-bp-saltacoda-input]', bpDati.saltacoda);
      if (bpDati.manifestoToccato === true) this.bpManifestoToccato = true;

      /* LE FOTO PER ULTIME fra le cose salvate, ma comunque PRIMA di
         bpUpdate, che e' due righe dopo la chiamata a questo metodo: le
         voci entrano nell'array adesso, in modo sincrono, cosi' il primo
         conteggio le vede gia' tutte e il bottone non puo' accettare un
         ordine che crede senza foto. I byte arrivano dopo, in sottofondo. */
      this.bpRipristinaFoto(bpDati.foto);
    }

    /* Rimette in piedi le voci foto dai dati salvati. SINCRONO e senza
       rete: crea le voci e basta, poi lascia correre il recupero.

       LA VOCE NASCE SENZA FILE E SENZA ORIGINALE, col contrassegno
       "ripristinata". E' la differenza che il disegno della griglia
       guarda per mettere un segnaposto al posto dell'anteprima: un tag
       immagine senza sorgente mostrerebbe l'icona di immagine rotta del
       browser, che a schermo sembra un guasto.

       LO STATO E' "caricata" perche' e' la verita': quella foto sta su
       R2 col suo gettone. E' anche cio' che permette al click di mandare
       i gettoni senza aspettare niente, e che tiene la voce fuori dalle
       code di conversione e caricamento, che guardano proprio lo stato.

       UNA VOLTA SOLA: la bandierina impedisce che una riconnessione
       raddoppi le voci. */
    bpRipristinaFoto(bpSalvate) {
      if (this.bpFotoRipristinate) return;
      if (!Array.isArray(bpSalvate) || bpSalvate.length === 0) return;
      this.bpFotoRipristinate = true;

      const bpNuove = [];
      for (let bpI = 0; bpI < bpSalvate.length; bpI += 1) {
        const bpSalvata = bpSalvate[bpI];
        if (!bpSalvata || typeof bpSalvata.gettone !== 'string' || bpSalvata.gettone === '') continue;
        if (typeof bpSalvata.nome !== 'string' || bpSalvata.nome === '') continue;
        const bpVoce = {
          originale: null,
          file: null,
          stato: 'caricata',
          esito: null,
          gettone: bpSalvata.gettone,
          erroreCaricamento: null,
          ripristinata: true,
          recuperoFallito: false,
          nome: bpSalvata.nome,
          tipo: (typeof bpSalvata.tipo === 'string') ? bpSalvata.tipo : '',
          peso: (typeof bpSalvata.peso === 'number') ? bpSalvata.peso : 0,
        };
        this.bpFotoFiles.push(bpVoce);
        bpNuove.push(bpVoce);
      }
      if (bpNuove.length === 0) return;

      /* Il recupero parte subito e NON si aspetta: una promessa lasciata
         correre, che ridisegna la griglia da sola a ogni foto tornata.
         Il catch e' il muro finale: un guasto qui dentro non deve mai
         arrivare al bottone, esattamente come per la memoria. */
      this.bpRecuperaFoto(bpNuove).catch(function (bpErrore) {
        console.warn('[bp-configuratore] Recupero delle foto salvate interrotto:', bpErrore);
      });
    }

    /* Il recupero vero: una chiamata alla porta con tutti i gettoni,
       poi uno scarico per foto, uno dopo l'altro.

       SERIALE e non in parallelo: sono byte in discesa mentre il cliente
       sta guardando la pagina, e due o tre scarichi insieme si
       ruberebbero la banda senza far arrivare prima la prima miniatura,
       che e' l'unica che il cliente aspetta davvero.

       OGNI PASSO RICONTROLLA CHE LA VOCE SIA ANCORA VIVA, come fanno le
       code di conversione e caricamento: fra una riga e l'altra il
       cliente puo' aver rimosso quella foto o svuotato tutto. */
    async bpRecuperaFoto(bpVoci) {
      let bpIndirizzi = null;
      try {
        bpIndirizzi = await bpChiediIndirizziFoto(bpVoci.map(function (bpVoce) { return bpVoce.gettone; }));
      } catch (bpErrore) {
        /* La porta non ha risposto: stesso trattamento dell'errore di
           rete sullo scarico. Le voci restano, col gettone valido e il
           segnaposto al posto dell'anteprima: l'ordine puo' partire lo
           stesso, ed e' il danno minore. */
        console.warn('[bp-configuratore] rileggi-foto non ha risposto:', bpErrore.message);
        this.bpSegnaRecuperoFallito(bpVoci);
        return;
      }

      const bpSparite = [];
      for (let bpI = 0; bpI < bpVoci.length; bpI += 1) {
        const bpVoce = bpVoci[bpI];
        if (this.bpFotoFiles.indexOf(bpVoce) === -1) continue;

        const bpUrl = bpIndirizzi[bpVoce.gettone];
        if (typeof bpUrl !== 'string' || bpUrl === '') {
          /* Nessun indirizzo per questo gettone: la porta lo ha scartato
             perche' fuori forma, cosa che succede solo se la memoria e'
             stata toccata a mano. Non e' una prova che il file non ci
             sia, quindi la voce resta col segnaposto invece di essere
             buttata. */
          this.bpSegnaRecuperoFallito([bpVoce]);
          continue;
        }

        let bpBlob = null;
        let bpCausa = 'rete';
        for (let bpTentativo = 1; bpTentativo <= BP_SCARICO_TENTATIVI; bpTentativo += 1) {
          if (this.bpFotoFiles.indexOf(bpVoce) === -1) break;
          if (bpTentativo > 1) await bpAspetta(BP_SCARICO_PAUSA_MS);
          try {
            bpBlob = await bpScaricaFotoSalvata(bpUrl);
            break;
          } catch (bpErrore) {
            bpCausa = (bpErrore && bpErrore.bpCausa === 'sparita') ? 'sparita' : 'rete';
            /* Un file sparito non torna al secondo tentativo: si smette
               subito e si passa all'avviso al cliente. */
            if (bpCausa === 'sparita') break;
          }
        }

        if (this.bpFotoFiles.indexOf(bpVoce) === -1) continue;

        if (bpBlob) {
          /* IL FILE SI RICOSTRUISCE COL NOME E COL TIPO SALVATI, non con
             quelli che il browser deduce dal Blob: il nome e' quello che
             il cliente vede e quello che viaggia nel ripiego, e il tipo
             dichiarato e' lo stesso con cui la foto e' stata firmata e
             caricata. Da qui in poi la voce e' una voce come le altre:
             originale e file puntano allo stesso File, che e' la verita'
             (di quella foto esiste una versione sola, quella su R2). */
          const bpTipo = bpVoce.tipo || bpBlob.type || 'application/octet-stream';
          const bpFile = new File([bpBlob], bpVoce.nome, { type: bpTipo });
          bpVoce.file = bpFile;
          bpVoce.originale = bpFile;
          bpVoce.ripristinata = false;
          bpVoce.recuperoFallito = false;
          this.bpRenderFoto();
          continue;
        }

        if (bpCausa === 'sparita') {
          bpSparite.push(bpVoce);
          continue;
        }
        this.bpSegnaRecuperoFallito([bpVoce]);
      }

      if (bpSparite.length > 0) this.bpTogliFotoSparite(bpSparite);
    }

    /* Il segnaposto resta, la voce pure: il gettone e' valido, l'ordine
       puo' partire coi gettoni come sempre, manca solo l'anteprima. */
    bpSegnaRecuperoFallito(bpVoci) {
      let bpCambiato = false;
      for (let bpI = 0; bpI < bpVoci.length; bpI += 1) {
        const bpVoce = bpVoci[bpI];
        if (this.bpFotoFiles.indexOf(bpVoce) === -1) continue;
        if (!bpVoce.ripristinata) continue;
        bpVoce.recuperoFallito = true;
        bpCambiato = true;
      }
      if (bpCambiato) this.bpRenderFoto();
    }

    /* Le foto che su R2 non ci sono piu' SI TOLGONO, ed e' l'unico caso
       in cui il ripristino butta qualcosa. Il gettone e' morto: tenerlo
       vorrebbe dire lasciar comprare un ordine che in officina si
       fermerebbe subito, con il cliente che aspetta e una persona che
       deve scrivergli. Meglio dirlo adesso, quando ricaricare la foto
       costa un tocco.
       La memoria si riscrive subito: quei gettoni non devono tornare al
       prossimo ripristino. */
    bpTogliFotoSparite(bpSparite) {
      let bpTolte = 0;
      for (let bpI = 0; bpI < bpSparite.length; bpI += 1) {
        const bpPos = this.bpFotoFiles.indexOf(bpSparite[bpI]);
        if (bpPos === -1) continue;
        this.bpFotoFiles.splice(bpPos, 1);
        bpTolte += 1;
      }
      if (bpTolte === 0) return;

      this.bpRenderFoto();
      this.bpRefreshFotoState();
      this.bpMemoriaSalva();
      this.bpShowFotoMsg(
        bpTolte === 1
          ? 'Una foto che avevi caricato prima non è più disponibile: caricala di nuovo.'
          : bpTolte + ' foto che avevi caricato prima non sono più disponibili: caricale di nuovo.',
        false
      );
    }

    /* LA REGOLA DEI QUATTRO METODI QUI SOTTO, ed e' una sola: la memoria
       RIEMPIE cio' che in pagina e' vuoto, non CORREGGE mai cio' che c'e'
       gia'. Da questa regola escono da sole tutte le precedenze che
       servono, senza doverle scrivere una per una:
       - il link con ?variant=: il Liquid ha gia' spuntato i radio, la
         memoria li trova pieni e passa oltre. Vince l'indirizzo, che e'
         una scelta esplicita e appena fatta;
       - l'opzione con un valore solo, preselezionata dal Liquid: stessa
         cosa;
       - il ritorno indietro del browser, che ripristina i campi da se':
         la memoria li trova gia' a posto e non fa niente.
       Un valore che non esiste piu' in pagina (opzione tolta dal
       catalogo, sfondo cancellato dal theme editor) non trova
       corrispondenza e viene lasciato cadere: il gruppo resta vuoto,
       che e' esattamente cio' che il cliente vedrebbe aprendo la pagina
       oggi per la prima volta. */

    /* Un selettore di variante puo' essere reso a pillole, a schede o a
       tendina: si guardano i radio e, se quel gruppo non ne ha, la
       tendina dello stesso indice. L'indice e' un numero, quindi nel
       selettore CSS e' sicuro; il VALORE invece arriva dal catalogo e
       puo' contenere qualsiasi cosa, per questo si confronta in
       JavaScript e non lo si infila mai dentro un querySelector. */
    bpRimettiOpzione(bpIndex, bpValore) {
      if (typeof bpValore !== 'string' || bpValore === '') return;

      const bpRadio = this.querySelectorAll(
        'input[type="radio"][data-bp-option-index="' + bpIndex + '"]'
      );
      if (bpRadio.length > 0) {
        for (let bpI = 0; bpI < bpRadio.length; bpI += 1) {
          if (bpRadio[bpI].checked) return;
        }
        for (let bpI = 0; bpI < bpRadio.length; bpI += 1) {
          if (bpRadio[bpI].value === bpValore) {
            bpRadio[bpI].checked = true;
            return;
          }
        }
        return;
      }

      const bpTendina = this.querySelector('select[data-bp-option-index="' + bpIndex + '"]');
      /* Valore diverso da vuoto vuol dire che il segnaposto non e' piu'
         selezionato, cioe' che una scelta c'e' gia'. */
      if (!bpTendina || bpTendina.value !== '') return;
      for (let bpI = 0; bpI < bpTendina.options.length; bpI += 1) {
        if (bpTendina.options[bpI].value === bpValore) {
          bpTendina.selectedIndex = bpI;
          return;
        }
      }
    }

    bpRimettiRadio(bpSelettore, bpValore) {
      if (typeof bpValore !== 'string' || bpValore === '') return;
      const bpTutti = this.querySelectorAll(bpSelettore);
      for (let bpI = 0; bpI < bpTutti.length; bpI += 1) {
        if (bpTutti[bpI].checked) return;
      }
      for (let bpI = 0; bpI < bpTutti.length; bpI += 1) {
        if (bpTutti[bpI].value === bpValore) {
          bpTutti[bpI].checked = true;
          return;
        }
      }
    }

    bpRimettiTesto(bpSelettore, bpValore) {
      if (typeof bpValore !== 'string' || bpValore === '') return;
      const bpCampo = this.querySelector(bpSelettore);
      if (!bpCampo || bpCampo.value !== '') return;
      bpCampo.value = bpValore;
    }

    /* Un interruttore si riaccende, non si spegne mai: spento E' lo
       stato vuoto, e la memoria non corregge cio' che trova. Vale anche
       per il saltacoda dopo un add riuscito, che il modulo spegne da se'
       e che la memoria fotografa spento un istante dopo. */
    bpRimettiInterruttore(bpSelettore, bpAcceso) {
      if (bpAcceso !== true) return;
      const bpCampo = this.querySelector(bpSelettore);
      if (!bpCampo || bpCampo.checked) return;
      bpCampo.checked = true;
    }

    /* --- eventi -------------------------------------------------------- */

    /* Spegne l'avviso "gia' nel carrello": da qui in poi il ritratto in
       lavorazione non e' piu' garantito identico a quello appena
       ordinato. Chiamata SOLO dai rami di bpOnChange/bpOnClick/bpOnInput
       che rappresentano un cambiamento vero (foto aggiunte o tolte,
       cambio di opzione, dettagli, sfondo, nome, saltacoda): mai da
       bpMemoriaRipristina o dalla prima bpUpdate() di connectedCallback,
       che non sono tocchi del cliente e con la bandierina gia' falsa di
       suo non avrebbero comunque niente da spegnere. */
    bpSpegniAvvisoGiaAggiunto() {
      this.bpUltimoOrdineAggiunto = false;
      /* Il modulo e' cambiato: il motivo di un clic fermato prima (vedi
         bpFermaClick) potrebbe non valere piu'. Si toglie solo quello:
         gli altri messaggi del bottone restano ai loro padroni. */
      if (this.bpErroreDelClick) {
        this.bpErroreDelClick = false;
        this.bpHideError();
      }
    }

    bpOnChange(bpEvent) {
      const bpTarget = bpEvent.target;
      if (!bpTarget) return;
      /* Un selettore e' appena stato scelto: il bordo rosso su quel
         gruppo non ha piu' ragione di stare li'. Si toglie qui e non in
         bpUpdate perche' qui si sa QUALE gruppo ha ricevuto la scelta,
         senza doverli ripassare tutti.
         Il ramo della tendina esiste a parte perche' un prodotto puo'
         avere il primo selettore a tendina e il secondo a pillole. */
      if (bpTarget.matches('input[type="radio"][data-bp-option-index], select[data-bp-option-index]')) {
        const bpGruppo = bpTarget.closest('[data-bp-opzione-gruppo]');
        if (bpGruppo) bpGruppo.classList.remove('bp-campo-mancante');
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpUpdate();
        return;
      }
      if (bpTarget.matches('input[type="radio"][data-bp-sfondo-input]')) {
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetSfondo(bpTarget.value);
        return;
      }
      if (bpTarget.matches('input[type="radio"][data-bp-dettagli-modo-input]')) {
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetDettagliModo(bpTarget.value);
        return;
      }
      if (bpTarget.matches('input[type="file"][data-bp-foto-input]')) {
        this.bpAddFotoFiles(bpTarget.files);
        /* si svuota il picker: le foto vivono nello stato del modulo,
           così la stessa foto può essere riselezionata dopo una rimozione */
        bpTarget.value = '';
        return;
      }
      if (bpTarget.matches('input[data-bp-saltacoda-input]')) {
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetSaltacoda(bpTarget.checked);
        return;
      }
      if (bpTarget.matches('input[data-bp-wanted-toggle]')) {
        /* Una checkbox cambia SEMPRE stato al click, acceso o spento che
           sia: "change" riparte sempre, a differenza del radio. Un
           tocco solo basta. */
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpManifestoToccato = true;
        this.bpToggleWantedFields();
      }
    }

    bpOnClick(bpEvent) {
      const bpTarget = bpEvent.target;
      if (!bpTarget) return;
      /* Qui NON c'e' piu' un ramo per i selettori di variante. Ce n'era
         uno che, al click su un radio gia' scelto, segnava il tocco e
         riallineava la rotta: serviva solo a tenere aggiornato il
         registro dei tocchi, che non esiste piu'. Un click che non
         cambia il valore non cambia nemmeno lo stato della tappa, e il
         click che il valore lo cambia davvero passa comunque da
         "change". Aprire una tendina senza scegliere non deve contare
         niente, ed e' giusto che non conti. */
      /* UNICA ECCEZIONE, e non riguarda la rotta: il primo tocco su un
         numero, anche sullo stesso "1" gia' scelto, spegne la frase del
         numero preselezionato. Il tocco sullo stesso numero non genera
         "change", per questo sta qui e non la. */
      if (this.bpNumeroPreselAttivo && bpTarget.matches('input[type="radio"][data-bp-option-index="0"]')) {
        this.bpNumeroPreselAttivo = false;
        this.bpAggiornaEcoNumeri();
      }
      const bpRemoveBtn = bpTarget.closest('[data-bp-foto-remove]');
      if (bpRemoveBtn) {
        this.bpRemoveFoto(parseInt(bpRemoveBtn.getAttribute('data-bp-foto-remove'), 10));
        return;
      }
      /* Il Riprova sta DOPO il rimuovi, e l'ordine conta: il bottone
         rimuovi vive dentro il riquadro, quindi un clic su di lui
         risalirebbe fino al riquadro fallito e rimetterebbe in coda una
         foto che il cliente stava cancellando.
         NON spegne l'avviso: e' la STESSA foto che riprova, non una
         foto aggiunta o tolta, quindi il ritratto non e' cambiato. */
      const bpRiprovaEl = bpTarget.closest('[data-bp-foto-riprova]');
      if (bpRiprovaEl) {
        this.bpRiprovaCaricamento(parseInt(bpRiprovaEl.getAttribute('data-bp-foto-riprova'), 10));
        return;
      }
      /* QUI NON C'E' PIU' L'ANTEPRIMA DELLO SFONDO, e la sua assenza e'
         la correzione. Prima il tocco sulla tessera faceva due cose
         insieme, sceglieva e apriva; adesso ne fa una sola, sceglie.
         L'anteprima ha un gesto suo, la lente, che e' un bottone con un
         ascoltatore proprio (bpInitZoom) e non passa di qui: cosi'
         l'apertura non aspetta nessun lavoro del configuratore, e nemmeno
         il salvataggio in memoria che avvolge questo gestore.
         Di conseguenza anche le frecce della tastiera, che sui radio
         fanno scattare un click, non possono piu' aprire niente. */
      if (bpTarget.closest('[data-bp-atc]')) {
        /* Un guasto dentro bpAddToCart prima del suo try (i controlli
           iniziali) finirebbe in una promessa rifiutata che nessuno
           guarda: il cliente non vedrebbe niente. Qui si raccoglie. */
        const bpModulo = this;
        this.bpAddToCart().catch(function (bpErrore) {
          console.warn('[bp-configuratore] Aggiungi al carrello interrotto:', bpErrore);
          bpModulo.bpFermaClick(
            'errore nel gestore (' + ((bpErrore && bpErrore.message) || String(bpErrore)).slice(0, 120) + ')',
            'Qualcosa è andato storto. Riprova tra un attimo, oppure scrivici.',
            { tipo: 'errore nel gestore del bottone' }
          );
        });
      }
    }

    bpOnInput(bpEvent) {
      const bpTarget = bpEvent.target;
      if (!bpTarget) return;
      if (bpTarget.matches('[data-bp-dettagli-input]')) {
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetDettagli(bpTarget.value);
        return;
      }
      if (bpTarget.matches('[data-bp-sfondo-descr-input]')) {
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetSfondoDescr(bpTarget.value);
        return;
      }
      if (bpTarget.matches('[data-bp-wanted-nome-input]')) {
        /* Appena il cliente scrive, il rosso non serve piu'. */
        bpTarget.classList.remove('bp-campo-mancante');
        this.bpNascondiErroreCampo(this.bpErroreNomeEl);
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetWantedNome(bpTarget.value);
        return;
      }
      if (bpTarget.matches('[data-bp-wanted-taglia-input]')) {
        this.bpSpegniAvvisoGiaAggiunto();
        this.bpSetWantedTaglia(bpTarget.value);
      }
    }

    /* --- lettura selezione e ricerca variante --------------------------- */

    /* LA SCELTA DI OGNI OPZIONE, indice per indice: il valore scelto
       oppure null se il cliente non ha ancora scelto quella.
       Ogni selettore puo' essere reso a pillole, a schede o a tendina,
       scelta fatta nel theme editor selettore per selettore: si guarda
       prima il radio spuntato e, in sua mancanza, la tendina dello stesso
       indice.
       LA TENDINA VUOTA VALE NULL: la sua prima riga e' un segnaposto con
       value vuoto, perche' un select mostra sempre qualcosa e senza quella
       riga leggeremmo come scelta il primo valore dell'elenco. Stringa
       vuota qui significa esattamente "non ha ancora scelto".
       Il null per posizione, invece di un null secco per tutto, serve a
       sapere QUALI opzioni mancano: e' quello che accende di rosso il
       gruppo giusto invece di tutti. */
    bpLeggiScelte() {
      const bpCount = this.bpProduct.options.length;
      const bpScelte = [];
      for (let bpIndex = 0; bpIndex < bpCount; bpIndex += 1) {
        const bpChecked = this.querySelector(
          'input[type="radio"][data-bp-option-index="' + bpIndex + '"]:checked'
        );
        if (bpChecked) {
          bpScelte.push(bpChecked.value);
          continue;
        }
        const bpTendina = this.querySelector(
          'select[data-bp-option-index="' + bpIndex + '"]'
        );
        if (bpTendina && bpTendina.value !== '') {
          bpScelte.push(bpTendina.value);
          continue;
        }
        bpScelte.push(null);
      }
      return bpScelte;
    }

    /* Vero quando almeno una opzione non e' stata scelta. Distingue il
       modulo appena aperto dalla combinazione davvero impossibile: sono
       due cose diverse e vanno raccontate in due modi diversi, altrimenti
       chi apre la pagina si becca "Combinazione non disponibile" prima di
       aver fatto qualsiasi cosa. */
    bpScelteIncomplete() {
      return this.bpLeggiScelte().indexOf(null) !== -1;
    }

    /* Le scelte complete, o null se ne manca anche una sola. Contratto
       identico a prima per chi la chiama (bpUpdate, bpGetMaxFoto): null
       vuol dire "non si puo' cercare una variante". */
    bpGetSelectedOptions() {
      const bpScelte = this.bpLeggiScelte();
      if (bpScelte.indexOf(null) !== -1) return null;
      return bpScelte;
    }

    /* LA VARIANTE DELLE SCELTE, A STRATI (14/10/2026, regola del Capitano:
       un cliente non resta mai senza poter comprare). Prima c'era solo il
       testo identico; ora, nell'ordine:
       1. GLI ID: ogni radio e ogni voce della tendina porta in data-bp-ids
          gli ID delle varianti che hanno quel valore, scritti dal Liquid
          sugli stessi oggetti variante. La variante e' quella che hanno in
          comune tutte le scelte: nessun confronto fra testi;
       2. il testo identico, come sempre;
       3. il testo normalizzato (bpNormalizza);
       4. le parole chiave (bpParoleChiave).
       Dal 3 in poi vale solo una corrispondenza UNICA: due candidate sono un
       dubbio, e un dubbio non va nel carrello. Sempre e solo fra le varianti
       del modulo: i formati nascosti restano fuori. */
    bpFindVariant(bpSelected) {
      if (!Array.isArray(bpSelected) || !this.bpProduct || !Array.isArray(this.bpProduct.variants)) return null;
      const bpVarianti = this.bpProduct.variants;
      const bpPerId = this.bpVariantePerId(bpSelected);
      if (bpPerId) return bpPerId;
      const bpStessaForma = function (bpVariant) {
        return Array.isArray(bpVariant.options) && bpVariant.options.length === bpSelected.length;
      };
      const bpMatch = bpVarianti.find(function (bpVariant) {
        return bpStessaForma(bpVariant) && bpVariant.options.every(function (bpValue, bpIndex) {
          return bpValue === bpSelected[bpIndex];
        });
      });
      if (bpMatch) return bpMatch;
      const bpUnica = function (bpUguali) {
        const bpTrovate = bpVarianti.filter(function (bpVariant) {
          return bpStessaForma(bpVariant) && bpVariant.options.every(function (bpValue, bpIndex) {
            return bpUguali(bpValue, bpSelected[bpIndex]);
          });
        });
        return bpTrovate.length === 1 ? bpTrovate[0] : null;
      };
      const bpNorm = bpUnica(function (bpA, bpB) { return bpNormalizza(bpA) === bpNormalizza(bpB); });
      if (bpNorm) { this.bpSegnaRiserva('testo normalizzato', bpSelected, bpNorm); return bpNorm; }
      const bpParole = bpUnica(function (bpA, bpB) {
        const bpK = bpParoleChiave(bpA);
        return bpK !== '' && bpK === bpParoleChiave(bpB);
      });
      if (bpParole) { this.bpSegnaRiserva('parole chiave', bpSelected, bpParole); return bpParole; }
      return null;
    }

    /* Gli ID scritti dal Liquid sul controllo di quel valore (il radio
       spuntato se e' lui, altrimenti il primo con quel valore, o la voce
       della tendina). null se il controllo non c'e' o non porta ID. */
    bpIdsDi(bpIndice, bpValore) {
      if (bpValore == null) return null;
      const bpControlli = Array.prototype.slice.call(this.querySelectorAll(
        'input[type="radio"][data-bp-option-index="' + bpIndice + '"], select[data-bp-option-index="' + bpIndice + '"] option'
      ));
      const bpStesso = bpControlli.filter(function (bpC) { return bpC.value === bpValore; });
      const bpScelto = bpStesso.find(function (bpC) { return bpC.checked || bpC.selected; }) || bpStesso[0];
      if (!bpScelto) return null;
      const bpGrezzo = bpScelto.getAttribute('data-bp-ids');
      if (!bpGrezzo) return null;
      const bpIds = bpGrezzo.split(',').map(function (bpX) { return bpX.trim(); }).filter(Boolean);
      return bpIds.length ? bpIds : null;
    }

    /* Strato 1: la variante in comune fra gli ID di tutte le scelte. */
    bpVariantePerId(bpSelected) {
      let bpComuni = null;
      for (let bpI = 0; bpI < bpSelected.length; bpI += 1) {
        const bpIds = this.bpIdsDi(bpI, bpSelected[bpI]);
        if (!bpIds) return null;
        bpComuni = bpComuni === null ? bpIds : bpComuni.filter(function (bpId) { return bpIds.indexOf(bpId) !== -1; });
      }
      if (!bpComuni || bpComuni.length !== 1) return null;
      const bpId = bpComuni[0];
      return this.bpProduct.variants.find(function (bpV) { return String(bpV.id) === bpId; }) || null;
    }

    /* Una variante trovata con la riserva (strati 3 e 4): si dice in console,
       una volta per scelta, e resta scritto nello stato degli avvisi. */
    bpSegnaRiserva(bpModo, bpSelected, bpVariante) {
      const bpChiave = bpModo + '|' + bpSelected.join('|');
      this.bpRiserve = this.bpRiserve || {};
      if (this.bpRiserve[bpChiave]) return;
      this.bpRiserve[bpChiave] = true;
      this.bpUltimaRiserva = bpModo + ' -> ' + bpVariante.id;
      console.warn('[bp-configuratore] Variante trovata con la riserva (' + bpModo + '): ' + bpSelected.map(bpEsatto).join(' / ') + ' -> ' + bpVariante.id + '.');
    }

    /* Strato 5: il prodotto riscaricato da Shopify, senza cache, UNA volta
       per pagina. Serve se i dati scritti nella pagina sono vecchi (pagina
       tenuta in memoria dal browser o dall'app, prodotto cambiato nel
       frattempo). Le varianti nuove passano dagli stessi formati nascosti.
       Torna vero se il prodotto e' stato davvero sostituito.

       L'ESITO HA UNA CAUSA (30/10/2026), in bpRicaricaStato:
       'in corso'; 'ok' (prodotto riscaricato); 'dati' (Shopify risponde ma
       il prodotto non c'e': 404, o indirizzo senza handle); 'rete' (nessuna
       risposta, timeout, errore di rete, 5xx, risposta non JSON). Il
       dettaglio, per l'avviso, in bpRicaricaDettaglio. "Una volta per
       pagina" vale per 'ok' e 'dati'; dopo 'rete' la chiamata seguente
       riprova davvero, invece di restituire la stessa caduta per sempre. */
    bpRicaricaProdotto() {
      if (this.bpRicaricaPromessa && this.bpRicaricaStato !== 'rete') return this.bpRicaricaPromessa;
      const bpModulo = this;
      const bpPercorso = (window.location.pathname || '').split('/products/')[1] || '';
      const bpHandle = bpPercorso.split('/')[0];
      this.bpRicaricaTentativi = (this.bpRicaricaTentativi || 0) + 1;
      if (!bpHandle) {
        this.bpRicaricaStato = 'dati';
        this.bpRicaricaDettaglio = 'indirizzo senza handle';
        this.bpRicaricaPromessa = Promise.resolve(false);
        return this.bpRicaricaPromessa;
      }
      this.bpRicaricaStato = 'in corso';
      this.bpRicaricaInCorso = true;
      let bpEsito = null;
      /* TIMEOUT DI 8 SECONDI (20/10/2026). Su una rete lenta o appesa fetch
         puo' non rispondere mai: il modulo restava in attesa della ricarica,
         senza riga e senza avviso, e il clic non partiva. Allo scadere la
         richiesta si annulla (AbortController; dove non c'e' vale la corsa
         col timer) e il risultato e' "non ricaricato": la riga rossa col
         pulsante WhatsApp e l'avviso "variante non trovata" partono come
         se la ricarica avesse risposto no, piu' un avviso suo che dice
         che e' scaduta. Mai un riquadro vuoto in silenzio. */
      const bpControllo = (typeof AbortController === 'function') ? new AbortController() : null;
      let bpScaduta = false;
      let bpTimer = null;
      const bpScadenza = new Promise(function (bpOk) {
        bpTimer = setTimeout(function () {
          bpScaduta = true;
          if (bpControllo) { try { bpControllo.abort(); } catch (bpErroreAbort) { /* niente */ } }
          bpOk(false);
        }, BP_RICARICA_TIMEOUT_MS);
      });
      const bpRichiesta = fetch('/products/' + bpHandle + '.js?bp=' + Date.now(), { cache: 'no-store', credentials: 'same-origin', signal: bpControllo ? bpControllo.signal : undefined })
        .then(function (bpRisposta) {
          if (!bpRisposta.ok) {
            bpEsito = { stato: bpRisposta.status === 404 ? 'dati' : 'rete', dettaglio: 'HTTP ' + bpRisposta.status };
            return null;
          }
          return bpRisposta.json().catch(function () {
            bpEsito = { stato: 'rete', dettaglio: 'risposta non JSON' };
            return null;
          });
        })
        .then(function (bpDati) {
          if (bpScaduta) return false;
          if (!bpDati || !Array.isArray(bpDati.variants) || !Array.isArray(bpDati.options)) {
            if (!bpEsito) bpEsito = { stato: 'rete', dettaglio: 'dati del prodotto incompleti' };
            return false;
          }
          bpModulo.bpProduct = {
            id: bpDati.id,
            options: bpDati.options.map(function (bpO) { return (bpO && typeof bpO === 'object') ? bpO.name : bpO; }),
            variants: bpDati.variants.map(function (bpV) {
              return { id: bpV.id, title: bpV.title, options: bpV.options, price: bpV.price, compare_at_price: bpV.compare_at_price, available: bpV.available };
            }),
          };
          bpModulo.bpApplicaFormatiNascosti();
          bpModulo.bpProdottoRicaricato = true;
          bpEsito = { stato: 'ok', dettaglio: 'prodotto riscaricato da Shopify (' + bpModulo.bpProduct.variants.length + ' varianti)' };
          console.warn('[bp-configuratore] Prodotto riscaricato da Shopify: ' + bpModulo.bpProduct.variants.length + ' varianti nel modulo.');
          return true;
        })
        .catch(function (bpErrore) {
          if (!bpEsito) bpEsito = { stato: 'rete', dettaglio: 'errore di rete (' + ((bpErrore && bpErrore.name) || 'sconosciuto') + ': ' + ((bpErrore && bpErrore.message) || '') + ')' };
          return false;
        });
      /* Lo scadere non manda piu' un avviso suo (prima "ricarica prodotto
         scaduta"): la causa entra nell'unico avviso della variante non
         trovata, che dice rete o variante mancante. */
      this.bpRicaricaPromessa = Promise.race([bpRichiesta, bpScadenza]).then(function (bpRiuscita) {
        clearTimeout(bpTimer);
        if (bpScaduta) {
          console.warn('[bp-configuratore] Ricarica del prodotto scaduta dopo ' + BP_RICARICA_TIMEOUT_MS + ' ms.');
          bpEsito = { stato: 'rete', dettaglio: 'nessuna risposta dopo ' + BP_RICARICA_TIMEOUT_MS + ' ms' };
        }
        if (!bpEsito) bpEsito = { stato: 'rete', dettaglio: 'esito sconosciuto' };
        bpModulo.bpRicaricaStato = bpEsito.stato;
        bpModulo.bpRicaricaDettaglio = bpEsito.dettaglio;
        if (bpEsito.stato === 'rete') bpModulo.bpRicaricaEraRete = true;
        bpModulo.bpRicaricaInCorso = false;
        /* I dati sono arrivati dopo una caduta: gli avvisi di rete in attesa
           partono come "Recuperato", notifica normale. */
        if (bpEsito.stato === 'ok') {
          try { bpModulo.bpChiudiAvvisiRete('recuperato'); } catch (bpErrore) { /* niente */ }
        }
        return bpRiuscita;
      });
      return this.bpRicaricaPromessa;
    }

    /* Ricarica e poi ridisegno: e' quello che fa bpUpdate quando la variante
       manca, e quello che fanno le riprove automatiche dopo una caduta. */
    bpRicaricaERidisegna() {
      const bpModulo = this;
      return this.bpRicaricaProdotto().then(function () {
        try { bpModulo.bpUpdate(); } catch (bpErrore) { /* il clic ricalcola comunque */ }
        if (bpModulo.bpRicalcoloInAttesa && bpModulo.bpCurrentVariant) bpModulo.bpAvvisaRicalcolo(bpModulo.bpRicalcoloInAttesa);
      });
    }

    /* Dopo una caduta per la rete il modulo riprova da solo, al massimo
       BP_RICARICA_RIPROVE_MS.length volte, e subito quando il telefono
       torna online. Un timer alla volta. Se nel frattempo la variante si
       trova (riprova riuscita, o il cliente cambia scelta) non succede
       niente: bpUpdate non richiama questa funzione. */
    bpProgrammaRiprovaRicarica() {
      const bpModulo = this;
      if (!this.bpAscoltaOnline) {
        this.bpAscoltaOnline = true;
        window.addEventListener('online', function () {
          if (bpModulo.bpRicaricaStato !== 'rete' || bpModulo.bpCurrentVariant) return;
          clearTimeout(bpModulo.bpRiprovaTimer);
          bpModulo.bpRiprovaTimer = null;
          bpModulo.bpRicaricaERidisegna();
        });
      }
      if (this.bpRiprovaTimer || this.bpRicaricaStato !== 'rete') return;
      const bpFatte = this.bpRiprovaAutomatiche || 0;
      if (bpFatte >= BP_RICARICA_RIPROVE_MS.length) {
        /* Anche la riprova dei 10 secondi e' caduta: l'avviso in attesa
           parte rosso. */
        this.bpChiudiAvvisiRete('esaurite');
        return;
      }
      this.bpRiprovaTimer = setTimeout(function () {
        bpModulo.bpRiprovaTimer = null;
        bpModulo.bpRiprovaAutomatiche = bpFatte + 1;
        if (bpModulo.bpRicaricaStato === 'rete' && !bpModulo.bpCurrentVariant) bpModulo.bpRicaricaERidisegna();
      }, BP_RICARICA_RIPROVE_MS[bpFatte]);
    }

    /* LA VARIANTE DI ADESSO, dalla pagina e non dalla memoria del modulo:
       strati 1-4 sulle scelte in pagina e, se non basta, il prodotto
       riscaricato (strato 5). null se manca una scelta o se non si trova. */
    async bpVarianteSicura() {
      if (this.bpScelteIncomplete()) return null;
      const bpTrovata = this.bpFindVariant(this.bpLeggiScelte());
      if (bpTrovata) return bpTrovata;
      const bpNuovo = await this.bpRicaricaProdotto();
      if (!bpNuovo || this.bpScelteIncomplete()) return null;
      return this.bpFindVariant(this.bpLeggiScelte());
    }

    /* --- prezzo e stato ------------------------------------------------- */

    bpFormatPrice(bpCents) {
      /* Shopify espone i prezzi in centesimi: 1490 -> €14,90 */
      return this.bpMoney.format(bpCents / 100);
    }

    /* IL PREZZO IN ALTO DELLA PAGINA, cioe' il blocco price del tema, che
       sta FUORI da questo custom element: si cerca nel document, non in
       this, altrimenti non lo si trova.
       Lo teneva aggiornato Optis, coi ganci bss-po-* che sono ancora nel
       markup di snippets/price.liquid. Da quando Optis e' spento non li
       legge piu' nessuno e il prezzo in alto restava fermo al cambio
       variante, mentre quello qui dentro cambiava: due numeri diversi
       sulla stessa pagina.
       IL BADGE NON SI TOCCA: sui prodotti di oggi e' quello "custom", con
       il testo scritto a mano nel theme editor, e il CSS del badge custom
       non dipende da price--on-sale. Resta quello che e', come deve.
       IL FORMATO DEVE COINCIDERE con quello del render server: vedi la
       nota lunga su bpCreateMoneyFormatter. Se un domani si cambia la
       formattazione valuta nelle impostazioni Shopify, va cambiata anche
       li', altrimenti il prezzo torna a lampeggiare al caricamento.
       DIFENSIVA SU TUTTO: se il blocco price non c'e' in pagina, o ha un
       markup diverso da quello atteso, si esce senza fare niente. Questa
       funzione non deve mai impedire l'aggiornamento del prezzo del
       configuratore, che e' quello che il cliente paga davvero. */
    bpAggiornaPrezzoTema(bpVariant) {
      if (!bpVariant) return;
      /* La pillola sotto il numero legge QUESTA variante (vedi
         bpAggiornaPillolaNumero): e' quella del prezzo in alto. */
      this.bpVariantePrezzoAlto = bpVariant;
      const bpContenitori = document.querySelectorAll('.product-page-price');
      if (bpContenitori.length === 0) return;

      /* Sconto solo se il confronto e' un numero VERO e maggiore del
         prezzo: compare_at_price assente arriva come null dal liquid, e
         null > numero e' falso, ma il controllo esplicito dice perche'. */
      const bpHaSconto = typeof bpVariant.compare_at_price === 'number'
        && bpVariant.compare_at_price > bpVariant.price;

      bpContenitori.forEach(function (bpBox) {
        /* Il prezzo corrente e' scritto in DUE punti dal tema: il ramo
           "regular" e il ramo "sale" portano lo STESSO valore, ognuno
           col suo span bss-po-product-price (attributo vuoto, non un
           valore da leggere). Il CSS ne mostra uno solo a seconda del
           layout, ma si aggiornano tutti e due, cosi' qualunque ramo sia
           visibile porta il numero giusto. */
        bpBox.querySelectorAll('[bss-po-product-price]').forEach(function (bpEl) {
          bpEl.textContent = this.bpFormatPrice(bpVariant.price);
        }, this);

        /* Il barrato: un <s> con bss-po-product-compare-price, dentro
           .price__compare-price dentro .price__sale. Su un prodotto che
           non va MAI in sconto (nessuna variante con compare_at_price) il
           tema puo' non avere affatto questo markup: querySelector torna
           null e non si scrive niente, nessun errore. */
        const bpBarrato = bpBox.querySelector('[bss-po-product-compare-price]')
          || bpBox.querySelector('.price__compare-price .price-item--regular')
          || bpBox.querySelector('.price__compare-price');
        if (bpBarrato) {
          if (bpHaSconto) {
            bpBarrato.textContent = this.bpFormatPrice(bpVariant.compare_at_price);
            bpBarrato.style.visibility = 'visible';
          } else {
            /* Niente sconto su questa variante: il barrato SPARISCE, non
               resta col valore della variante di prima. La visibilita' qui
               e' gestita da style="visibility" sul singolo elemento (vedi
               il markup live), non da display legato a una classe sul
               contenitore: si tocca solo quella, senza toccare classi. */
            bpBarrato.style.visibility = 'hidden';
          }
        }
      }, this);

      /* L'etichetta sotto il prezzo prende QUI la stessa variante appena
         scritta nel prezzo: nessun'altra strada la tocca. */
      this.bpAggiornaEtichettaPrezzo(bpVariant);
    }

    /* ETICHETTA SOTTO IL PREZZO IN ALTO ("per 3 personaggi · Cornice
       21x30"), dal blocco blocks/bp-etichetta-prezzo.liquid, che sta FUORI
       da questo custom element: si cerca nel document. Blocco assente
       (spento o non montato): non si fa niente.
       I NOMI CORTI NON STANNO QUI: il blocco li stampa in
       data-bp-etichetta-formati come mappa {valore Shopify: nome corto}.
       Nome corto vuoto o assente: solo "per N personaggi". Variante che non
       ha due opzioni o mappa illeggibile: etichetta nascosta, mai un testo
       che non corrisponde al prezzo. */
    bpAggiornaEtichettaPrezzo(bpVariant) {
      const bpEtichette = document.querySelectorAll('[data-bp-etichetta-prezzo]');
      if (bpEtichette.length === 0) return;
      const bpOpzioni = bpVariant && Array.isArray(bpVariant.options) ? bpVariant.options : null;
      bpEtichette.forEach(function (bpEl) {
        const bpTestoEl = bpEl.querySelector('[data-bp-etichetta-testo]');
        if (!bpTestoEl) return;
        /* Da qui l'etichetta e' nostra: il posto tenuto libero dal server
           (vedi data-bp-etichetta-attesa) si libera, qualunque cosa segua. */
        bpEl.removeAttribute('data-bp-etichetta-attesa');
        if (!bpOpzioni || bpOpzioni.length !== 2 || typeof bpOpzioni[0] !== 'string' || bpOpzioni[0].trim() === '') {
          bpEl.hidden = true;
          return;
        }
        let bpMappa;
        try {
          bpMappa = JSON.parse(bpEl.getAttribute('data-bp-etichetta-formati') || '{}');
        } catch (bpErrore) {
          console.warn('[bp-configuratore] Etichetta prezzo nascosta: nomi corti illeggibili.');
          bpEl.hidden = true;
          return;
        }
        const bpCorto = bpMappa && typeof bpMappa[bpOpzioni[1]] === 'string' ? bpMappa[bpOpzioni[1]].trim() : '';
        /* "SOLO IL FORMATO" (prezzo unico): l'etichetta dice il nome corto e
           nient'altro, senza "per N personaggi". Nome corto vuoto: niente
           da dire, e l'etichetta non compare (mai un guscio vuoto). */
        if (bpEl.hasAttribute('data-bp-etichetta-solo-formato')) {
          bpTestoEl.textContent = bpCorto;
          bpEl.hidden = bpCorto === '';
          return;
        }
        const bpPer = bpEl.getAttribute('data-bp-etichetta-per') || 'per';
        bpTestoEl.textContent = bpPer + ' ' + bpOpzioni[0].trim().toLowerCase() + (bpCorto ? ' · ' + bpCorto : '');
        bpEl.hidden = false;
      });
    }

    /* --- riquadro totale sopra il bottone -------------------------------- */

    /* Un prezzo in centesimi, letto da un dato stampato dal Liquid (quindi
       da Shopify). Vuoto, negativo o non intero: null, MAI zero. Uno zero
       inventato darebbe un totale sbagliato ma plausibile, il peggio. */
    bpCentesimiDa(bpValore) {
      if (bpValore === undefined || bpValore === null || String(bpValore).trim() === '') return null;
      const bpNumero = Number(bpValore);
      return Number.isInteger(bpNumero) && bpNumero >= 0 ? bpNumero : null;
    }

    /* Gli extra accesi ADESSO, con la STESSA decisione che prende il
       bottone al click: Saltacoda da this.bpSaltacoda (bpAddSaltacoda),
       Sfondo personalizzato da bpIsSfondoCustomSelezionato
       (bpAddSfondoCustom). Prezzi dagli attributi data-bp-*-price, che il
       Liquid scrive accanto all'id della stessa variante che finisce nel
       carrello. Un extra acceso senza prezzo leggibile rende null: il
       riquadro si nasconde, mai un totale che non torna col carrello. */
    bpExtraAttivi() {
      const bpVoci = [
        { chiave: 'Saltacoda', attivo: this.bpSaltacoda === true },
        { chiave: 'SfondoCustom', attivo: this.bpIsSfondoCustomSelezionato() },
      ];
      const bpExtra = [];
      for (const bpVoce of bpVoci) {
        if (!bpVoce.attivo) continue;
        const bpPrezzo = this.bpCentesimiDa(this.dataset['bp' + bpVoce.chiave + 'Price']);
        if (bpPrezzo === null) {
          console.warn('[bp-configuratore] Totale nascosto: prezzo non trovato per l\'extra ' + bpVoce.chiave + '.');
          return null;
        }
        /* Barrato dell'extra: il suo compare_at se c'e' ed e' piu' alto,
           altrimenti il suo prezzo (regola del Capitano). */
        const bpConfronto = this.bpCentesimiDa(this.dataset['bp' + bpVoce.chiave + 'Compare']);
        bpExtra.push({
          nome: this.dataset['bp' + bpVoce.chiave + 'Nome'] || bpVoce.chiave,
          prezzo: bpPrezzo,
          barrato: bpConfronto !== null && bpConfronto > bpPrezzo ? bpConfronto : bpPrezzo,
        });
      }
      return bpExtra;
    }

    /* Riscrive il riquadro. Si chiama a ogni cambio che tocca il prezzo:
       variante (bpUpdate, entrambi i rami), Saltacoda (bpSetSaltacoda),
       sfondo (bpSetSfondo). Qualunque dato mancante o strano: riquadro
       nascosto e console.warn, mai un NaN o un totale sbagliato a vista.
       NON tocca il bottone: legge soltanto. */
    bpAggiornaTotale() {
      const bpBox = this.bpTotaleEl;
      if (!bpBox) return;
      const bpNascondi = (bpMotivo) => {
        bpBox.hidden = true;
        if (bpMotivo) console.warn('[bp-configuratore] Totale nascosto: ' + bpMotivo);
      };
      try {
        const bpExtra = this.bpExtraAttivi();
        if (bpExtra === null) return bpNascondi(null);
        const bpSommaExtra = bpExtra.reduce(function (bpSomma, bpVoce) { return bpSomma + bpVoce.prezzo; }, 0);
        const bpScelte = this.bpLeggiScelte();
        const bpIncomplete = bpScelte.indexOf(null) !== -1;
        const bpEtichetta = bpBox.dataset.bpTotaleEtichetta || 'Totale';
        const bpInvitoEl = bpBox.querySelector('[data-bp-totale-invito]');
        const bpPrezziEl = bpBox.querySelector('[data-bp-totale-prezzi]');

        if (bpIncomplete) {
          /* PRIMA DELLA SCELTA COMPLETA: NESSUNA CIFRA. Un "Totale da" col
             minimo del catalogo non descriveva niente di quello che il
             cliente stava guardando. Si vede "Totale" e, in grigio al posto
             della cifra, cosa manca: tutto, il formato (il modello sulla
             Cover) o il numero. Niente barrato, niente Risparmi. */
          const bpNumeroScelto = bpScelte[0] !== null;
          const bpAltroScelto = bpScelte.slice(1).some(function (bpValore) { return bpValore !== null; });
          let bpInvito;
          if (bpNumeroScelto) bpInvito = bpBox.dataset.bpTotaleScegliFormato || 'scegli il formato';
          else if (bpAltroScelto) bpInvito = bpBox.dataset.bpTotaleScegliNumero || 'scegli il numero';
          else bpInvito = bpBox.dataset.bpTotaleScegliTutto || 'scegli numero e formato';
          bpBox.querySelector('[data-bp-totale-testo]').textContent = bpEtichetta;
          if (bpInvitoEl) {
            bpInvitoEl.textContent = bpInvito;
            bpInvitoEl.hidden = false;
          }
          if (bpPrezziEl) bpPrezziEl.hidden = true;
          bpBox.hidden = false;
          return;
        }

        let bpTotale;
        let bpBarrato = null;
        /* Qui arrivano anche sfondo e Saltacoda: se un radio e' stato spuntato
           senza "change" la variante in memoria e' vecchia, e il riquadro
           sparirebbe o mostrerebbe il prezzo di prima. Prima si registra la
           scelta (bpRicalcolaSeServe, che ripassa di qui con i dati giusti). */
        if (this.bpRicalcolaSeServe('sfondo o Saltacoda')) return;
        const bpVariant = this.bpCurrentVariant;
        /* Scelte complete ma combinazione inesistente: l'avviso rosso lo
           mostra gia' bpUpdate, qui si tace e si nasconde. */
        if (!bpVariant) return bpNascondi(null);
        const bpPrezzo = this.bpCentesimiDa(bpVariant.price);
        if (bpPrezzo === null) return bpNascondi('prezzo della variante ' + bpVariant.id + ' non leggibile.');
        bpTotale = bpPrezzo + bpSommaExtra;
        const bpConfronto = this.bpCentesimiDa(bpVariant.compare_at_price);
        if (bpConfronto !== null && bpConfronto > bpPrezzo) {
          bpBarrato = bpConfronto + bpExtra.reduce(function (bpSomma, bpVoce) { return bpSomma + bpVoce.barrato; }, 0);
        }
        if (!Number.isInteger(bpTotale) || bpTotale < 0) return bpNascondi('totale non valido.');
        const bpTestoTotale = this.bpFormatPrice(bpTotale);
        if (typeof bpTestoTotale !== 'string' || bpTestoTotale === '' || /NaN|undefined/.test(bpTestoTotale)) {
          return bpNascondi('formato del totale non valido.');
        }

        bpBox.querySelector('[data-bp-totale-testo]').textContent = bpEtichetta;
        if (bpInvitoEl) bpInvitoEl.hidden = true;
        if (bpPrezziEl) bpPrezziEl.hidden = false;
        bpBox.querySelector('[data-bp-totale-valore]').textContent = bpTestoTotale;

        /* Il riquadro mostra solo etichetta, barrato e totale. Il riepilogo
           delle scelte e la riga "Risparmi" non ci sono piu': la differenza
           si legge dal barrato accanto al totale. */
        const bpBarratoEl = bpBox.querySelector('[data-bp-totale-barrato]');
        if (bpBarrato !== null && bpBarrato > bpTotale) {
          bpBarratoEl.textContent = this.bpFormatPrice(bpBarrato);
          bpBarratoEl.hidden = false;
        } else {
          bpBarratoEl.hidden = true;
        }
        bpBox.hidden = false;
      } catch (bpErrore) {
        bpNascondi('errore inatteso ' + (bpErrore && bpErrore.message ? bpErrore.message : bpErrore));
      }
    }

    /* --- prezzi dentro i passi ------------------------------------------ */

    /* Accesi dall'editor ("Mostra prezzo sulle card", attributo sulla
       radice) e solo sui prodotti a DUE opzioni: numero, poi formato o
       modello o quantita'. Per altri prodotti non c'e' un "passo 2" da
       prezzare e non si fa niente. */
    bpPrezziCardAttivi() {
      return this.hasAttribute('data-bp-prezzi-card')
        && !!this.bpProduct
        && Array.isArray(this.bpProduct.options)
        && this.bpProduct.options.length === 2;
    }

    /* Prezzo in centesimi della variante con queste scelte. Variante che
       non esiste o prezzo illeggibile: null e console.warn, mai un numero
       inventato. */
    bpPrezzoDiScelte(bpScelte) {
      const bpVariante = this.bpFindVariant(bpScelte);
      if (!bpVariante) {
        console.warn('[bp-configuratore] Prezzo sulla card: nessuna variante per ' + bpScelte.join(' / ') + '.');
        return null;
      }
      const bpCentesimi = this.bpCentesimiDa(bpVariante.price);
      if (bpCentesimi === null) {
        console.warn('[bp-configuratore] Prezzo sulla card: prezzo non leggibile per la variante ' + bpVariante.id + '.');
      }
      return bpCentesimi;
    }

    /* Il numero di personaggi con cui prezzare le card: quello scelto, o
       se non c'e' ancora il PRIMO valore del selettore (1 personaggio),
       letto dal DOM nell'ordine di Shopify. */
    bpNumeroPerPrezzi() {
      const bpScelta = this.bpLeggiScelte()[0];
      if (bpScelta != null) return bpScelta;
      const bpRadio = this.querySelector('input[type="radio"][data-bp-option-index="0"]');
      if (bpRadio) return bpRadio.value;
      const bpSelect = this.querySelector('select[data-bp-option-index="0"]');
      if (bpSelect) {
        const bpPrima = Array.prototype.find.call(bpSelect.options, function (bpOpt) { return bpOpt.value !== ''; });
        if (bpPrima) return bpPrima.value;
      }
      return null;
    }

    /* Scrive il prezzo su ogni scelta del secondo selettore, per il numero
       di personaggi di bpNumeroPerPrezzi. Vale per schede e pillole: hanno
       il loro posto [data-bp-prezzo-scelta] (dal Liquid). La tendina NON ha
       prezzi: una <option> non impagina niente e il nome del modello deve
       restare quello di Shopify, tale e quale.
       LO SBARRATO sta sotto il prezzo, nel suo posto [data-bp-barrato-scelta]
       (il Liquid lo stampa solo con "Mostra prezzo barrato sulle card").
       Il valore e' il compare_at_price DELLA VARIANTE DI QUELLA CARD, come
       lo passa Shopify, mai calcolato. Compare solo se e' un numero vero e
       piu' alto del prezzo; altrimenti il posto si svuota e si nasconde,
       cosi' non resta lo sbarrato del numero di prima.
       Prezzo mancante: posto vuoto, mai un simbolo da solo. */
    bpAggiornaPrezziScelte() {
      if (!this.bpPrezziCardAttivi()) return;
      const bpNumero = this.bpNumeroPerPrezzi();
      if (bpNumero == null) return;
      const bpModulo = this;
      const bpTestoDi = function (bpCentesimi) {
        if (bpCentesimi === null) return '';
        const bpTesto = bpModulo.bpFormatPrice(bpCentesimi);
        return (typeof bpTesto === 'string' && !/NaN|undefined/.test(bpTesto)) ? bpTesto : '';
      };
      this.querySelectorAll('input[type="radio"][data-bp-option-index="1"]').forEach(function (bpRadio) {
        const bpLabel = bpRadio.closest('label');
        if (!bpLabel) return;
        const bpCentesimi = bpModulo.bpPrezzoDiScelte([bpNumero, bpRadio.value]);
        const bpPosto = bpLabel.querySelector('[data-bp-prezzo-scelta]');
        if (bpPosto) bpPosto.textContent = bpTestoDi(bpCentesimi);
        const bpBarrato = bpLabel.querySelector('[data-bp-barrato-scelta]');
        if (bpBarrato) {
          const bpVariante = bpModulo.bpFindVariant([bpNumero, bpRadio.value]);
          const bpConfronto = bpVariante ? bpModulo.bpCentesimiDa(bpVariante.compare_at_price) : null;
          const bpTesto = (bpCentesimi !== null && bpConfronto !== null && bpConfronto > bpCentesimi)
            ? bpTestoDi(bpConfronto)
            : '';
          bpBarrato.textContent = bpTesto;
          bpBarrato.hidden = bpTesto === '';
        }
      });
    }

    /* La variante col prezzo piu' basso fra quelle di questo numero di
       personaggi. Legge TUTTE le varianti, non solo le disponibili, perche'
       le card del passo 2 mostrano tutte le varianti e il prezzo in alto
       deve coincidere con la card piu' economica. A parita' di prezzo vale
       la prima, nell'ordine di Shopify (lo stesso delle card). null e
       console.warn se non se ne legge nessuna. */
    bpVariantePiuEconomicaPer(bpNumero) {
      let bpMigliore = null;
      let bpMinimo = null;
      (this.bpProduct.variants || []).forEach(function (bpV) {
        if (!Array.isArray(bpV.options) || bpV.options[0] !== bpNumero) return;
        const bpC = this.bpCentesimiDa(bpV.price);
        if (bpC === null) return;
        if (bpMinimo === null || bpC < bpMinimo) {
          bpMinimo = bpC;
          bpMigliore = bpV;
        }
      }, this);
      if (!bpMigliore) {
        console.warn('[bp-configuratore] Prezzo in alto: nessuna variante con prezzo per ' + bpNumero + '.');
      }
      return bpMigliore;
    }

    /* SCELTA A META': c'e' il numero o c'e' il formato, non tutti e due.
       Il prezzo in alto (con sbarrato ed etichetta, che passano da
       bpAggiornaPrezzoTema) deve dire la stessa variante che il cliente
       vede evidenziata, mai quella di partenza.
       - SOLO NUMERO: la variante piu' economica per quel numero, senza
         "da". Prima restava quella di partenza (1 personaggio) mentre le
         card mostravano gia' i prezzi del numero scelto.
       - SOLO FORMATO: 1 personaggio + QUEL formato, cioe' esattamente il
         prezzo della card selezionata, che per il numero mancante usa
         bpNumeroPerPrezzi (il primo valore del selettore). Prima restava la
         variante di partenza: sul Puzzle "Puzzle + Cornice" scelto e in
         alto €44,90 "per 1 personaggio · Puzzle" invece di €54,90.
       Quando il cliente sceglie anche l'altro, la strada normale di
       bpUpdate riscrive tutto con la variante scelta.
       Solo prodotti a DUE opzioni (numero, poi formato): con altre forme
       non c'e' un "numero" da cui partire e non si tocca niente. Se non e'
       scelto niente il prezzo resta com'e', il prezzo delle inserzioni non
       sparisce sotto gli occhi di chi arriva. */
    bpPrezzoPerSceltaParziale() {
      if (!this.bpProduct || !Array.isArray(this.bpProduct.options) || this.bpProduct.options.length !== 2) return;
      const bpScelte = this.bpLeggiScelte();
      const bpNumero = bpScelte[0];
      const bpFormato = bpScelte[1];
      let bpVariante = null;
      if (bpNumero != null) {
        bpVariante = this.bpVariantePiuEconomicaPer(bpNumero);
      } else if (bpFormato != null) {
        const bpPrimoNumero = this.bpNumeroPerPrezzi();
        bpVariante = bpPrimoNumero != null ? this.bpFindVariant([bpPrimoNumero, bpFormato]) : null;
        if (!bpVariante) {
          console.warn('[bp-configuratore] Prezzo in alto: nessuna variante per ' + bpPrimoNumero + ' / ' + bpFormato + '.');
        }
      } else {
        /* Niente scelto: il prezzo resta quello del server, tranne con dei
           formati nascosti. Il server non lo sa e parte dalla prima variante
           disponibile, che puo' essere proprio quella nascosta (il Digitale):
           il suo prezzo in alto, con la sua etichetta, non deve vedersi. Si
           scrive la variante piu' economica visibile del primo numero. */
        if (!Array.isArray(this.bpFormatiNascosti) || this.bpFormatiNascosti.length === 0) return;
        const bpPrimoNumero = this.bpNumeroPerPrezzi();
        bpVariante = bpPrimoNumero != null ? this.bpVariantePiuEconomicaPer(bpPrimoNumero) : null;
      }
      if (!bpVariante) return;
      this.bpPriceEl.textContent = this.bpFormatPrice(bpVariante.price);
      this.bpPriceEl.hidden = false;
      this.bpAggiornaPrezzoTema(bpVariante);
    }
    bpUpdate() {
      /* Le scelte che il modulo ha visto: bpScelteNonRegistrate le confronta
         con quelle in pagina. Per primissima cosa, cosi' niente di quello che
         segue puo' far ripartire il ricalcolo. */
      this.bpScelteViste = JSON.stringify(this.bpLeggiScelte());
      const bpSelected = this.bpGetSelectedOptions();
      const bpVariant = bpSelected ? this.bpFindVariant(bpSelected) : null;

      /* Si riparte da zero a ogni giro: se in questo giro il prezzo in alto
         non viene riscritto, la pillola sotto il numero non mostra niente. */
      this.bpVariantePrezzoAlto = null;
      this.bpCurrentVariant = bpVariant;
      this.bpHideError();
      /* L'eco dei selettori a numeri si riallinea QUI, PRIMA del bivio qui
         sotto: deve aggiornarsi sia quando la variante si trova sia quando
         manca ancora un pezzo, e i due rami non si incontrano piu' dopo.
         Vale anche per il ripristino della pagina: al ritorno indietro il
         browser rimette i radio spuntati e connectedCallback chiude
         chiamando bpUpdate, che passa di qui e riscrive l'eco. */
      this.bpAggiornaEcoNumeri();
      /* Anche i prezzi sulle card del passo 2 seguono il numero scelto, in
         tutti e due i rami qui sotto. */
      this.bpAggiornaPrezziScelte();

      if (!bpVariant) {
        this.removeAttribute('data-bp-variant-id');
        /* DUE MOTIVI DIVERSI PER NON AVERE UNA VARIANTE, e due modi
           diversi di dirlo.
           A) Il cliente non ha ancora scelto (bpSelected null). Non e' un
              guasto, e' il modulo appena aperto: nessun avviso, e
              soprattutto IL PREZZO RESTA DOV'E'. Lo span esce dal server
              col prezzo della variante di partenza, il 14,90 delle ads:
              nasconderlo o azzerarlo qui vorrebbe dire far sparire sotto
              gli occhi del cliente il numero per cui ha cliccato
              sull'inserzione. Non si tocca finche' una scelta vera non
              porta un prezzo nuovo.
           B) Il cliente ha scelto tutto ma quella combinazione non esiste
              a catalogo. Questo si', e' il caso per cui l'avviso e'
              nato, e li' il prezzo si nasconde come ha sempre fatto:
              mostrare un numero che non appartiene a niente sarebbe
              peggio del non mostrarlo. */
        /* STRATO 5 PRIMA DELLA RIGA ROSSA (14/10/2026): scelte complete e
           nessuna variante nemmeno con ID, testo normalizzato e parole
           chiave. Prima di dirlo al cliente e al Capitano si riscarica il
           prodotto da Shopify, una volta per pagina: intanto niente riga e
           niente avviso, e al ritorno bpUpdate riparte da capo. Se anche
           cosi' non si trova, si va avanti come sempre. */
        /* TRE ESITI DELLA RICARICA, TRE COSE DIVERSE (30/10/2026):
           - mai tentata o in corso: niente riga e niente prezzo, si aspetta
             (se e' una riprova dopo una caduta resta la riga della rete,
             invece di sparire e ricomparire);
           - caduta per la rete: "Connessione lenta, riprova tra qualche
             secondo." e il modulo riprova da solo. Non e' la combinazione
             a mancare, e dirlo al cliente lo mandava via;
           - riuscita o prodotto assente su Shopify, e la variante manca lo
             stesso: e' davvero la combinazione, riga rossa di sempre. */
        const bpStatoRicarica = this.bpRicaricaStato || 'mai';
        if (bpSelected && (bpStatoRicarica === 'mai' || bpStatoRicarica === 'in corso')) {
          if (bpStatoRicarica === 'mai') this.bpRicaricaERidisegna();
          this.bpPriceEl.hidden = true;
          if (this.bpRicaricaEraRete) this.bpShowMessage(this.dataset.bpTextRete || BP_TESTO_RETE_LENTA);
          else this.bpHideMessage();
        } else if (bpSelected && bpStatoRicarica === 'rete') {
          this.bpPriceEl.hidden = true;
          this.bpShowMessage(this.dataset.bpTextRete || BP_TESTO_RETE_LENTA);
          this.bpAvvisaVarianteNonTrovata(bpSelected, 'riga in pagina, prima del click');
          this.bpProgrammaRiprovaRicarica();
        } else if (bpSelected) {
          this.bpPriceEl.hidden = true;
          this.bpShowMessage(this.dataset.bpTextUnavailable || 'Combinazione non disponibile.');
          /* Il cliente vede la riga rossa anche senza premere il bottone:
             il Capitano lo deve sapere subito, con tutto lo stato. Una
             volta sola per combinazione e per pagina, non a ogni tocco. */
          this.bpAvvisaVarianteNonTrovata(bpSelected, 'riga rossa in pagina, prima del click');
        } else {
          this.bpHideMessage();
          this.bpPrezzoPerSceltaParziale();
        }
        this.bpRefreshFotoState();
        this.bpEmitVariantChange(null);
        this.bpAggiornaTotale();
        this.bpAggiornaPillolaNumero();
        return;
      }

      this.setAttribute('data-bp-variant-id', String(bpVariant.id));
      this.bpPriceEl.textContent = this.bpFormatPrice(bpVariant.price);
      this.bpPriceEl.hidden = false;
      this.bpAggiornaPrezzoTema(bpVariant);
      this.bpAggiornaTotale();

      if (bpVariant.available === false) {
        this.bpShowMessage(this.dataset.bpTextSoldout || 'Al momento esaurito.');
      } else {
        this.bpHideMessage();
      }

      /* il cambio personaggi può cambiare il massimo foto:
         si riallineano contatore, avvisi e stato del bottone */
      this.bpRefreshFotoState();
      this.bpEmitVariantChange(bpVariant);
      this.bpAggiornaPillolaNumero();
    }

    /* PILLOLA COL PREZZO SOTTO IL NUMERO ("€39,90 con Cornice 21x30").
       Il prezzo e' quello del prezzo in alto, per costruzione: la variante
       e' quella che bpAggiornaPrezzoTema ha appena scritto lassu' in questo
       stesso giro di bpUpdate, e si formatta con la stessa espressione
       (bpFormatPrice di variant.price). Nessun calcolo nuovo.
       Si vede SOLO se il formato e' scelto (o preselezionato) e la variante
       del prezzo in alto e' proprio di quel formato. Formato non scelto,
       prezzo in alto non riscritto, prezzo illeggibile: nascosta e vuota,
       mai una pillola vuota o con un prezzo che non torna.
       IL NOME CORTO viene dal blocco etichetta sotto il prezzo
       (data-bp-etichetta-formati, anche quando l'etichetta e' spenta): un
       posto solo per i nomi. Nome mancante: solo il prezzo. */
    bpAggiornaPillolaNumero() {
      const bpPillola = this.querySelector('[data-bp-numeri-pillola]');
      if (!bpPillola) return;
      const bpPrezzoEl = bpPillola.querySelector('[data-bp-numeri-pillola-prezzo]');
      const bpFormatoEl = bpPillola.querySelector('[data-bp-numeri-pillola-formato]');
      const bpNascondi = function () {
        bpPillola.hidden = true;
        if (bpPrezzoEl) bpPrezzoEl.textContent = '';
        if (bpFormatoEl) bpFormatoEl.textContent = '';
      };
      const bpVariante = this.bpVariantePrezzoAlto;
      const bpFormato = this.bpLeggiScelte()[1];
      if (!bpPrezzoEl || !bpFormatoEl || !bpVariante || bpFormato == null
          || !Array.isArray(bpVariante.options) || bpVariante.options[1] !== bpFormato) {
        bpNascondi();
        return;
      }
      const bpPrezzo = this.bpFormatPrice(bpVariante.price);
      if (typeof bpPrezzo !== 'string' || bpPrezzo.trim() === '' || /NaN|undefined/.test(bpPrezzo)) {
        bpNascondi();
        return;
      }
      let bpCorto = '';
      const bpNomi = document.querySelector('[data-bp-etichetta-formati]');
      if (bpNomi) {
        try {
          const bpMappa = JSON.parse(bpNomi.getAttribute('data-bp-etichetta-formati') || '{}');
          if (bpMappa && typeof bpMappa[bpFormato] === 'string') bpCorto = bpMappa[bpFormato].trim();
        } catch (bpErrore) {
          bpCorto = '';
        }
      }
      bpPrezzoEl.textContent = bpPrezzo;
      bpFormatoEl.textContent = bpCorto ? (bpPillola.getAttribute('data-bp-numeri-pillola-con') || 'con') + ' ' + bpCorto : '';
      bpPillola.hidden = false;
    }

    /* I TESTI SOTTO I BOTTONI A NUMERI, un gruppetto per ogni selettore
       reso in quello stile: l'eco della scelta e, sotto, la riga in piu'
       che riguarda la sola opzione col piu'.
       I TESTI FISSI NON STANNO QUI: guida, coda e riga extra arrivano dal
       liquid dentro tre template nascosti, cosi' restano governati dal
       theme editor e in questo file non c'e' nessuna frase italiana
       scritta a mano da mantenere allineata. Sono campi in cui il
       Capitano puo' mettere grassetto, corsivo e collegamenti, quindi
       quello che ne esce e' HTML e come HTML va messo in pagina.
       IL VALORE DELLA VARIANTE NO, QUELLO E' TESTO. Arriva da Shopify,
       non da noi, e va aggiunto come nodo di testo: se lo si incollasse
       nell'HTML insieme al resto, un nome di variante con dentro una
       parentesi angolare finirebbe interpretato come markup. Il confine
       fra le due cose e' tutto qui, ed e' voluto.
       IL MINUSCOLO E' TUTTA LA TRASFORMAZIONE sul valore: arriva con
       l'iniziale maiuscola ("2 Personaggi") e dentro la frase va in
       minuscolo ("2 personaggi da disegnare"). Singolare e plurale non si
       calcolano e non si indovinano: sono gia' nel nome della variante, e
       abbassare le maiuscole non li tocca.
       LA RIGA EXTRA NON RIFA' LA REGOLA DEL PIU': si limita a guardare se
       il radio scelto porta data-bp-numero-piu, che il liquid ha gia'
       messo al momento giusto. La regola vive in un posto solo, di la'.
       LE SCELTE SI LEGGONO, NON SI CAMBIANO: bpLeggiScelte resta quella
       che e', qui la si interroga soltanto. Se nessun selettore e' a
       numeri non c'e' niente da aggiornare e il metodo esce subito,
       quindi su tutti gli altri prodotti non costa niente. */
    bpAggiornaEcoNumeri() {
      const bpGruppi = this.querySelectorAll('[data-bp-numeri-testi]');
      if (bpGruppi.length === 0) return;
      const bpScelte = this.bpLeggiScelte();
      const bpModulo = this;
      bpGruppi.forEach(function (bpGruppo) {
        const bpPos = parseInt(bpGruppo.getAttribute('data-bp-numeri-testi'), 10);
        const bpScelta = isNaN(bpPos) ? null : bpScelte[bpPos];
        /* L'HTML di un template non e' disegnato e non e' eseguito finche'
           non lo si va a prendere: innerHTML qui legge il testo cosi'
           com'e' stato scritto nell'editor, tag compresi. */
        const bpTestoDi = function (bpNome) {
          const bpTpl = bpGruppo.querySelector('template[' + bpNome + ']');
          return bpTpl ? bpTpl.innerHTML.trim() : '';
        };

        const bpEco = bpGruppo.querySelector('[data-bp-numeri-eco]');
        if (bpEco) {
          if (bpScelta == null) {
            bpEco.innerHTML = bpTestoDi('data-bp-numeri-guida');
          } else {
            bpEco.textContent = '';
            bpEco.appendChild(
              document.createTextNode(String(bpScelta).toLowerCase())
            );
            const bpCoda = bpTestoDi('data-bp-numeri-coda');
            if (bpCoda) {
              bpEco.appendChild(document.createTextNode(' '));
              const bpPezzo = document.createElement('span');
              bpPezzo.innerHTML = bpCoda;
              bpEco.appendChild(bpPezzo);
            }
            /* La frase del numero preselezionato: solo sul selettore dei
               numeri (posizione 0) e solo finche' il numero e' quello messo
               da bpPreselezionaNumero senza che il cliente abbia toccato un
               numero. Il punto chiude la prima frase, poi la seconda. */
            const bpFrase = bpPos === 0 && bpModulo.bpNumeroPreselAttivo === true
              ? bpTestoDi('data-bp-numeri-presel-frase')
              : '';
            if (bpFrase) {
              bpEco.appendChild(document.createTextNode('. '));
              const bpPezzoFrase = document.createElement('span');
              bpPezzoFrase.setAttribute('data-bp-numeri-presel-frase-testo', '');
              bpPezzoFrase.innerHTML = bpFrase;
              bpEco.appendChild(bpPezzoFrase);
            }
          }
        }

        const bpExtra = bpGruppo.querySelector('[data-bp-numeri-extra]');
        if (bpExtra) {
          const bpTestoExtra = bpTestoDi('data-bp-numeri-extra-html');
          const bpSceltoPiu = isNaN(bpPos)
            ? null
            : bpModulo.querySelector(
                'input[data-bp-option-index="' + bpPos + '"]:checked[data-bp-numero-piu]'
              );
          if (bpTestoExtra && bpSceltoPiu) {
            bpExtra.innerHTML = bpTestoExtra;
            bpExtra.hidden = false;
          } else {
            bpExtra.textContent = '';
            bpExtra.hidden = true;
          }
        }
      });
    }

    bpShowMessage(bpText) {
      if (!this.bpUnavailableEl) return;
      this.bpUnavailableEl.textContent = bpText;
      this.bpUnavailableEl.hidden = false;
    }

    bpHideMessage() {
      if (!this.bpUnavailableEl) return;
      this.bpUnavailableEl.hidden = true;
      this.bpUnavailableEl.textContent = '';
    }

    /* --- sfondo (mattone 3) ---------------------------------------------- */

    bpSetSfondo(bpNome) {
      this.bpSfondoNome = bpNome || null;
      if (this.bpSfondoNome) {
        /* attributo ispezionabile, comodo in console e nei test */
        this.setAttribute('data-bp-sfondo', this.bpSfondoNome);
      } else {
        this.removeAttribute('data-bp-sfondo');
      }
      /* la textarea della descrizione esiste solo per il Personalizzato */
      this.bpToggleSfondoDescr();
      this.dispatchEvent(
        new CustomEvent('bp:sfondo-change', {
          bubbles: true,
          detail: { nome: this.bpSfondoNome },
        })
      );
      /* Lo sfondo non passa da bpRefreshAtcState (non blocca il bottone:
         e' facoltativo), quindi la rotta va riallineata qui. */
      this.bpAggiornaRotta();
      /* Lo sfondo personalizzato e' un extra a pagamento: cambia il totale. */
      this.bpAggiornaTotale();
    }

    /* Mostra la descrizione dello sfondo solo quando è selezionato il
       riquadro Personalizzato. Il testo digitato NON viene cancellato
       quando il campo si nasconde: se il cliente ci ripensa due volte
       lo ritrova; conta solo lo stato al momento del click. */
    bpToggleSfondoDescr() {
      const bpWrap = this.querySelector('[data-bp-sfondo-descr-wrap]');
      if (!bpWrap) return;
      bpWrap.hidden = !this.bpIsSfondoCustomSelezionato();
    }

    bpSetSfondoDescr(bpTesto) {
      this.bpSfondoDescr = typeof bpTesto === 'string' ? bpTesto : '';
      this.dispatchEvent(
        new CustomEvent('bp:sfondo-descr-change', {
          bubbles: true,
          detail: { testo: this.bpSfondoDescr },
        })
      );
    }

    /* --- modalità Wanted (mattone 8, BP-MODALITA) -------------------------- */

    bpSetWantedNome(bpTesto) {
      this.bpWantedNome = typeof bpTesto === 'string' ? bpTesto : '';
      this.bpRefreshAtcState();
    }

    bpSetWantedTaglia(bpTesto) {
      this.bpWantedTaglia = typeof bpTesto === 'string' ? bpTesto : '';
      this.bpRefreshAtcState();
    }

    /* I campi Wanted sono attivi: SEMPRE in modalità wanted; nelle
       modalità con interruttore Manifesto (puzzle/portachiavi/cover)
       solo a interruttore acceso; mai altrove. Il DOM è la fonte di
       verità, così lo stato è sempre quello del momento. */
    bpWantedFieldsAttivi() {
      if (this.dataset.bpModalita === 'wanted') return true;
      const bpToggle = this.querySelector('input[data-bp-wanted-toggle]');
      return !!(bpToggle && bpToggle.checked);
    }

    /* Mostra/nasconde i campi Wanted al cambio dell'interruttore.
       Il testo digitato resta in memoria quando si nascondono, ma
       con l'interruttore spento non finisce mai nell'ordine. */
    bpToggleWantedFields() {
      const bpWrap = this.querySelector('[data-bp-wanted-fields]');
      if (bpWrap && this.dataset.bpModalita !== 'wanted') {
        bpWrap.hidden = !this.bpWantedFieldsAttivi();
      }
      this.bpRefreshAtcState();
    }

    /* Se i campi Wanted non sono attivi non blocca mai; se attivi
       richiede il nome compilato (solo spazi = vuoto). La taglia e'
       diventata facoltativa: bpAddToCart la scrive solo se presente
       (bpTagliaPulita, piu' sotto), quindi la sua assenza non deve
       impedire il click. */
    bpIsWantedCompleto() {
      if (!this.bpWantedFieldsAttivi()) return true;
      return (this.bpWantedNome || '').trim() !== '';
    }

    /* Gli elementi del modulo ancora da compilare, in ordine di
       apparizione: prima il nome sul manifesto (se i campi Wanted
       sono attivi ed e' vuoto), poi il contenitore delle foto (se
       vuoto o oltre il massimo). Array vuoto significa modulo
       completo. Selettori gia' presenti nel file: il campo nome si
       cerca fresco con [data-bp-wanted-nome-input], come fa gia'
       bpOnInput; per le foto si segna bpFotoAddEl (data-bp-foto-add,
       gia' in cache dal connectedCallback), cioe' il riquadro
       tratteggiato del caricamento. E' lui e non la griglia delle
       anteprime perche' a zero foto la griglia e' un contenitore
       vuoto senza altezza: un bordo rosso li' non si vedrebbe. */
    bpCampiMancanti() {
      const bpMancanti = [];
      /* I SELETTORI PER PRIMI, perche' stanno in cima al modulo:
         bpSegnalaMancanti porta lo sguardo sul primo elemento
         dell'elenco, e il primo deve essere quello piu' in alto nella
         pagina, altrimenti lo scorrimento salta un passo mancante per
         andare su uno piu' in basso. Si segna il gruppo, non il singolo
         radio: il rosso deve circondare la scelta intera. */
      /* I gruppi si prendono NELL'ORDINE DELLA PAGINA, non dell'indice
         Shopify: con "Formato prima del numero" il gruppo 1 (formato) sta
         sopra il gruppo 0 (numero), e lo sguardo deve andare a quello piu'
         in alto. A spunta spenta i due ordini coincidono. */
      const bpScelte = this.bpLeggiScelte();
      this.querySelectorAll('[data-bp-opzione-gruppo]').forEach(function (bpGruppo) {
        const bpIndex = parseInt(bpGruppo.getAttribute('data-bp-opzione-gruppo'), 10);
        if (isNaN(bpIndex) || bpIndex >= bpScelte.length || bpScelte[bpIndex] != null) return;
        bpMancanti.push(bpGruppo);
      });
      if (this.bpWantedFieldsAttivi()) {
        const bpNomeEl = this.querySelector('[data-bp-wanted-nome-input]');
        if (bpNomeEl && (bpNomeEl.value || '').trim() === '') {
          bpMancanti.push(bpNomeEl);
        }
      }
      const bpCount = this.bpFotoFiles ? this.bpFotoFiles.length : 0;
      const bpMax = this.bpGetMaxFoto();
      if (this.bpFotoAddEl && (bpCount < 1 || bpCount > bpMax)) {
        bpMancanti.push(this.bpFotoAddEl);
      }
      /* Passo 4, ultimo in ordine di apparizione: nessuna delle due
         schede scelta. Si segna il contenitore delle schede, come per le
         foto si segna il riquadro del caricamento. */
      if (this.bpDettagliSchedeEl && !this.bpDettagliModo) {
        bpMancanti.push(this.bpDettagliSchedeEl);
      }
      return bpMancanti;
    }

    /* Segnala in rosso gli elementi mancanti, scrive sotto ognuno la
       sua riga di errore, accende l'avviso sotto il bottone e porta lo
       sguardo sul primo campo. Array vuoto: non fa niente, in
       silenzio.
       COME SI DISTINGUONO I DUE CAMPI: bpCampiMancanti puo' mettere
       nell'array solo due cose, il riquadro delle foto (che e'
       sempre e solo bpFotoAddEl) e l'input del nome. Il confronto per
       identita' con bpFotoAddEl basta a dire quale dei due e', senza
       leggere classi o attributi che un domani potrebbero cambiare. */
    bpSegnalaMancanti(bpElementi) {
      if (!Array.isArray(bpElementi) || bpElementi.length === 0) return;
      /* Il riquadro foto finisce fra i mancanti per due ragioni
         opposte: zero foto oppure troppe. La nostra riga parla SOLO
         del primo caso.
         PERCHE' SUL CASO ECCESSO STIAMO ZITTI: quel caso ce l'ha gia'
         bpRefreshFotoState, che scrive su data-bp-foto-msg un avviso
         piu' preciso del nostro, col numero di foto caricate e col
         massimo. Scrivere anche qui vorrebbe dire due righe rosse
         attaccate che dicono la stessa cosa con parole diverse, e chi
         legge si chiede quale delle due sia quella vera.
         Il bordo rosso invece resta in tutti e due i casi: quello
         indica DOVE guardare, e il posto e' lo stesso. */
      const bpCount = this.bpFotoFiles ? this.bpFotoFiles.length : 0;
      bpElementi.forEach(function (bpEl) {
        bpEl.classList.add('bp-campo-mancante');
        /* I GRUPPI DEI SELETTORI PRENDONO SOLO IL BORDO ROSSO, nessuna
           riga scritta sotto. Il motivo e' lo spazio: quei gruppi stanno
           in cima, uno sopra l'altro, e una riga di testo per ciascuno
           spingerebbe giu' tutto il modulo proprio mentre il cliente sta
           guardando. Cosa manca lo dice gia' l'avviso sotto il bottone,
           e il rosso dice dove.
           STA PRIMA DEGLI ALTRI CONTROLLI di proposito: il ramo finale
           qui sotto e' quello del nome sul manifesto, e senza questa
           uscita anticipata un gruppo di selettori finirebbe li' dentro
           a farsi scrivere "Scrivi il nome sul manifesto". */
        if (bpEl.matches('[data-bp-opzione-gruppo]')) return;
        if (bpEl === this.bpDettagliSchedeEl) {
          this.bpMostraErroreCampo(this.bpErroreDettagliEl, 'Scegli come vuoi i dettagli.');
        } else if (bpEl === this.bpFotoAddEl) {
          if (bpCount === 0) {
            this.bpMostraErroreCampo(this.bpErroreFotoEl, 'Carica almeno una foto.');
          } else {
            /* Niente da dire qui, ma si pulisce lo stesso: un "Carica
               almeno una foto" rimasto da un click precedente sarebbe
               una bugia adesso che le foto ci sono. */
            this.bpNascondiErroreCampo(this.bpErroreFotoEl);
          }
        } else {
          this.bpMostraErroreCampo(this.bpErroreNomeEl, 'Scrivi il nome sul manifesto.');
        }
      }, this);
      this.bpEvidenziaHint();
      bpElementi[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* Le due righe di errore sotto i campi. Difensive sull'elemento:
       un liquid vecchio, senza i due paragrafi, non manda in errore
       il modulo, semplicemente non mostra niente li' sotto. */
    bpMostraErroreCampo(bpEl, bpTesto) {
      if (!bpEl) return;
      bpEl.textContent = bpTesto;
      bpEl.hidden = false;
    }

    bpNascondiErroreCampo(bpEl) {
      if (!bpEl) return;
      bpEl.textContent = '';
      bpEl.hidden = true;
    }

    /* Accende l'avviso sotto il bottone. Il togli e rimetti con la
       lettura di offsetWidth in mezzo serve a far ripartire
       l'animazione anche quando la classe c'era gia': senza quella
       lettura il browser accorpa le due mutazioni in un giro solo e
       la pulsazione non riparte, quindi un secondo click su un
       modulo ancora incompleto non darebbe nessun segnale. */
    bpEvidenziaHint() {
      if (!this.bpAtcHintEl) return;
      this.bpAtcHintEl.classList.remove('bp-hint-allarme');
      void this.bpAtcHintEl.offsetWidth;
      this.bpAtcHintEl.classList.add('bp-hint-allarme');
    }

    /* --- dettagli per gli artisti (mattone 4) ----------------------------- */

    bpSetDettagli(bpTesto) {
      this.bpDettagli = typeof bpTesto === 'string' ? bpTesto : '';
      this.dispatchEvent(
        new CustomEvent('bp:dettagli-change', {
          bubbles: true,
          detail: { testo: this.bpDettagli },
        })
      );
    }

    /* LA SCELTA DEL PASSO 4: "fatevoi" o "scrivo", niente all'inizio.
       Lo stato va sull'attributo data-bp-dettagli-modo dell'elemento
       radice (stessa disciplina di data-bp-saltacoda): la CSS legge di
       li' e accende il riquadro verde o la textarea. Nessun elemento
       viene tolto dal DOM, quindi i selettori del JS trovano sempre
       tutto.
       LA MEMORIA DEL TESTO: passando a "Fate voi" il testo gia' scritto
       si mette da parte e la textarea si svuota, cosi' non resta un
       residuo invisibile che al prossimo giro tornerebbe su da solo;
       tornando su "Scrivo io" il testo si rimette dov'era. Il ripristino
       dal browser (bpDaRipristino) NON svuota niente: li' il valore
       nella textarea e' quello vero, appena restituito dalla cronologia.
       IL FOCUS NON SI METTE PIU' nella textarea, di proposito: faceva
       scorrere la pagina da sola e sul telefono apriva la tastiera senza
       che il cliente l'avesse chiesto. La textarea compare comunque
       subito sotto la scheda appena scelta, quindi si vede gia'. */
    bpSetDettagliModo(bpModo, bpOpzioni) {
      const bpDaRipristino = !!(bpOpzioni && bpOpzioni.bpDaRipristino);
      this.bpDettagliModo = (bpModo === 'fatevoi' || bpModo === 'scrivo') ? bpModo : '';
      if (this.bpDettagliModo) {
        this.setAttribute('data-bp-dettagli-modo', this.bpDettagliModo);
      } else {
        this.removeAttribute('data-bp-dettagli-modo');
      }

      const bpTextarea = this.querySelector('[data-bp-dettagli-input]');
      if (bpTextarea && !bpDaRipristino) {
        if (this.bpDettagliModo === 'fatevoi') {
          this.bpDettagliMemoria = bpTextarea.value;
          bpTextarea.value = '';
          this.bpSetDettagli('');
        } else if (this.bpDettagliModo === 'scrivo') {
          if (this.bpDettagliMemoria) {
            bpTextarea.value = this.bpDettagliMemoria;
            this.bpSetDettagli(this.bpDettagliMemoria);
          }
        }
      }

      /* Scelta fatta: via il rosso e la riga di errore, come fa
         bpOnInput sul nome appena il cliente scrive. */
      if (this.bpDettagliModo && this.bpDettagliSchedeEl) {
        this.bpDettagliSchedeEl.classList.remove('bp-campo-mancante');
        this.bpNascondiErroreCampo(this.bpErroreDettagliEl);
      }
      this.bpRefreshAtcState();
    }

    /* --- la rotta dei passi ------------------------------------------------ */

    /* UNA TAPPA E' COMPLETATA? La risposta non nasce qui: si ripesca la
       stessa verita' che il modulo usa gia' per bloccare il bottone, cosi'
       rotta e blocco non possono raccontare due storie diverse.
       'variante' si chiede opzione per opzione, non sulla variante
       completa: bpIndice dice QUALE delle tappe (una per ogni opzione
       Shopify) si sta chiedendo, e si guarda solo la scelta di quella.
       Chiedere invece bpCurrentVariant, che esiste solo quando TUTTE le
       opzioni sono scelte, terrebbe la prima tappa su "da fare" anche
       dopo che il cliente l'ha scelta, finche' non sceglie pure la
       seconda: la rotta racconterebbe una bugia proprio sul passo appena
       fatto. Per tutti gli altri nomi bpIndice resta inutilizzato.
       'manifesto' e' l'unica che ha ancora bisogno del tocco: e' una
       checkbox, e spenta non si distingue da mai guardata.
       'taglia' e 'saltacoda' sono le due eccezioni, entrambe facoltative:
       il bottone non le richiede mai, quindi si contano completate
       appena c'e' una variante, senza pretendere un'interazione. Per la
       taglia e' sempre stato cosi'. Per il saltacoda e' una scelta
       precisa: e' un extra a pagamento, non sceglierlo e' il comportamento
       normale della maggioranza dei clienti, e pretendere un tocco
       parcheggerebbe il "sei qui" su un riquadro che il cliente ha gia'
       deciso di ignorare, senza che la rotta arrivasse mai in fondo.
       NON C'E' PIU' UNA TAPPA 'carrello': la rotta finisce alla tappa
       vera che il liquid decide essere l'ultima (saltacoda, sfondo o
       dettagli a seconda di cosa il prodotto ha configurato), col
       modificatore --ultima. Il bottone e i suoi avvisi restano fuori
       dalla rotta, come prima che la rotta esistesse. */
    bpTappaCompletata(bpNome, bpIndice) {
      if (bpNome === 'variante') {
        /* bpIndice arriva dall'attributo, quindi come stringa. Se per
           qualunque motivo non e' un numero valido si ripiega sulla
           variante intera: meglio una tappa prudente che un errore. */
        const bpPos = parseInt(bpIndice, 10);
        if (isNaN(bpPos)) return this.bpCurrentVariant !== null;
        return this.bpLeggiScelte()[bpPos] != null;
      }
      if (bpNome === 'manifesto') {
        return this.bpManifestoToccato === true;
      }
      if (bpNome === 'taglia' || bpNome === 'saltacoda') {
        return this.bpCurrentVariant !== null;
      }
      if (bpNome === 'nome') {
        return this.bpIsWantedCompleto();
      }
      if (bpNome === 'foto') {
        const bpCount = this.bpFotoFiles ? this.bpFotoFiles.length : 0;
        return bpCount >= 1 && bpCount <= this.bpGetMaxFoto();
      }
      if (bpNome === 'dettagli') {
        return this.bpDettagliModo !== '';
      }
      if (bpNome === 'sfondo') {
        return !!this.bpSfondoNome;
      }
      return false;
    }

    /* Scrive lo stato su ogni tappa: "fatto" quelle completate, "qui" la
       PRIMA non completata, "dafare" tutte le altre. Le tappe dentro un
       contenitore nascosto (i campi Manifesto a interruttore spento) non
       partecipano: non si vedono, e non devono rubare il "qui" a una
       tappa visibile.
       A interruttore della rotta spento non esiste nessun elemento
       data-bp-tappa e il metodo esce subito senza toccare niente. */
    bpAggiornaRotta() {
      const bpTappe = this.querySelectorAll('[data-bp-tappa]');
      if (bpTappe.length === 0) return;
      let bpQuiGiaData = false;
      bpTappe.forEach(function (bpTappa) {
        if (bpTappa.closest('[hidden]')) {
          bpTappa.setAttribute('data-bp-tappa-stato', 'dafare');
          return;
        }
        let bpStato = 'dafare';
        const bpIndice = bpTappa.getAttribute('data-bp-tappa-indice');
        if (this.bpTappaCompletata(bpTappa.getAttribute('data-bp-tappa'), bpIndice)) {
          bpStato = 'fatto';
        } else if (!bpQuiGiaData) {
          bpStato = 'qui';
          bpQuiGiaData = true;
        }
        bpTappa.setAttribute('data-bp-tappa-stato', bpStato);
      }, this);
    }

    /* --- saltacoda (mattone 6) -------------------------------------------- */

    bpSetSaltacoda(bpAttivo) {
      this.bpSaltacoda = bpAttivo === true;
      if (this.bpSaltacoda) {
        this.setAttribute('data-bp-saltacoda', 'on');
      } else {
        this.removeAttribute('data-bp-saltacoda');
      }
      this.dispatchEvent(
        new CustomEvent('bp:saltacoda-change', {
          bubbles: true,
          detail: { attivo: this.bpSaltacoda },
        })
      );
      /* Come lo sfondo: il saltacoda non passa da bpRefreshAtcState (non
         blocca il bottone, e' un in piu'), quindi la rotta si riallinea
         qui, altrimenti la sua tappa resterebbe indietro fino al prossimo
         tocco su un altro passo. */
      this.bpAggiornaRotta();
      /* Il Saltacoda e' un extra a pagamento: cambia il totale. */
      this.bpAggiornaTotale();
    }

    /* Funzione PAGAMENTO del saltacoda: POST semplice e separato per
       il prodottino da 5 euro scelto nel theme editor. Va fatto PRIMA
       del ritratto, così la property viene scritta solo a pagamento
       riuscito. In OGNI caso di errore restituisce null e mostra un
       avviso NON bloccante: il ritratto procede comunque. */
    async bpAddSaltacoda() {
      const bpVariantId = this.dataset.bpSaltacodaVariant;
      if (!bpVariantId) {
        console.warn('[bp-configuratore] Saltacoda attivo ma prodotto non configurato nel theme editor.');
        this.bpShowSaltacodaError();
        return null;
      }

      try {
        const bpFormData = new FormData();
        bpFormData.append('id', String(bpVariantId));
        bpFormData.append('quantity', '1');

        const bpResponse = await fetch(this.dataset.bpAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: bpFormData,
        });

        let bpResult = null;
        try {
          bpResult = await bpResponse.json();
        } catch (bpParseError) {
          bpResult = null;
        }

        if (!bpResponse.ok || !bpResult || bpResult.status || !bpResult.key) {
          console.warn(
            '[bp-configuratore] Aggiunta Saltacoda fallita:',
            (bpResult && (bpResult.description || bpResult.message)) || bpResponse.statusText
          );
          this.bpShowSaltacodaError();
          return null;
        }

        return bpResult;
      } catch (bpError) {
        console.warn('[bp-configuratore] Errore aggiunta Saltacoda:', bpError);
        this.bpShowSaltacodaError();
        return null;
      }
    }

    bpShowSaltacodaError() {
      this.bpShowError(
        this.dataset.bpTextSaltacodaError ||
        'Il ritratto è nel carrello, ma il Saltacoda non è stato aggiunto.'
      );
    }

    /* Rollback generico di un prodottino (saltacoda o sfondo custom):
       si usa quando il ritratto fallisce o quando la property
       saltacoda non è scrivibile, così pagamento e scelte restano
       sempre allineati. Best effort: se anche questo POST fallisce
       si logga soltanto. */
    async bpRemoveProdottino(bpKey) {
      if (!bpKey) return;
      try {
        await fetch(this.dataset.bpChangeUrl || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: bpKey, quantity: 0 }),
        });
      } catch (bpError) {
        console.warn('[bp-configuratore] Rollback prodottino fallito:', bpError);
      }
    }

    /* SEGNALE AL CARRELLO LATERALE: "sequenza di aggiunta in corso".
       Il bottone aggiunge PRIMA il Saltacoda e lo Sfondo, POI la variante.
       Fra una chiamata e l'altra il carrello laterale (bp-cart-body) si
       ridisegna e lancia bpCheckOrphans: vedeva il Saltacoda senza il
       prodotto personalizzato, lo credeva orfano e lo toglieva. Il cliente
       pagava il ritratto senza i 5 euro, con la property del Saltacoda
       scritta lo stesso. Col segnale acceso bpCheckOrphans non toglie
       niente; allo spegnimento il carrello rifa' UN controllo normale.
       Il segnale e' una scadenza (Date.now() + tetto), non un vero/falso:
       anche se lo spegnimento non arrivasse mai, scade da solo. */
    bpApriSequenzaCarrello() {
      window.bpSequenzaCarrello = Date.now() + BP_SEQUENZA_CARRELLO_MAX_MS;
      document.dispatchEvent(new CustomEvent('bp:sequenza-carrello', { detail: { attiva: true } }));
    }

    bpChiudiSequenzaCarrello() {
      window.bpSequenzaCarrello = 0;
      document.dispatchEvent(new CustomEvent('bp:sequenza-carrello', { detail: { attiva: false } }));
    }

    /* --- sfondo personalizzato (mattone 7) -------------------------------- */

    /* La decisione sul prodottino si prende al momento del click,
       guardando quale sfondo è selezionato ADESSO. */
    bpIsSfondoCustomSelezionato() {
      return !!this.querySelector('input[data-bp-sfondo-input][data-bp-sfondo-custom]:checked');
    }

    bpShowSfondoCustomError() {
      this.bpShowError(
        this.dataset.bpTextSfondoCustomError ||
        'Il ritratto è nel carrello, ma lo sfondo personalizzato non è stato aggiunto.'
      );
    }

    /* Prodottino "Sfondo personalizzato": stesso schema di
       bpAddSaltacoda. In OGNI caso di errore restituisce null e
       mostra un avviso NON bloccante: il ritratto procede comunque,
       ma senza la property "Personalizzato" (coerenza col pagamento). */
    async bpAddSfondoCustom() {
      const bpVariantId = this.dataset.bpSfondoCustomVariant;
      if (!bpVariantId) {
        console.warn('[bp-configuratore] Sfondo personalizzato scelto ma prodotto non configurato nel theme editor.');
        this.bpShowSfondoCustomError();
        return null;
      }

      try {
        const bpFormData = new FormData();
        bpFormData.append('id', String(bpVariantId));
        bpFormData.append('quantity', '1');

        const bpResponse = await fetch(this.dataset.bpAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: bpFormData,
        });

        let bpResult = null;
        try {
          bpResult = await bpResponse.json();
        } catch (bpParseError) {
          bpResult = null;
        }

        if (!bpResponse.ok || !bpResult || bpResult.status || !bpResult.key) {
          console.warn(
            '[bp-configuratore] Aggiunta Sfondo personalizzato fallita:',
            (bpResult && (bpResult.description || bpResult.message)) || bpResponse.statusText
          );
          this.bpShowSfondoCustomError();
          return null;
        }

        return bpResult;
      } catch (bpError) {
        console.warn('[bp-configuratore] Errore aggiunta Sfondo personalizzato:', bpError);
        this.bpShowSfondoCustomError();
        return null;
      }
    }

    /* Scrive un gruppo di properties sulla riga del ritratto appena
       creata, via /cart/change.js in JSON — il multipart perde i nomi
       campo non-ASCII (property saltacoda, taglia Wanted), il JSON
       no. Il change sostituisce le properties in blocco, quindi si
       rimandano quelle esistenti (le foto ormai sono URL, semplici
       stringhe) più le nuove passate in bpExtraProps. Chiede anche le
       sezioni del drawer: la risposta è lo stato più fresco e
       completo per il render finale. */
    async bpWriteJsonProperties(bpRitrattoItem, bpExtraProps) {
      if (!bpRitrattoItem || !bpRitrattoItem.key) return null;
      if (!bpExtraProps || Object.keys(bpExtraProps).length === 0) return null;
      try {
        const bpNuoveProperties = {};
        const bpEsistenti = bpRitrattoItem.properties || {};
        Object.keys(bpEsistenti).forEach(function (bpKey) {
          bpNuoveProperties[bpKey] = bpEsistenti[bpKey];
        });
        Object.keys(bpExtraProps).forEach(function (bpKey) {
          bpNuoveProperties[bpKey] = bpExtraProps[bpKey];
        });

        const bpResponse = await fetch(this.dataset.bpChangeUrl || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: bpRitrattoItem.key,
            quantity: bpRitrattoItem.quantity || 1,
            properties: bpNuoveProperties,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });

        let bpResult = null;
        try {
          bpResult = await bpResponse.json();
        } catch (bpParseError) {
          bpResult = null;
        }

        if (!bpResponse.ok || !bpResult || bpResult.status) {
          console.warn(
            '[bp-configuratore] Scrittura properties JSON fallita:',
            (bpResult && (bpResult.description || bpResult.message)) || bpResponse.statusText
          );
          return null;
        }
        return bpResult;
      } catch (bpError) {
        console.warn('[bp-configuratore] Errore scrittura properties JSON:', bpError);
        return null;
      }
    }

    /* Raccoglitore delle line item properties TESTUALI per l'ordine,
       usato da bpAddToCart. Le foto NON passano da qui: essendo File,
       vanno appese direttamente al FormData multipart. */
    bpGetOrderProperties() {
      const bpProperties = {};
      /* BP-MODALITA: campo NOME dei campi Wanted — attivi sempre in
         modalità wanted, o con l'interruttore Manifesto acceso nelle
         altre (il gating è già in bpRefreshAtcState e bpAddToCart).
         Nome ASCII puro: multipart ok. La TAGLIA invece NON va
         aggiunta qui: il suo nome contiene l'apostrofo tipografico e
         il multipart lo perderebbe — viaggia in JSON da bpAddToCart
         nell'aggiunta unica (dal 08/10/2026), come la property del
         saltacoda. */
      if (this.bpWantedFieldsAttivi()) {
        const bpNomePulito = (this.bpWantedNome || '').trim();
        if (bpNomePulito) {
          bpProperties[BP_PROP_WANTED_NOME] = bpNomePulito;
        }
      }
      if (this.bpSfondoNome) {
        bpProperties[BP_PROP_SFONDO] = this.bpSfondoNome;
      }
      /* IL VALORE DEI DETTAGLI, deciso QUI e non nel DOM. Con la prima
         scheda la property vale la frase esatta che il generatore di
         brief a valle riconosce ("Fate voi, mi fido!", virgola e punto
         esclamativo compresi): e' collaudato su quella, scritta a mano
         dai clienti per mesi, e una variante romperebbe il
         riconoscimento. Si legge dal theme editor per poterla correggere
         senza toccare il codice, col testo storico come ripiego se la
         setting fosse vuota.
         Con la seconda scheda arriva il testo del cliente, esattamente
         come prima di questo mattone: campo facoltativo, la property
         esiste solo se c'e' del testo. */
      const bpDettagliPuliti = (this.bpDettagli || '').trim();
      if (this.bpDettagliModo === 'fatevoi') {
        const bpValoreFatevoi = (this.dataset.bpDettagliValoreFatevoi || '').trim();
        bpProperties[BP_PROP_DETTAGLI] = bpValoreFatevoi || BP_DETTAGLI_FATEVOI_STORICO;
      } else if (bpDettagliPuliti) {
        bpProperties[BP_PROP_DETTAGLI] = bpDettagliPuliti;
      }
      /* Descrizione dello sfondo personalizzato: vale solo se in
         QUESTO momento è selezionato il riquadro Personalizzato
         (se il cliente ha scritto e poi è tornato su uno sfondo
         normale, il testo non finisce nell'ordine). Facoltativa per il
         cliente, ma col Personalizzato la property c'e' SEMPRE: casella
         vuota (o solo spazi) = BP_SFONDO_DESCR_VUOTA, cosi' l'artista
         sa che la scelta e' sua e non pensa a un testo perso. */
      if (this.bpIsSfondoCustomSelezionato()) {
        const bpDescrPulita = (this.bpSfondoDescr || '').trim();
        bpProperties[BP_PROP_SFONDO_DESCR] = bpDescrPulita || BP_SFONDO_DESCR_VUOTA;
      }
      /* ATTENZIONE: la property del saltacoda NON va aggiunta qui.
         Questo raccoglitore alimenta il POST multipart, e il parser
         di Shopify perde i nomi campo non-ASCII ("sarà", "?", "!") —
         la property arrivava vuota, verificato sul campo. Viene
         scritta in JSON nell'aggiunta unica di bpAddToCart (dal
         08/10/2026; prima dopo, da bpWriteJsonProperties()). */
      return bpProperties;
    }

    /* IL MOTIVO VERO di un add fallito, al posto di "Impossibile
       aggiungere al carrello. Riprova." che non dice cosa fare. Si
       controlla per prima la cosa che su Android e' successa davvero: una
       foto che il telefono non lascia piu' leggere (Chrome annulla
       l'invio, e al JS arriva solo un "errore di rete"). Poi la rete.
       Il testo generico resta l'ultimo ripiego. Non lancia mai. */
    async bpMotivoErrore(bpErrore) {
      const bpGenerico = this.dataset.bpTextAtcError || 'Impossibile aggiungere al carrello. Riprova.';
      try {
        const bpVoci = this.bpFotoFiles || [];
        for (let bpI = 0; bpI < bpVoci.length; bpI += 1) {
          if (!bpVoci[bpI].file) continue;
          try {
            await bpVoci[bpI].file.slice(0, 1).arrayBuffer();
          } catch (bpErroreLettura) {
            const bpNome = bpVoci[bpI].originale ? bpVoci[bpI].originale.name : 'una foto';
            this.bpShowFotoMsg(
              'Non riusciamo a leggere la foto "' + bpNome + '" dal telefono: toglila e caricala di nuovo, oppure carica uno screenshot della foto.',
              false
            );
            return 'Una foto non si può leggere dal telefono: toglila e caricala di nuovo (vedi sopra).';
          }
        }
        if (navigator.onLine === false) {
          return 'Sei senza connessione: controlla la rete e riprova.';
        }
        const bpTesto = (bpErrore && bpErrore.message) || '';
        if (/rete|scaduta|interrotta/.test(bpTesto)) {
          return 'La connessione si è interrotta durante l’invio: controlla la rete e riprova.';
        }
      } catch (bpErroreDiagnosi) {
        /* la diagnosi non deve mai coprire l'errore vero */
      }
      return bpGenerico;
    }

    /* Status HTTP senza spiegazione di Shopify: si dice cosa e' successo. */
    bpMotivoHttp(bpStatus) {
      if (bpStatus === 413) {
        return 'Le foto sono troppo pesanti per partire insieme: togline qualcuna e riprova.';
      }
      if (bpStatus === 429) {
        return 'Troppe richieste in poco tempo: aspetta qualche secondo e riprova.';
      }
      if (bpStatus >= 500) {
        return 'Il negozio non ha risposto (errore ' + bpStatus + '). Riprova tra qualche secondo.';
      }
      return (this.dataset.bpTextAtcError || 'Impossibile aggiungere al carrello. Riprova.') +
        ' (errore ' + bpStatus + ')';
    }

    bpShowError(bpText, bpUscita) {
      if (!this.bpErrorEl) return;
      /* L'attributo prima del testo (vedi bpShowFotoMsg): il salvagente
         scatta alla scrittura del testo e deve trovarlo al suo posto. */
      if (bpUscita) this.bpErrorEl.setAttribute('data-bp-uscita', bpUscita);
      else this.bpErrorEl.removeAttribute('data-bp-uscita');
      this.bpErrorEl.textContent = bpText;
      this.bpErrorEl.hidden = false;
    }

    /* Il clic su "Aggiungi al carrello" si ferma PRIMA di partire: il
       motivo al cliente, sotto il bottone, e alla sentinella. Il testo
       resta finche' il cliente non cambia qualcosa nel modulo (lo toglie
       bpSpegniAvvisoGiaAggiunto), poi il clic successivo rivaluta tutto. */
    bpFermaClick(bpMotivo, bpTesto, bpOpzioni) {
      this.bpShowError(bpTesto || 'Qualcosa nel modulo non è a posto: controlla le scelte e riprova.');
      this.bpErroreDelClick = true;
      console.warn('[bp-configuratore] Aggiungi al carrello fermato: ' + bpMotivo + '.');
      /* L'avviso al Capitano parte solo per i blocchi VERI, quelli per cui
         il chiamante passa un tipo (08/10/2026): variante esaurita, formato
         nascosto, errore nel gestore. Il modulo incompleto non e' un errore
         e non manda niente: prima andava alla sentinella, il server lo
         scartava, e nel browser consumava il tetto degli avvisi. */
      if (bpOpzioni && bpOpzioni.tipo) this.bpAvvisaCapitano(bpOpzioni.tipo, bpMotivo);
    }

    /* TUTTO lo stato del modulo in una riga, per l'avviso al Capitano
       (08/10/2026): prodotto, ogni scelta col suo valore ESATTO (bpEsatto),
       la variante trovata o no, le foto, sfondo, dettagli, extra, ora.
       Niente di cio' che il cliente scrive: del nome sul manifesto e dei
       dettagli si dice solo se ci sono. */
    bpStatoPerAvviso() {
      const bpParti = [];
      try {
        const bpPercorso = (window.location.pathname || '').split('/products/')[1] || '';
        bpParti.push('prodotto=' + (bpPercorso.split('/')[0] || (this.bpProduct && this.bpProduct.id) || '?'));
        const bpScelte = this.bpLeggiScelte();
        bpScelte.forEach(function (bpValore, bpIndice) {
          bpParti.push('opzione' + (bpIndice + 1) + '=' + bpEsatto(bpValore));
        });
        const bpV = this.bpCurrentVariant;
        bpParti.push('variante=' + (bpV ? bpV.id + (bpV.available === false ? ' ESAURITA' : '') : 'NESSUNA'));
        bpParti.push('varianti nel modulo=' + ((this.bpProduct && this.bpProduct.variants) ? this.bpProduct.variants.length : '?'));
        if (this.bpProdottoRicaricato) bpParti.push('prodotto riscaricato=si');
        if (this.bpUltimaRiserva) bpParti.push('riserva=' + this.bpUltimaRiserva);
        if (this.bpFormatiNascosti && this.bpFormatiNascosti.length) bpParti.push('nascosti=' + this.bpFormatiNascosti.map(bpEsatto).join('+'));
        const bpFoto = this.bpFotoFiles || [];
        const bpStati = {};
        bpFoto.forEach(function (bpVoce) { bpStati[bpVoce.stato] = (bpStati[bpVoce.stato] || 0) + 1; });
        bpParti.push('foto=' + bpFoto.length + (bpFoto.length ? ' (' + Object.keys(bpStati).map(function (k) { return k + ' ' + bpStati[k]; }).join(', ') + ')' : ''));
        bpParti.push('sfondo=' + bpEsatto(this.bpSfondoNome));
        bpParti.push('dettagli=' + (this.bpDettagliModo || 'non scelti'));
        bpParti.push('saltacoda=' + (this.bpSaltacoda ? 'si' : 'no'));
        if (this.bpWantedFieldsAttivi()) bpParti.push('nome manifesto=' + ((this.bpWantedNome || '').trim() ? 'presente' : 'vuoto'));
      } catch (bpErrore) {
        bpParti.push('stato non leggibile: ' + ((bpErrore && bpErrore.message) || bpErrore));
      }
      const bpOra = new Date();
      bpParti.push('ora=' + bpOra.toLocaleString('it-IT', { timeZone: 'Europe/Rome' }));
      return bpParti.join(' | ');
    }

    /* Variante non trovata: UN avviso per combinazione e per causa, e la
       causa e' scritta (30/10/2026).
       - Variante davvero mancante (prodotto arrivato da Shopify, o Shopify
         dice che il prodotto non c'e'): 'variante non trovata', rosso,
         subito.
       - Rete (i dati non sono arrivati): l'avviso NON parte subito, perche'
         il modulo sta riprovando da solo. Si mette da parte e parte quando
         l'esito e' noto (bpChiudiAvvisiRete):
           riprova riuscita -> 'Recuperato: variante caricata dopo errore di
             rete', notifica normale;
           riprove automatiche finite, o clic con la rete ancora giu' ->
             'variante non trovata (rete)', rosso;
           pagina chiusa prima dell'esito -> lo stesso rosso, con sendBeacon. */
    bpAvvisaVarianteNonTrovata(bpScelte, bpDove) {
      const bpStato = this.bpRicaricaStato || 'mai';
      const bpScelteTesto = (bpScelte || []).join('|');
      this.bpAvvisiCombinazioni = this.bpAvvisiCombinazioni || {};
      if (bpStato === 'rete') {
        const bpChiaveRete = 'rete|' + bpScelteTesto;
        if (this.bpAvvisiCombinazioni[bpChiaveRete]) return;
        this.bpRetePendenti = this.bpRetePendenti || {};
        if (!this.bpRetePendenti[bpChiaveRete]) {
          this.bpRetePendenti[bpChiaveRete] = { scelte: (bpScelte || []).slice(), dove: bpDove, da: Date.now(), errore: this.bpRicaricaDettaglio || '' };
        }
        this.bpAscoltaUscitaPagina();
        return;
      }
      const bpChiave = 'manca|' + bpScelteTesto;
      if (this.bpAvvisiCombinazioni[bpChiave]) return;
      this.bpAvvisiCombinazioni[bpChiave] = true;
      this.bpAvvisaCapitano(
        'variante non trovata',
        bpDove + ' | causa=' + (bpStato === 'dati' ? 'prodotto non trovato su Shopify' : 'variante davvero mancante')
        + ' | ricarica=' + bpStato + (this.bpRicaricaDettaglio ? ' (' + this.bpRicaricaDettaglio + ')' : '')
        + ' | tentativi di ricarica=' + (this.bpRicaricaTentativi || 0)
        + ' | online=' + (navigator.onLine === false ? 'no' : 'si')
      );
    }

    /* Gli avvisi di rete messi da parte partono qui, con l'esito:
       'recuperato', 'esaurite' (dopo la riprova dei 10 secondi), 'clic'
       (Aggiungi con la rete giu', solo per quella combinazione), 'uscita'
       (pagehide). Ognuno una volta sola per combinazione. */
    bpChiudiAvvisiRete(bpEsito, bpSoloScelte) {
      const bpPendenti = this.bpRetePendenti || {};
      const bpSolo = bpSoloScelte ? 'rete|' + bpSoloScelte.join('|') : null;
      this.bpAvvisiCombinazioni = this.bpAvvisiCombinazioni || {};
      Object.keys(bpPendenti).forEach(function (bpChiave) {
        if (bpSolo && bpChiave !== bpSolo) return;
        const bpVoce = bpPendenti[bpChiave];
        delete bpPendenti[bpChiave];
        if (this.bpAvvisiCombinazioni[bpChiave]) return;
        this.bpAvvisiCombinazioni[bpChiave] = true;
        const bpSecondi = Math.round((Date.now() - bpVoce.da) / 1000);
        const bpComune = 'scelte=' + bpVoce.scelte.join(' / ')
          + ' | primo errore=' + (bpVoce.errore || '?')
          + ' | tentativi di ricarica=' + (this.bpRicaricaTentativi || 0)
          + ' | online=' + (navigator.onLine === false ? 'no' : 'si');
        if (bpEsito === 'recuperato') {
          this.bpAvvisaCapitano(
            'variante caricata dopo errore di rete',
            bpComune + ' | dati del prodotto arrivati dopo ' + bpSecondi + ' s, il cliente puo\' proseguire',
            { recuperato: true, prefisso: 'Variante caricata dopo errore di rete' }
          );
          return;
        }
        const bpPerche = bpEsito === 'clic' ? 'clic su Aggiungi con la rete ancora giu'
          : (bpEsito === 'uscita' ? 'il cliente ha lasciato la pagina prima dell\'esito'
            : 'riprove automatiche finite senza dati');
        this.bpAvvisaCapitano(
          'variante non trovata (rete)',
          bpVoce.dove + ' | causa=rete (dati del prodotto non caricati) | ' + bpPerche
          + ' | ricarica=' + (this.bpRicaricaStato || 'mai') + (this.bpRicaricaDettaglio ? ' (' + this.bpRicaricaDettaglio + ')' : '')
          + ' | dopo ' + bpSecondi + ' s | ' + bpComune,
          bpEsito === 'uscita' ? { beacon: true } : undefined
        );
      }, this);
    }

    /* Se la pagina si chiude con un avviso di rete ancora in attesa, parte
       rosso con sendBeacon (l'unico invio che sopravvive alla chiusura). */
    bpAscoltaUscitaPagina() {
      if (this.bpAscoltaUscita) return;
      this.bpAscoltaUscita = true;
      const bpModulo = this;
      window.addEventListener('pagehide', function () {
        try { bpModulo.bpChiudiAvvisiRete('uscita'); } catch (bpErrore) { /* niente */ }
      });
    }

    /* Avviso al Capitano su Telegram per un cliente BLOCCATO (regola del
       Capitano, 08/10/2026). Passa dal canale proprio della sentinella
       (window.bpCanaleAvvisi in snippets/bp-errori.liquid): uno per cliente
       e per tipo, riprova se la spedizione fallisce, "N avvisi persi" se
       qualcosa si perde. Se il canale manca (snippet vecchio o spento) si
       ripiega sulla sentinella di sempre.
       Il prefisso "Aggiunta al carrello fallita" fa scattare lato server
       l'allarme rosso, quello degli acquisti bloccati.

       UN GUASTO, UN MESSAGGIO (27/10/2026). Prima erano due o tre (motivo,
       stato, contesto) piu' quello del wrapper di bp-errori.liquid. Il
       server taglia il messaggio a 1500 caratteri (erano 500 fino al
       27/10/2026), quindi qui si compone fino a 1490 in questo ordine e si
       ferma se lo spazio finisce:
       1. il motivo (al massimo 300 caratteri);
       2. lo stato del modulo, tagliato per ultimo (finisce con l'ora, che il
          server scrive gia' per conto suo);
       3. la coda dello user agent oltre i 160 caratteri. Browser (primi 160)
          e indirizzo completo viaggiano gia' nei campi dispositivo e pagina
          di OGNI messaggio, e Telegram li mostra: il vecchio messaggio
          "contesto" li ripeteva. Nella coda stanno la versione dell'app
          (Instagram, Facebook) e il telefono, che sono proprio in fondo.
       bpOpzioni.recuperato: l'aggiunta e' riuscita lo stesso (rete caduta e
       recuperata). Il prefisso NON contiene "carrello fallita" e l'etichetta
       non e' "Cliente bloccato", cosi' non scatta l'allarme rosso. Non
       lancia mai. */

    bpAvvisaCapitano(bpTipo, bpDettaglio, bpOpzioni) {
      try {
        const bpRecuperato = !!(bpOpzioni && bpOpzioni.recuperato);
        /* bpOpzioni.prefisso (30/10/2026): un recuperato che non riguarda
           l'aggiunta (variante caricata dopo un errore di rete) dice la sua
           cosa e non "Aggiunta al carrello...". bpOpzioni.beacon: la pagina
           si sta chiudendo, il canale spedisce subito con sendBeacon. */
        const bpPrefisso = (bpOpzioni && bpOpzioni.prefisso)
          || (bpRecuperato ? 'Aggiunta al carrello riuscita dopo un guasto di rete' : 'Aggiunta al carrello fallita');
        const bpLimite = 1490;
        /* Il testo che il cliente ha letto ("mostrato=") si accorcia: lo
           dice gia' il tipo, e mangiava lo spazio dello stato. */
        const bpMotivo = bpSenzaRumore(bpTipo + (bpDettaglio ? ' | ' + bpDettaglio : ''))
          .replace(/ \| mostrato=(.{0,50})[\s\S]*$/, function (bpTutto, bpInizio) { return ' | mostrato=' + bpInizio + (bpTutto.length > 62 ? '...' : ''); })
          .slice(0, 300);
        /* Oltre i 160 caratteri dello user agent c'e' quasi solo l'app che
           apre la pagina: di quella basta il nome con la versione. */
        const bpUa = String(navigator.userAgent || '');
        const bpApp = bpUa.length > 160 ? /(Instagram|FBAN\/\w+|FBAV\/[\d.]+|FB_IAB\/\w+|TikTok|musical_ly|Line\/[\d.]+)[^;)]{0,24}/.exec(bpUa.slice(160)) : null;
        const bpCodaUa = bpApp ? ' || app=' + bpSenzaRumore(bpApp[0]) : '';
        const bpTesta = '[bp-configuratore] ' + bpPrefisso + ': ' + bpMotivo;
        const bpSpazioStato = bpLimite - bpTesta.length - bpCodaUa.length - 4;
        let bpMessaggio = bpTesta;
        if (bpSpazioStato >= 40) {
          /* L'ora la scrive gia' il server: fuori dallo stato. */
          const bpStato = bpSenzaRumore(this.bpStatoPerAvviso()).replace(/ \| ora=[^|]*$/, '');
          bpMessaggio += ' || ' + (bpStato.length > bpSpazioStato ? bpStato.slice(0, bpSpazioStato - 3) + '...' : bpStato) + bpCodaUa;
        } else {
          bpMessaggio = (bpTesta + bpCodaUa).slice(0, bpLimite);
        }
        /* UN RECUPERATO NON SUONA MAI L'ALLARME ROSSO. La function bp-errori
           lo accende se tipo o messaggio contengono "carrello fallita",
           "carrello interrotta", "checkout" o il numero 413 da solo: qui si
           spezzano, cosi' nemmeno lo stato del modulo o la versione di
           un'app (Instagram 413.x) possono trasformarlo in un cliente fermo. */
        if (bpRecuperato) {
          bpMessaggio = bpMessaggio
            .replace(/carrello(\s+)(fallita|interrotta)/gi, 'carrello_$2')
            .replace(/check(\s*)out/gi, 'check_out')
            .replace(/(^|\D)413(?=\D|$)/g, '$14_13');
        }
        const bpCanaleOpzioni = { file: 'bp-configuratore.js' };
        if (bpRecuperato) bpCanaleOpzioni.etichetta = 'Recuperato';
        if (bpOpzioni && bpOpzioni.beacon) bpCanaleOpzioni.beacon = true;
        if (typeof window.bpCanaleAvvisi === 'function') {
          window.bpCanaleAvvisi(bpTipo, [bpMessaggio], bpCanaleOpzioni);
        } else {
          bpSegnalaSentinella(bpMessaggio.replace(/^\[bp-configuratore\] /, ''));
        }
      } catch (bpErrore) {
        /* l'avviso non deve mai fermare niente */
      }
    }

    /* Il nome che il cliente vede sulla card di questo valore del secondo
       selettore: il titolo dell'editor se c'e', altrimenti il valore
       Shopify (e' cio' che il Liquid stampa nella card). Gli a capo del
       titolo (<br>) diventano spazi. Pillole e tendina non hanno un nome
       diverso dal valore: si torna il valore, come prima. */
    bpNomeCardDi(bpValore) {
      const bpRadio = Array.prototype.find.call(
        this.querySelectorAll('input[type="radio"][data-bp-option-index="1"]'),
        function (bpR) { return bpR.value === bpValore; }
      );
      const bpNomeEl = bpRadio && bpRadio.closest('label')
        ? bpRadio.closest('label').querySelector('.bp-configuratore__scheda-nome')
        : null;
      if (!bpNomeEl) return bpValore;
      const bpPezzi = [];
      bpNomeEl.childNodes.forEach(function (bpNodo) {
        if (bpNodo.nodeType === 3) bpPezzi.push(bpNodo.textContent);
        else if (bpNodo.nodeName === 'BR') bpPezzi.push(' ');
        else bpPezzi.push(bpNodo.textContent || '');
      });
      const bpNome = bpPezzi.join('').replace(/\s+/g, ' ').trim();
      return bpNome || bpValore;
    }

    /* Il nome del secondo selettore nei messaggi: il modello sulla Cover,
       la quantita' sul Portachiavi, il formato altrove. */
    bpNomeSecondoPasso() {
      const bpModalita = this.dataset.bpModalita;
      if (bpModalita === 'cover') return 'scegli il modello';
      if (bpModalita === 'portachiavi') return 'scegli quanti portachiavi';
      return 'scegli il formato';
    }

    /* Cosa manca, in una riga sola, dagli elementi di bpCampiMancanti. */
    bpTestoMancanti(bpElementi) {
      const bpModulo = this;
      const bpParti = [];
      (bpElementi || []).forEach(function (bpEl) {
        if (bpEl.matches && bpEl.matches('[data-bp-opzione-gruppo]')) {
          /* Un nome corto scritto qui, non il titolo dell'opzione: i titoli
             sono lunghi e con emoji ("2️⃣: Seleziona il formato..."),
             illeggibili dentro una frase. Il gruppo ha gia' il bordo rosso. */
          const bpIndice = parseInt(bpEl.getAttribute('data-bp-opzione-gruppo'), 10);
          /* L'opzione 0 e' sempre il numero di personaggi, su tutti e cinque
             i prodotti: quando manca (nessun numero preselezionato) lo si
             dice con le parole del cliente. */
          /* Il secondo selettore si dice col suo nome, mai col numero del
             passo: con "Formato prima del numero" il numero a schermo non
             corrisponde piu' all'indice Shopify. */
          if (bpIndice === 0) bpParti.push('scegli il numero di personaggi');
          else if (bpIndice === 1) bpParti.push(bpModulo.bpNomeSecondoPasso());
          else bpParti.push('completa le scelte in alto');
        } else if (bpEl === bpModulo.bpFotoAddEl) {
          const bpCount = bpModulo.bpFotoFiles ? bpModulo.bpFotoFiles.length : 0;
          bpParti.push(bpCount === 0
            ? 'carica almeno una foto'
            : 'togli le foto in più (massimo ' + bpModulo.bpGetMaxFoto() + ')');
        } else if (bpEl === bpModulo.bpDettagliSchedeEl) {
          bpParti.push('scegli come vuoi i dettagli');
        } else {
          bpParti.push('scrivi il nome sul manifesto');
        }
      });
      if (bpParti.length === 0) return '';
      return 'Prima di aggiungere al carrello: ' + bpParti.join(', ') + '.';
    }

    bpHideError() {
      if (!this.bpErrorEl) return;
      this.bpErrorEl.removeAttribute('data-bp-uscita');
      this.bpErrorEl.hidden = true;
      this.bpErrorEl.textContent = '';
    }

    /* --- add-to-cart (mattone 2) ----------------------------------------- */

    /* Il bottone è attivo solo quando: variante esistente e disponibile,
       almeno 1 foto caricata, foto non oltre il massimo, e (in modalità
       wanted) nome e taglia compilati. L'hint sotto il bottone spiega
       al cliente perché è bloccato. */
    bpRefreshAtcState() {
      const bpCount = this.bpFotoFiles ? this.bpFotoFiles.length : 0;
      const bpMax = this.bpGetMaxFoto();
      const bpVariantOk =
        this.bpCurrentVariant !== null &&
        this.bpCurrentVariant.available !== false;
      const bpFotoOk = bpCount >= 1 && bpCount <= bpMax;
      const bpWantedOk = this.bpIsWantedCompleto();

      /* Il bottone e' sempre cliccabile, tranne mentre l'invio e' in
         corso: bpBusy resta l'unico motivo di disabled. Il controllo
         dei campi si e' spostato sul momento del click (bpAddToCart).
         Dei tre calcoli qui sopra l'hint usa solo bpVariantOk: senza
         una variante scelta non si chiede niente al cliente, perche'
         non c'e' ancora un prodotto da configurare. bpFotoOk e
         bpWantedOk non hanno piu' lettori. */
      if (this.bpAtcEl) {
        this.bpAtcEl.disabled = this.bpBusy;
      }

      if (this.bpAtcHintEl) {
        /* Il nome manca davvero solo quando i campi Wanted sono in
           gioco: fuori da quelle modalita' non c'e' nessun nome da
           chiedere. La taglia NON entra piu' in questo conto, e per
           questo nessuno dei testi qui sotto la nomina.
           I TESTI VIVONO QUI E IN NESSUN ALTRO POSTO, e non si leggono
           piu' da this.dataset. Le due setting foto_required_text e
           wanted_required_text restano nello schema ma non le guarda
           piu' nessuno: i valori gia' salvati nei template JSON
           portavano la frase vecchia, quella che nominava la taglia, e
           siccome il dataset veniva letto per primo avrebbero
           continuato a vincere sul codice. Un default di schema non
           tocca le istanze gia' montate, quindi cambiarlo la' non
           bastava. */
        const bpNomeMancante = this.bpWantedFieldsAttivi()
          && (this.bpWantedNome || '').trim() === '';
        let bpHint = '';
        /* PRIMA DI TUTTO IL RESTO: senza le scelte fatte non ha senso
           chiedere foto o nomi, perche' non si sa ancora nemmeno cosa si
           sta configurando. Va prima anche della combinazione
           impossibile, che parla per conto suo nella riga sopra il
           bottone. */
        if (this.bpScelteIncomplete()) {
          bpHint = 'Scegli tutte le opzioni per continuare.';
        } else if (bpVariantOk && bpNomeMancante && bpCount === 0) {
          bpHint = 'Per aggiungere al carrello devi scrivere il nome sul manifesto e caricare almeno una foto.';
        } else if (bpVariantOk && bpNomeMancante) {
          bpHint = 'Per aggiungere al carrello devi scrivere il nome sul manifesto.';
        } else if (bpVariantOk && bpCount === 0) {
          bpHint = 'Per aggiungere al carrello devi caricare almeno una foto.';
        } else if (bpVariantOk && bpCount > bpMax) {
          bpHint = 'Rimuovi le foto in eccesso per continuare.';
        } else if (bpVariantOk && !this.bpDettagliModo) {
          bpHint = 'Scegli come vuoi i dettagli per procedere.';
        } else if (bpVariantOk && this.bpUltimoOrdineAggiunto) {
          /* ULTIMO DELLA CATENA, e la posizione e' la regola: ogni ramo
             sopra parla di qualcosa che manca per poter aggiungere, e
             finche' manca qualcosa vince sempre quello. Questo compare
             SOLO quando il bottone e' gia' pronto e non c'e' nient'altro
             da dire, cioe' quando bpHint sarebbe rimasto vuoto. */
          bpHint = 'Questo ritratto è già nel carrello. Premendo di nuovo ne ordini un altro.';
        }
        this.bpAtcHintEl.textContent = bpHint;
        this.bpAtcHintEl.hidden = !bpHint;
        /* Niente da chiedere piu': via anche l'allarme, altrimenti
           resterebbe acceso su un avviso vuoto e ripartirebbe gia'
           rosso alla mancanza successiva. */
        if (!bpHint) {
          this.bpAtcHintEl.classList.remove('bp-hint-allarme');
        }
      }

      /* La rotta si riallinea QUI, e non in sei posti diversi: questo
         metodo lo chiamano gia' il cambio variante, le foto aggiunte o
         tolte, la scelta dei dettagli, il nome del manifesto e il suo
         interruttore. Un aggancio solo, sugli stessi dati che decidono il
         blocco del bottone. Fuori dall'if qui sopra di proposito: la rotta
         si aggiorna anche su un markup senza la riga di avviso. Restano
         fuori solo lo sfondo e l'aggiunta riuscita, agganciati dove
         succedono. */
      this.bpAggiornaRotta();
    }

    /* ---- La barra di avanzamento delle foto -------------------------
       Vive sotto la griglia delle tessere, non sul bottone: e' li' che il
       cliente sta guardando, ed e' li' che stanno le cose che partono.
       Compare SOLO se ci sono foto: senza allegati l'upload e' istantaneo
       e una barra che lampeggia sarebbe rumore. */
    bpMostraProgresso(bpFrazione) {
      if (!this.bpFotoProgressoEl) return;
      const bpPercento = Math.max(0, Math.min(100, Math.round(bpFrazione * 100)));
      this.bpFotoProgressoEl.hidden = false;
      this.bpFotoProgressoEl.setAttribute('aria-valuenow', String(bpPercento));
      if (this.bpFotoProgressoRiempiEl) {
        this.bpFotoProgressoRiempiEl.style.width = bpPercento + '%';
      }
      if (this.bpFotoProgressoTestoEl) {
        const bpBase = this.dataset.bpTextFotoUpload || 'Carico le tue foto…';
        this.bpFotoProgressoTestoEl.textContent = bpBase + ' ' + bpPercento + '%';
      }
      /* Velo leggero sulle tessere, sorella di quello della conversione:
         dice che quelle foto stanno partendo e non si toccano. */
      if (this.bpFotoGridEl) {
        this.bpFotoGridEl.classList.add('bp-configuratore__foto-grid--invio');
      }
    }

    bpNascondiProgresso() {
      if (this.bpFotoGridEl) {
        this.bpFotoGridEl.classList.remove('bp-configuratore__foto-grid--invio');
      }
      if (!this.bpFotoProgressoEl) return;
      this.bpFotoProgressoEl.hidden = true;
      this.bpFotoProgressoEl.removeAttribute('aria-valuenow');
      if (this.bpFotoProgressoRiempiEl) this.bpFotoProgressoRiempiEl.style.width = '0%';
      if (this.bpFotoProgressoTestoEl) this.bpFotoProgressoTestoEl.textContent = '';
    }

    bpSetLoading(bpIsLoading) {
      if (!this.bpAtcEl) return;
      if (bpIsLoading) {
        this.bpAtcLabelBackup = this.bpAtcEl.textContent;
        this.bpAtcEl.textContent = this.dataset.bpTextAdding || 'Aggiunta in corso…';
        this.bpAtcEl.setAttribute('aria-busy', 'true');
        this.bpAtcEl.disabled = true;
      } else {
        if (this.bpAtcLabelBackup) {
          this.bpAtcEl.textContent = this.bpAtcLabelBackup;
        }
        this.bpAtcEl.removeAttribute('aria-busy');
        this.bpRefreshAtcState();
      }
    }

    async bpAddToCart() {
      if (this.bpBusy || this.bpRisoluzioneInCorso) return;
      this.bpRicalcolaSeServe('clic su Aggiungi');
      /* LA VARIANTE SI RICALCOLA AL CLIC (14/10/2026, caso Android
         Instagram). Prima il clic si fidava di bpCurrentVariant, calcolata
         all'ultimo bpUpdate: se l'avvio del modulo si era interrotto, o il
         browser aveva rimesso le scelte senza un "change", le scelte in
         pagina erano giuste e la variante in memoria no, e il cliente si
         sentiva dire "combinazione inesistente" su una combinazione che
         esiste. Ora si rilegge la pagina a strati (bpVarianteSicura, con il
         prodotto riscaricato se serve) e la pagina si riallinea. */
      this.bpRisoluzioneInCorso = true;
      try {
        const bpFresca = await this.bpVarianteSicura();
        try { this.bpUpdate(); } catch (bpErrore) { /* lo stato si fissa qui sotto */ }
        this.bpCurrentVariant = bpFresca;
      } catch (bpErrore) {
        /* niente: si prosegue con quello che c'e' */
      } finally {
        this.bpRisoluzioneInCorso = false;
      }
      /* IL MURO DELLE SCELTE, ED E' UN MURO CHE PARLA. Prima usciva in
         silenzio: il cliente premeva, non succedeva niente, e non c'era
         modo di capire perche'. Ora i gruppi non scelti si accendono di
         rosso, l'avviso sotto il bottone dice cosa fare e lo sguardo
         viene portato sul primo che manca.
         Se invece le scelte ci sono tutte e la variante manca lo stesso,
         quella combinazione non esiste a catalogo: non c'e' un campo da
         segnare in rosso, ma il motivo si dice lo stesso (vedi sotto). */
      /* NESSUNA USCITA E' MUTA (30/09/2026). Ogni ritorno qui sotto passa
         da bpFermaClick: una riga in [data-bp-error] sotto il bottone, che
         il cliente vede senza cercarla, e una segnalazione col motivo alla
         sentinella bp-errori. Prima alcune uscite scrivevano solo sotto il
         campo (fuori vista, in fondo a un modulo lungo) e due non
         scrivevano niente: il clic sembrava non funzionare, e nessuno lo
         veniva a sapere. */
      if (!this.bpCurrentVariant) {
        if (this.bpScelteIncomplete()) {
          const bpMancanti = this.bpCampiMancanti();
          this.bpSegnalaMancanti(bpMancanti);
          this.bpFermaClick('scelte incomplete', this.bpTestoMancanti(bpMancanti));
        } else if (this.bpRicaricaStato === 'rete') {
          /* La variante manca perche' i dati non arrivano (la ricarica al
             clic e' appena caduta di nuovo): stesso testo della riga, niente
             WhatsApp (il salvagente non lo riconosce, di proposito), e le
             riprove automatiche ripartono se erano finite. */
          this.bpFermaClick(
            'dati prodotto non caricati (rete) (' + this.bpLeggiScelte().join(' / ') + ')',
            this.dataset.bpTextRete || BP_TESTO_RETE_LENTA,
            { senzaSentinella: true }
          );
          this.bpAvvisaVarianteNonTrovata(this.bpLeggiScelte(), 'al click');
          this.bpChiudiAvvisiRete('clic', this.bpLeggiScelte());
          this.bpProgrammaRiprovaRicarica();
        } else {
          /* Scelte tutte fatte ma la variante non si trova. Il cliente non
             resta fermo in silenzio: il testo lo manda su WhatsApp (il
             pulsante lo aggiunge snippets/bp-salvagente.liquid, che
             riconosce "questa combinazione"), e il Capitano riceve lo
             stato completo per capire perche'. */
          this.bpFermaClick(
            'combinazione inesistente (' + this.bpLeggiScelte().join(' / ') + ')',
            'Non riusciamo a completare questa combinazione dal sito. Scrivici su WhatsApp: finiamo l’ordine insieme.',
            { senzaSentinella: true }
          );
          /* Avviso solo se la riga rossa non l'ha gia' mandato per queste
             scelte: la sentinella accetta al massimo 5 messaggi per pagina,
             e lo stesso stato due volte li consumerebbe per niente. */
          this.bpAvvisaVarianteNonTrovata(this.bpLeggiScelte(), 'al click');
        }
        return;
      }
      /* RETE DI SICUREZZA sui formati nascosti: la variante nascosta e' gia'
         fuori dall'elenco, quindi qui non dovrebbe arrivare mai. Se ci
         arrivasse comunque, nel carrello non entra. */
      if (Array.isArray(this.bpVariantiNascoste)
          && this.bpVariantiNascoste.some(function (bpV) { return bpV.id === this.bpCurrentVariant.id; }, this)) {
        this.bpFermaClick(
          'formato nascosto (' + this.bpCurrentVariant.id + ')',
          'Questo formato non è disponibile: scegline un altro.',
          { tipo: 'formato nascosto scelto' }
        );
        return;
      }
      /* VARIANTE "NON DISPONIBILE" (14/10/2026, regola del Capitano): non si
         ferma piu' il clic. I nostri prodotti sono fatti su ordinazione e
         "non disponibile" spesso vuol dire solo scorte a zero in admin:
         l'aggiunta si prova lo stesso. Se Shopify la rifiuta, il cliente
         riceve il messaggio generale con WhatsApp e il Capitano l'avviso
         (vedi il ramo del rifiuto, piu' sotto). */
      if (this.bpCurrentVariant.available === false) {
        console.warn('[bp-configuratore] Variante segnata non disponibile (' + this.bpCurrentVariant.id + '): si prova lo stesso l\'aggiunta.');
      }

      const bpMax = this.bpGetMaxFoto();
      const bpCount = this.bpFotoFiles.length;
      if (bpCount < 1 || bpCount > bpMax
          || !this.bpIsWantedCompleto()
          || !this.bpDettagliModo) {
        const bpMancanti = this.bpCampiMancanti();
        this.bpSegnalaMancanti(bpMancanti);
        this.bpFermaClick(
          'modulo incompleto (foto ' + bpCount + ' su ' + bpMax
            + ', nome ' + (this.bpIsWantedCompleto() ? 'ok' : 'mancante')
            + ', dettagli ' + (this.bpDettagliModo || 'non scelti') + ')',
          this.bpTestoMancanti(bpMancanti)
        );
        return;
      }

      this.bpBusy = true;
      this.bpSetLoading(true);
      this.bpHideError();
      /* Vero solo se il segnale al carrello e' stato acceso: i ritorni
         anticipati prima del Saltacoda non lo accendono e non lo spengono. */
      let bpSequenzaAperta = false;
      /* Il passo in cui si trova l'invio e quando e' partito: se qualcosa
         va storto, l'avviso al Capitano dice DOVE e dopo quanto. */
      this.bpPassoInvio = 'attesa conversione foto';
      const bpInizioInvio = Date.now();
      /* Lettura del carrello "prima", lanciata subito: lavora mentre si
         aspettano conversione e gettoni, cosi' non allunga il click. Non
         lancia mai (null se non riesce). */
      const bpQuantitaPrimaPromessa = bpQuantitaNelCarrello(this.bpCurrentVariant && this.bpCurrentVariant.id);

      try {
        /* Se una conversione è ancora in volo, si aspetta: sono frazioni
           di secondo, e caricare l'originale al posto della versione
           ridimensionata vanificherebbe tutto il guadagno. Il bottone NON
           si blocca mai per questo, aspetta e prosegue; bpBusy è già
           alzato qui sopra, quindi un doppio clic non fa partire due add. */
        await this.bpCodaConversione;

        /* SOLO GETTONI (vedi bpDecidiGettoni): nessun file viaggia nel
           carrello. bpDecidiGettoni puo' aspettare fino a
           BP_ATTESA_GETTONI_MS se qualche foto e' ancora in volo: il
           bottone e' gia' in "Aggiunta in corso" da qui sopra. Se le foto
           non sono pronte il click si ferma col motivo vero; il ritorno
           dentro il try lascia al finally il compito di rimettere a posto
           il bottone. */
        let bpSceltaFoto = 'blocco';
        try {
          this.bpPassoInvio = 'gettoni delle foto';
          bpSceltaFoto = await this.bpDecidiGettoni();
        } catch (bpErroreGettoni) {
          console.warn('[bp-configuratore] Scelta dei gettoni fallita:', bpErroreGettoni);
          this.bpMotivoBlocco = null;
        }
        if (bpSceltaFoto !== 'gettoni') {
          this.bpBloccaFoto(this.bpMotivoBlocco);
          /* Avviso al Capitano SOLO se almeno una foto e' DAVVERO in errore
             (09/10/2026): 'fallita' (non e' arrivata su R2, nemmeno
             riprovando) o 'non-caricabile' (troppo pesante anche dopo la
             riduzione). Il caso "le foto stanno ancora caricando" (rete
             lenta, bpDecidiGettoni scaduto in attesa) NON e' un errore: il
             cliente ha solo cliccato un po' presto, e mandava un avviso a
             ogni tentativo, anche piu' di uno sulla stessa pagina. */
          const bpFotoInErrore = this.bpFotoFiles.some(function (bpVoce) {
            return bpVoce.stato === 'fallita' || bpVoce.stato === 'non-caricabile';
          });
          if (bpFotoInErrore) {
            this.bpAvvisaCapitano('foto non pronte al click', 'mostrato=' + (this.bpMotivoBlocco || 'Una foto non è pronta'));
          }
          return;
        }

        /* Da qui partono le aggiunte: segnale acceso, cosi' il carrello
           laterale non toglie Saltacoda e Sfondo prima che arrivi la
           variante. Lo spegne il finally, in ogni caso. */
        this.bpApriSequenzaCarrello();
        bpSequenzaAperta = true;

        /* AGGIUNTA UNICA (08/10/2026). Ritratto, Saltacoda e Sfondo
           personalizzato entrano in UNA chiamata /cart/add.js con
           items: [...]. Shopify la tratta come tutto o niente (provato: con
           un articolo esaurito o inesistente nella lista risponde 422 e il
           carrello resta com'era), quindi un extra senza il suo ritratto
           non puo' piu' nascere. Prima erano tre o quattro chiamate in fila
           (Saltacoda, Sfondo, ritratto multipart, properties su change.js):
           se la terza cadeva, gli extra restavano nel carrello da soli.
           L'ORDINE CHE ARRIVA A SHOPIFY E' QUELLO DI PRIMA:
           - le righe sono le stesse, e la lista e' Saltacoda, Sfondo,
             ritratto, come l'ordine delle vecchie chiamate;
           - le properties del ritratto sono le stesse e nello stesso
             ordine: gettoni delle foto, poi bpGetOrderProperties, poi la
             taglia e la property del Saltacoda, che prima arrivavano dopo
             con change.js. In JSON i nomi non ASCII arrivano interi (il
             multipart li perdeva, ed era l'unico motivo di change.js);
           - Saltacoda e Sfondo restano righe senza properties, come prima.
           Le funzioni delle vecchie chiamate (bpAddSaltacoda,
           bpAddSfondoCustom, bpWriteJsonProperties) restano nel file ma da
           qui non sono piu' chiamate. */
        const bpVuoleSfondoCustom = this.bpIsSfondoCustomSelezionato();
        const bpIdSaltacoda = this.dataset.bpSaltacodaVariant;
        const bpIdSfondo = this.dataset.bpSfondoCustomVariant;
        /* Extra scelto ma prodotto non configurato nel theme editor: come
           prima, avviso non bloccante e il ritratto entra senza. */
        if (this.bpSaltacoda && !bpIdSaltacoda) {
          console.warn('[bp-configuratore] Saltacoda attivo ma prodotto non configurato nel theme editor.');
          this.bpShowSaltacodaError();
        }
        if (bpVuoleSfondoCustom && !bpIdSfondo) {
          console.warn('[bp-configuratore] Sfondo personalizzato scelto ma prodotto non configurato nel theme editor.');
          this.bpShowSfondoCustomError();
        }
        const bpConSaltacoda = !!(this.bpSaltacoda && bpIdSaltacoda);
        const bpConSfondo = !!(bpVuoleSfondoCustom && bpIdSfondo);

        /* Le properties del ritratto, nell'ordine di sempre. Le foto sono
           SOLO gettoni: "_Carica le foto 1", "_Carica le foto 2", con
           l'underscore SINGOLO di BP_PROP_FOTO_PREFIX. */
        const bpProperties = {};
        this.bpFotoFiles.forEach(function (bpVoce, bpIndex) {
          bpProperties[BP_PROP_FOTO_PREFIX + (bpIndex + 1)] = bpVoce.gettone;
        });
        const bpProps = this.bpGetOrderProperties();
        if (bpVuoleSfondoCustom && !bpConSfondo) {
          /* Sfondo personalizzato non pagabile: né la property
             "Personalizzato" né la sua descrizione sul ritratto. */
          delete bpProps[BP_PROP_SFONDO];
          delete bpProps[BP_PROP_SFONDO_DESCR];
        }
        Object.keys(bpProps).forEach(function (bpKey) {
          bpProperties[bpKey] = bpProps[bpKey];
        });
        if (this.bpWantedFieldsAttivi()) {
          const bpTagliaPulita = (this.bpWantedTaglia || '').trim();
          if (bpTagliaPulita) bpProperties[BP_PROP_WANTED_TAGLIA] = bpTagliaPulita;
        }
        if (bpConSaltacoda) bpProperties[BP_PROP_SALTACODA_NOME] = BP_PROP_SALTACODA_VALORE;

        const bpItems = [];
        if (bpConSaltacoda) bpItems.push({ id: Number(bpIdSaltacoda), quantity: 1 });
        if (bpConSfondo) bpItems.push({ id: Number(bpIdSfondo), quantity: 1 });
        bpItems.push({ id: this.bpCurrentVariant.id, quantity: 1, properties: bpProperties });

        /* Barra sotto la griglia, solo con delle foto: e' l'unico caso in
           cui c'e' un'attesa da raccontare. */
        const bpHaFoto = this.bpFotoFiles.length > 0;
        if (bpHaFoto) this.bpMostraProgresso(0);

        const bpModuloProgresso = this;
        this.bpPassoInvio = 'invio a /cart/add.js (ritratto' + (bpConSfondo ? ' + Sfondo' : '') + (bpConSaltacoda ? ' + Saltacoda' : '') + ')';
        /* La quantita' del ritratto nel carrello PRIMA dell'invio: serve
           solo se il POST cade per la rete (vedi bpAggiungiConRecupero). La
           lettura e' partita all'inizio dell'invio e di solito e' gia'
           finita; va attesa qui perche' deve precedere il POST, mai
           accavallarsi. */
        const bpQuantitaPrima = await bpQuantitaPrimaPromessa;
        const bpInvio = await bpAggiungiConRecupero(
          this.dataset.bpAddUrl || '/cart/add.js',
          JSON.stringify({ items: bpItems, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
          bpHaFoto ? function (bpFrazione) { bpModuloProgresso.bpMostraProgresso(bpFrazione); } : null,
          this.bpCurrentVariant.id,
          bpQuantitaPrima
        );
        const bpResponse = bpInvio.risposta;
        /* Aggiunta riuscita solo grazie al recupero: il cliente non vede
           niente (deve poter pagare), il Capitano si': e' la prova che il
           caso succede e come e' stato chiuso. */
        if (bpInvio.recupero) {
          console.warn('[bp-configuratore] Aggiunta recuperata dopo un guasto di rete: ' + bpInvio.recupero);
          this.bpAvvisaCapitano(
            'rete caduta, aggiunta ok', 'passo=' + this.bpPassoInvio
            + ' | ' + bpInvio.recupero
            + ' | dopo ' + (Date.now() - bpInizioInvio) + ' ms'
            + ' | online=' + (navigator.onLine === false ? 'no' : 'si'),
            { recuperato: true }
          );
        }

        /* I byte sono partiti tutti: barra a fondo corsa. Sparisce solo
           alla fine, quando il drawer si e' aperto (vedi il finally). */
        if (bpHaFoto) this.bpMostraProgresso(1);

        let bpResult = null;
        try {
          bpResult = await bpResponse.json();
        } catch (bpParseError) {
          bpResult = null;
        }

        /* Rifiuto: 422 con { status, message, description } (es. un
           articolo esaurito nel frattempo), oppure una risposta strana. Con
           l'aggiunta unica non e' entrato NIENTE: nessun rollback da fare. */
        if (!bpResponse.ok || !bpResult || bpResult.status) {
          const bpMotivoShopify = (bpResult && (bpResult.description || bpResult.message)) || 'nessuna spiegazione';
          /* RIPROVA COL SOLO RITRATTO (09/10/2026), come faceva il codice di
             prima quando Saltacoda o Sfondo fallivano da soli: SOLO per un
             422 strutturato di Shopify (il caso vero di "esaurito nel
             frattempo") e SOLO se nella lista c'era un extra. Una rete
             caduta, un timeout o una pagina non JSON (bpResult null, o uno
             status diverso da 422) potrebbero nascondere un'aggiunta GIA'
             riuscita: li' non si riprova, per non rischiare un doppione. */
          const bpPuoRiprovareSoloRitratto = bpResponse.status === 422 && bpResult && bpResult.status && (bpConSaltacoda || bpConSfondo);

          if (bpPuoRiprovareSoloRitratto) {
            /* EXTRA NON ACQUISTABILE (12/10/2026, regola del Capitano): non si
               torna subito al solo ritratto. Si toglie UN extra alla volta e
               si riprova, sempre con un'aggiunta unica: prima il ritratto con
               gli extra rimasti, solo alla fine il ritratto da solo. Al massimo
               3 tentativi in tutto, contando il primo. Per primo si toglie
               l'extra che Shopify nomina nel 422 (il suo titolo nel testo);
               se non ne nomina nessuno, il primo della lista.
               Si riprova SOLO dopo un 422 strutturato: una rete caduta o una
               risposta strana possono nascondere un'aggiunta gia' riuscita, e
               li' ci si ferma (rischio doppioni, come prima).
               Le property di un extra restano sul ritratto SOLO se quell'extra
               entra nello stesso tentativo: mai la scelta scritta senza i 5 €. */
            const bpVoci = [];
            if (bpConSaltacoda) bpVoci.push({ id: Number(bpIdSaltacoda), nome: this.dataset.bpSaltacodaNome || 'Saltacoda', proprieta: [BP_PROP_SALTACODA_NOME] });
            if (bpConSfondo) bpVoci.push({ id: Number(bpIdSfondo), nome: this.dataset.bpSfondoCustomNome || 'Sfondo personalizzato', proprieta: [BP_PROP_SFONDO, BP_PROP_SFONDO_DESCR] });
            let bpRimasti = bpVoci.slice();
            const bpPersi = [];
            const bpRifiuti = ['tentativo 1: ' + bpMotivoShopify];
            let bpUltimoMotivo = bpMotivoShopify;
            let bpTentativo = 1;
            let bpResponseRiprova = null;
            let bpResultRiprova = null;
            let bpOkRiprova = false;
            let bpFermati = false;
            /* 422 SUL RITRATTO (non su un extra): Shopify nomina la variante del
               ritratto, oppure ha rifiutato il ritratto da solo. Togliere extra
               non serve: niente altre chiamate, messaggio generale (quello che
               il salvagente trasforma nell'aiuto su WhatsApp) e avviso
               "ritratto non aggiungibile". */
            const bpTitoloRitratto = String((this.bpCurrentVariant && this.bpCurrentVariant.title) || '').toLowerCase();
            const bpNominaRitratto = function (bpTesto) {
              return !!bpTitoloRitratto && String(bpTesto || '').toLowerCase().indexOf(bpTitoloRitratto) !== -1;
            };
            let bpRitrattoRifiutato = bpNominaRitratto(bpMotivoShopify);
            /* Vero se Shopify ha nominato il ritratto; falso se e' stato
               rifiutato il ritratto da solo senza che il testo dica perche'. */
            let bpRitrattoNominato = bpRitrattoRifiutato;

            while (!bpOkRiprova && !bpFermati && !bpRitrattoRifiutato && bpTentativo < 3 && bpRimasti.length > 0) {
              bpTentativo += 1;
              if (bpTentativo === 3) {
                /* Ultimo tentativo: il ritratto da solo. */
                bpRimasti.forEach(function (bpV) { bpPersi.push(bpV); });
                bpRimasti = [];
              } else {
                const bpTestoRifiuto = String(bpUltimoMotivo || '').toLowerCase();
                const bpNominato = bpRimasti.find(function (bpV) { return bpV.nome && bpTestoRifiuto.indexOf(String(bpV.nome).toLowerCase()) !== -1; });
                const bpTolto = bpNominato || bpRimasti[0];
                bpPersi.push(bpTolto);
                bpRimasti = bpRimasti.filter(function (bpV) { return bpV !== bpTolto; });
              }
              const bpProprietaTentativo = {};
              Object.keys(bpProperties).forEach(function (bpKey) { bpProprietaTentativo[bpKey] = bpProperties[bpKey]; });
              bpPersi.forEach(function (bpV) { bpV.proprieta.forEach(function (bpP) { delete bpProprietaTentativo[bpP]; }); });
              const bpItemsTentativo = bpRimasti.map(function (bpV) { return { id: bpV.id, quantity: 1 }; });
              bpItemsTentativo.push({ id: this.bpCurrentVariant.id, quantity: 1, properties: bpProprietaTentativo });
              this.bpPassoInvio = 'tentativo ' + bpTentativo + ' (ritratto' + (bpRimasti.length ? ' + ' + bpRimasti.map(function (bpV) { return bpV.nome; }).join(' + ') : ' da solo') + ')';
              console.warn('[bp-configuratore] Aggiunta rifiutata (' + bpUltimoMotivo + '), ' + this.bpPassoInvio + '.');

              bpResponseRiprova = null;
              bpResultRiprova = null;
              try {
                bpResponseRiprova = await bpPostConProgresso(
                  this.dataset.bpAddUrl || '/cart/add.js',
                  JSON.stringify({ items: bpItemsTentativo, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
                  null,
                  'application/json'
                );
                try {
                  bpResultRiprova = await bpResponseRiprova.json();
                } catch (bpParseErrorRiprova) {
                  bpResultRiprova = null;
                }
              } catch (bpErroreRiprova) {
                bpResponseRiprova = null;
              }
              bpOkRiprova = !!(bpResponseRiprova && bpResponseRiprova.ok && bpResultRiprova && !bpResultRiprova.status);
              if (!bpOkRiprova) {
                const bpAncora422 = !!(bpResponseRiprova && bpResponseRiprova.status === 422 && bpResultRiprova && bpResultRiprova.status);
                bpUltimoMotivo = (bpResultRiprova && (bpResultRiprova.description || bpResultRiprova.message)) || 'nessuna spiegazione';
                bpRifiuti.push('tentativo ' + bpTentativo + ': ' + (bpResponseRiprova ? 'status ' + bpResponseRiprova.status + ', ' : 'nessuna risposta, ') + bpUltimoMotivo);
                if (!bpAncora422) bpFermati = true;
                else if (bpNominaRitratto(bpUltimoMotivo)) { bpRitrattoRifiutato = true; bpRitrattoNominato = true; }
                else if (bpRimasti.length === 0) bpRitrattoRifiutato = true;
              }
            }

            if (!bpOkRiprova && bpRitrattoRifiutato) {
              const bpMostratoRitratto = this.dataset.bpTextAtcError || 'Impossibile aggiungere al carrello. Riprova.';
              console.warn('[bp-configuratore] Ritratto rifiutato da Shopify: ' + bpRifiuti.join(' ; '));
              this.bpAvvisaCapitano(
                bpRitrattoNominato ? 'ritratto non aggiungibile' : 'aggiunta fallita del tutto',
                (bpRitrattoNominato
                  ? 'e\' fallito il RITRATTO (' + (this.bpCurrentVariant && this.bpCurrentVariant.title) + '), non un extra'
                  : 'rifiutato anche il ritratto da solo, nel carrello non e\' entrato niente; Shopify non dice quale prodotto')
                + ' | extra scelti=' + bpVoci.map(function (bpV) { return bpV.nome; }).join(' + ')
                + ' | chiamate al carrello=' + bpTentativo
                + ' | shopify: ' + bpRifiuti.join(' ; ')
                + ' | dopo ' + (Date.now() - bpInizioInvio) + ' ms'
                + ' | mostrato=' + bpMostratoRitratto
              );
              this.bpShowError(bpMostratoRitratto);
              return;
            }

            if (bpOkRiprova) {
              /* Il ritratto e' entrato, con gli extra rimasti. Il cliente NON
                 vede nessun messaggio (13/10/2026, regola del Capitano: il
                 cliente deve poter pagare sempre, senza frizioni): il carrello
                 si apre come dopo un'aggiunta normale. Il Capitano riceve gli
                 extra persi, quelli entrati e i 422 veri di Shopify.
                 L'EXTRA PERSO SI SPEGNE IN PAGINA, cosi' Totale e rata tornano
                 uguali al carrello: l'interruttore Saltacoda si spegne
                 comunque (pagato o perso, riaccenderlo al ritorno lo
                 rivenderebbe o lo prometterebbe di nuovo); lo Sfondo
                 personalizzato si spegne solo se e' perso (lo sfondo e'
                 facoltativo, nessuno sfondo scelto e' uno stato valido). */
              const bpNomiPersi = bpPersi.map(function (bpV) { return bpV.nome; });
              if (bpConSfondo && bpPersi.some(function (bpV) { return bpV.id === Number(bpIdSfondo); })) {
                const bpSfondoCustomInput = this.querySelector('input[data-bp-sfondo-input][data-bp-sfondo-custom]');
                if (bpSfondoCustomInput) bpSfondoCustomInput.checked = false;
                this.bpSetSfondo(null);
              }
              this.bpAvvisaCapitano(
                'extra non aggiungibile, ritratto aggiunto senza',
                'persi=' + bpNomiPersi.join(' + ')
                + ' | entrati=' + (bpRimasti.length ? bpRimasti.map(function (bpV) { return bpV.nome; }).join(' + ') : 'nessuno')
                + ' | tentativi=' + bpTentativo
                + ' | shopify: ' + bpRifiuti.join(' ; ')
              );
              if (bpConSaltacoda) {
                const bpSaltacodaInput = this.querySelector('input[data-bp-saltacoda-input]');
                if (bpSaltacodaInput) bpSaltacodaInput.checked = false;
                this.bpSetSaltacoda(false);
              }
              this.bpUltimoOrdineAggiunto = true;
              this.bpMemoriaSalva();
              this.bpPassoInvio = 'apertura del carrello laterale';
              await this.bpOpenCartDrawer(bpResultRiprova);
              return;
            }

            /* Rifiutato anche l'ultimo tentativo (o rete caduta durante una
               riprova): errore normale, col motivo VERO dell'ultimo tentativo. */
            console.warn('[bp-configuratore] Riprove esaurite: ' + bpRifiuti.join(' ; '));
            const bpMessageRiprova =
              (bpResultRiprova && (bpResultRiprova.description || bpResultRiprova.message)) ||
              (bpResponseRiprova ? this.bpMotivoHttp(bpResponseRiprova.status) : (this.dataset.bpTextAtcError || 'Impossibile aggiungere al carrello. Riprova.'));
            this.bpAvvisaCapitano(
              'invio rifiutato anche senza extra', 'passo=' + this.bpPassoInvio
              + ' | persi=' + bpPersi.map(function (bpV) { return bpV.nome; }).join(' + ')
              + ' | shopify: ' + bpRifiuti.join(' ; ')
              + ' | dopo ' + (Date.now() - bpInizioInvio) + ' ms'
              + ' | mostrato=' + bpMessageRiprova
            );
            this.bpShowError(bpMessageRiprova);
            return;
          }

          /* 422 DI SHOPIFY SUL SOLO RITRATTO (14/10/2026): prima il cliente
             leggeva il testo di Shopify ("esaurito", "non disponibile") e
             nessuna via d'uscita. Ora riceve il messaggio d'errore di sempre
             del blocco, che snippets/bp-salvagente.liquid trasforma nel
             messaggio generale col pulsante WhatsApp; il testo vero di
             Shopify va al Capitano nell'avviso qui sotto. Per tutto il resto
             (413, 5xx, pagine non JSON) il motivo si ricava dallo status. */
          const bpMessage = bpResponse.status === 422
            ? (this.dataset.bpTextAtcError || 'Impossibile aggiungere al carrello. Riprova.')
            : (bpMotivoShopify !== 'nessuna spiegazione' ? bpMotivoShopify : this.bpMotivoHttp(bpResponse.status));
          console.warn('[bp-configuratore] Aggiunta rifiutata, status ' + bpResponse.status);
          const bpCorpo = String(bpResponse.testo || '').replace(/\s+/g, ' ').trim();
          this.bpAvvisaCapitano(
            'invio rifiutato', 'passo=' + this.bpPassoInvio
            + ' | status=' + bpResponse.status
            + ' | shopify=' + bpMotivoShopify
            + ' | corpo=' + (bpCorpo ? bpCorpo.slice(0, 90) : 'vuoto')
            + ' | dopo ' + (Date.now() - bpInizioInvio) + ' ms'
            + ' | mostrato=' + bpMessage
          );
          this.bpShowError(bpMessage);
          return;
        }

        /* Saltacoda pagato e scritto: l'interruttore si spegne, come prima
           a properties scritte. */
        if (bpConSaltacoda) {
          const bpSaltacodaInput = this.querySelector('input[data-bp-saltacoda-input]');
          if (bpSaltacodaInput) bpSaltacodaInput.checked = false;
          this.bpSetSaltacoda(false);
        }
        const bpDrawerData = bpResult;

        /* SUCCESSO: LE FOTO RESTANO NEL MODULO, come restano gia'
           sfondo, dettagli e varianti. Fino a ieri si svuotavano qui,
           per impedire un secondo ordine identico per sbaglio, ma il
           prezzo era troppo alto: il cliente che torna sul
           configuratore trovava il riquadro foto completamente vuoto,
           senza nemmeno i segnaposto, e doveva ricaricare tutto da
           capo. La memoria e' una fotocopia dello stato vivo, quindi
           uno stato svuotato diventava una memoria svuotata, e il
           ripristino non aveva piu' niente da rimettere.
           Il doppio ordine resta possibile e si affronta avvisando il
           cliente, non togliendogli il lavoro fatto: da qui l'avviso
           sotto il bottone (bpRefreshAtcState), acceso da questa
           bandierina e spento al primo tocco che cambia qualcosa nel
           modulo (vedi bpOnChange, bpOnClick, bpOnInput piu' sotto). */
        this.bpUltimoOrdineAggiunto = true;

        /* La memoria si riscrive QUI, e non e' un di piu': fra il click
           e questa riga il modulo ha spento il saltacoda (il prodottino
           e' gia' pagato, riaccenderlo al ritorno vorrebbe dire
           venderlo due volte). Senza questa riga la memoria resterebbe
           ferma a com'era prima del click, col saltacoda ancora acceso.
           Le foto invece ci sono ancora, coi loro gettoni: e' proprio
           cosi' che al ritorno le miniature tornano. */
        this.bpMemoriaSalva();
        this.bpPassoInvio = 'apertura del carrello laterale';
        await this.bpOpenCartDrawer(bpDrawerData);
      } catch (bpError) {
        console.warn('[bp-configuratore] Errore add-to-cart:', bpError);
        const bpMostrato = await this.bpMotivoErrore(bpError);
        this.bpShowError(bpMostrato);
        /* Il motivo REALE al Capitano: tipo e testo dell'eccezione, il
           passo in cui e' caduta, dopo quanto, e se il telefono si dice
           online. E' il ramo che, col salvagente, diventa "Qualcosa e'
           andato storto durante l'invio". */
        this.bpAvvisaCapitano(
          'invio interrotto', 'passo=' + this.bpPassoInvio
          + ' | errore=' + ((bpError && bpError.name) || 'sconosciuto') + ': ' + ((bpError && bpError.message) || String(bpError)).slice(0, 120)
          + ' | dopo ' + (Date.now() - bpInizioInvio) + ' ms'
          + ' | online=' + (navigator.onLine === false ? 'no' : 'si')
          + (bpError && bpError.bpRecupero ? ' | recupero=' + bpError.bpRecupero : '')
          + ' | mostrato=' + bpMostrato
        );
      } finally {
        /* In ogni caso il bottone non resta mai bloccato in caricamento. */
        this.bpBusy = false;
        this.bpSetLoading(false);
        /* Sequenza finita, bene o male: il carrello torna a controllare
           gli orfani (un Saltacoda rimasto senza ritratto sparisce). */
        if (bpSequenzaAperta) this.bpChiudiSequenzaCarrello();
        /* La barra sparisce QUI, e solo qui. Il finally scatta dopo che il
           drawer si e' aperto (e' l'ultima istruzione del try), quindi il
           100% resta a schermo per tutta l'attesa; e scatta anche su ogni
           ramo di errore, compreso il return anticipato dell'add fallito,
           quindi non resta mai una barra appesa sopra un messaggio rosso. */
        this.bpNascondiProgresso();
      }
    }

    /* Aggiorna e apre il drawer copiando il pattern manuale GIÀ
       COLLAUDATO in questo tema (snippets/cart-drawer-upsell.liquid,
       righe 264-286): dall'HTML nuovo della sezione cart-drawer si
       ritaglia .drawer__inner e si sostituisce l'innerHTML di quello
       in pagina, poi si aggiorna #cart-icon-bubble.

       MAI chiamare renderContents di Shrine: è offuscato, senza
       null-check (il suo getSectionInnerHTML legge .innerHTML del
       risultato di querySelector senza verificarlo), e con questo
       drawer personalizzato muore a metà lasciandolo vuoto.

       Null-check a ogni passo; ultimo paracadute: pagina carrello. */
    async bpOpenCartDrawer(bpResult) {
      try {
        let bpSections = bpResult && bpResult.sections;

        /* Se l'add non ha restituito le sezioni, si recuperano con la
           stessa chiamata usata dal codice upsell del tema. */
        if (!bpSections || !bpSections['cart-drawer']) {
          const bpSectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
          if (bpSectionsResponse.ok) {
            bpSections = await bpSectionsResponse.json();
          }
        }
        if (!bpSections) throw new Error('sezioni non disponibili');

        let bpRendered = false;

        const bpDrawerInner = document.querySelector('cart-drawer .drawer__inner');
        if (bpDrawerInner && bpSections['cart-drawer']) {
          const bpTemp = document.createElement('div');
          bpTemp.innerHTML = bpSections['cart-drawer'];
          const bpNewInner = bpTemp.querySelector('.drawer__inner');
          if (bpNewInner) {
            bpDrawerInner.innerHTML = bpNewInner.innerHTML;
            bpRendered = true;
          }
        }

        const bpBubble = document.querySelector('#cart-icon-bubble');
        if (bpBubble && bpSections['cart-icon-bubble']) {
          bpBubble.innerHTML = bpSections['cart-icon-bubble'];
        }

        if (!bpRendered) throw new Error('drawer non aggiornabile');

        const bpDrawer = document.querySelector('cart-drawer');
        if (!bpDrawer) throw new Error('cart-drawer assente in pagina');

        /* il drawer poteva essere vuoto prima di questo add */
        bpDrawer.classList.remove('is-empty');

        /* apertura: solo la parte innocua di Shrine (classi e focus);
           se anche open() fallisse, si aprono le classi a mano */
        try {
          if (typeof bpDrawer.open === 'function') {
            bpDrawer.open();
            return;
          }
        } catch (bpOpenError) {
          console.warn('[bp-configuratore] open() del drawer fallito:', bpOpenError);
        }
        bpDrawer.classList.add('animate', 'active');
      } catch (bpError) {
        console.warn('[bp-configuratore] Aggiornamento drawer fallito:', bpError);
        window.location.href = this.dataset.bpCartUrl || '/cart';
      }
    }

    /* --- foto (mattone 5) ------------------------------------------------ */

    /* Massimo foto in base al numero personaggi selezionato (progetto,
       punto 6). Cerca tra i valori scelti quello dei personaggi
       (contiene "personagg") e ne estrae il numero iniziale:
       "1 Personaggio" -> 1, "2 Personaggi" -> 2, "3 o più..." -> 3. */
    bpGetMaxFoto() {
      const bpSelected = this.bpGetSelectedOptions();
      /* NESSUNA SCELTA ANCORA: si parte dal limite piu' BASSO, non dal
         piu' alto come faceva il ripiego in fondo. Al massimo il cliente
         caricherebbe otto foto e poi, scegliendo "1 personaggio", se ne
         ritroverebbe cinque di troppo da togliere a mano: le foto in
         eccesso non si cancellano mai da sole, di proposito.
         Il ripiego in fondo al metodo resta com'era e vale un altro caso:
         scelte fatte ma nessun numero da leggerci dentro, che e' la
         situazione normale dei prodotti senza personaggi. */
      if (!bpSelected) return BP_FOTO_MINIMO;
      let bpNum = NaN;
      for (let bpIndex = 0; bpIndex < bpSelected.length; bpIndex += 1) {
        if (/personagg/i.test(bpSelected[bpIndex])) {
          bpNum = parseInt(bpSelected[bpIndex], 10);
          break;
        }
      }
      if (isNaN(bpNum) && bpSelected[0]) {
        bpNum = parseInt(bpSelected[0], 10);
      }
      if (isNaN(bpNum) || bpNum < 1) return BP_FOTO_LIMITE_3PIU;
      return BP_FOTO_LIMITI[bpNum] || BP_FOTO_LIMITE_3PIU;
    }

    bpAddFotoFiles(bpFileList) {
      if (!bpFileList || !bpFileList.length) return;
      this.bpHideFotoMsg();

      const bpMax = this.bpGetMaxFoto();
      let bpScartateTipo = 0;
      let bpScartatePeso = 0;
      let bpScartateMax = 0;

      const bpFiles = Array.prototype.slice.call(bpFileList);
      for (let bpIndex = 0; bpIndex < bpFiles.length; bpIndex += 1) {
        const bpFile = bpFiles[bpIndex];
        /* Non piu' solo file.type: vuoto su alcuni Android per HEIC e
           foto senza estensione. Vedi bpSembraImmagine. */
        if (!bpSembraImmagine(bpFile)) {
          bpScartateTipo += 1;
          continue;
        }
        if (bpFile.size > BP_FOTO_MAX_BYTES) {
          bpScartatePeso += 1;
          continue;
        }
        if (this.bpFotoFiles.length >= bpMax) {
          bpScartateMax += 1;
          continue;
        }
        /* La voce entra SUBITO, con l'originale già utilizzabile e lo
           stato "in-corso": l'anteprima si vede all'istante e il cliente
           non aspetta la conversione per capire che la foto è arrivata. */
        /* gettone ed erroreCaricamento riguardano il viaggio verso R2 e
           restano null finche' quel viaggio non comincia. Sono separati
           da "esito", che invece racconta la conversione: due storie
           diverse sulla stessa foto, e mescolarle renderebbe illeggibili
           entrambe. */
        const bpVoce = {
          originale: bpFile,
          file: bpFile,
          stato: 'in-corso',
          esito: null,
          gettone: null,
          erroreCaricamento: null,
          /* La lettura dei byte parte QUI, subito, e non quando arriva il
             turno nella coda di conversione: prima si legge, meno tempo
             ha il riferimento del telefono per smettere di funzionare.
             Non lancia mai: torna { file } oppure { errore }. */
          lettura: bpCopiaInMemoria(bpFile).then(
            function (bpCopia) { return { file: bpCopia }; },
            function (bpErrore) { return { errore: bpErrore }; }
          ),
        };
        this.bpFotoFiles.push(bpVoce);
        this.bpAccodaConversione(bpVoce);
        /* Almeno una foto entrata davvero: il ritratto non e' piu'
           quello gia' ordinato. Scartate per tipo, peso o limite non
           contano: non hanno cambiato niente. */
        this.bpSpegniAvvisoGiaAggiunto();
      }

      const bpAvvisi = [];
      if (bpScartateMax > 0) {
        bpAvvisi.push('Puoi caricare al massimo ' + bpMax + ' foto per questa scelta.');
      }
      if (bpScartateTipo > 0) {
        bpAvvisi.push('Alcuni file non sono immagini e sono stati ignorati.');
      }
      if (bpScartatePeso > 0) {
        bpAvvisi.push('Alcune foto superano i ' + Math.round(BP_FOTO_MAX_BYTES / 1048576) + ' MB e sono state ignorate.');
      }
      if (bpAvvisi.length) this.bpShowFotoMsg(bpAvvisi.join(' '), false);

      this.bpRenderFoto();
      this.bpRefreshFotoState();
    }

    /* Mette una voce in coda alla conversione. La coda è seriale: ogni
       foto aspetta la precedente. A conversione finita la voce si
       aggiorna e la griglia si ridisegna, ma SOLO se quella voce è
       ancora nell'elenco: fra l'accodamento e la fine il cliente può
       averla rimossa, o aver svuotato tutto dopo un add riuscito, e
       scrivere su una voce che non c'è più rimetterebbe a schermo una
       foto che nessuno ha più chiesto. */
    bpAccodaConversione(bpVoce) {
      const bpModulo = this;
      this.bpCodaConversione = this.bpCodaConversione.then(async function () {
        if (bpModulo.bpFotoFiles.indexOf(bpVoce) === -1) return;
        /* Prima i byte in memoria (vedi bpCopiaInMemoria). Una foto che il
           telefono non ci da' non entra nemmeno in coda: si toglie e si
           dice SUBITO al cliente cosa fare, qui al passo delle foto, invece
           di lasciargli scoprire il guasto al bottone del carrello. */
        const bpLettura = bpVoce.lettura ? await bpVoce.lettura : { file: bpVoce.originale };
        bpVoce.lettura = null;
        if (bpModulo.bpFotoFiles.indexOf(bpVoce) === -1) return;
        if (bpLettura.errore) {
          bpModulo.bpTogliFotoNonUsabile(bpVoce, bpLettura.errore);
          return;
        }
        bpVoce.originale = bpLettura.file;
        bpVoce.file = bpLettura.file;
        const bpEsito = await bpPreparaFoto(bpVoce.originale);
        if (bpModulo.bpFotoFiles.indexOf(bpVoce) === -1) return;
        /* Ancora sopra il tetto (HEIC pesante, foto enorme, conversione
           fallita): si riduce ancora, perche' allegarla al carrello non si
           fa piu'. Se non ci sta nemmeno cosi', resta com'e' e bpCaricaFoto
           la segna "non-caricabile". */
        if (bpEsito.file.size > BP_FOTO_TETTO_R2) {
          const bpRidotta = await bpRiduciSottoTetto(bpVoce.originale);
          if (bpModulo.bpFotoFiles.indexOf(bpVoce) === -1) return;
          if (bpRidotta) {
            bpEsito.file = bpRidotta;
            bpEsito.esito = 'convertita';
          }
        }
        bpVoce.file = bpEsito.file;
        bpVoce.esito = bpEsito.esito;
        /* Convertita: l'originale in memoria non serve piu' (il nome e'
           identico, e la conversione e' definitiva). Liberarlo conta su un
           telefono con otto foto da 12 MB. */
        if (bpEsito.esito === 'convertita') bpVoce.originale = bpEsito.file;
        bpVoce.stato = 'pronta';
        bpModulo.bpRenderFoto();
        /* Cattura dei byte (22/10/2026): solo le prime BP_FOTO_CATTURA_MAX
           foto ancora senza bpByte, per il tetto di memoria. Il file e' gia'
           quello definitivo, quindi i byte catturati qui sono gli stessi
           che la firma si aspetta. */
        if (bpModulo.bpFotoFiles.filter(function (bpV) { return !!bpV.bpByte; }).length < BP_FOTO_CATTURA_MAX) {
          await bpCatturaByte(bpVoce);
          if (bpModulo.bpFotoFiles.indexOf(bpVoce) === -1) return;
        }
        /* Appena il file e' quello definitivo parte il viaggio verso
           R2. Prima non si puo': si dichiarerebbe alla porta il peso
           dell'originale e si manderebbe il convertito, e la firma
           salterebbe. */
        bpModulo.bpAccodaCaricamento(bpVoce);
      }).catch(async function (bpErrore) {
        /* La coda non deve MAI restare avvelenata: se una conversione
           esplode fuori da bpPreparaFoto (che già cattura tutto), la
           voce resta con l'originale e le altre proseguono. */
        console.warn('[bp-configuratore] Conversione foto interrotta:', bpErrore);
        bpVoce.stato = 'pronta';
        bpVoce.esito = bpVoce.esito || 'ripiego';
        /* Stessa cattura del ramo buono qui sopra: anche l'originale tenuto
           per ripiego merita la rete in piu'. */
        if (bpModulo.bpFotoFiles.indexOf(bpVoce) !== -1
          && bpModulo.bpFotoFiles.filter(function (bpV) { return !!bpV.bpByte; }).length < BP_FOTO_CATTURA_MAX) {
          await bpCatturaByte(bpVoce);
          if (bpModulo.bpFotoFiles.indexOf(bpVoce) === -1) return;
        }
        /* Anche qui si carica: il file e' l'originale, ma e' valido e
           il suo peso e' quello vero. Una conversione fallita non deve
           costare anche il caricamento anticipato. */
        bpModulo.bpAccodaCaricamento(bpVoce);
      });
    }

    /* ---- La coda di caricamento verso R2 ------------------------------
       Mette una voce in fila e prova a far partire subito qualcosa. Una
       voce gia' caricata o gia' in volo non si riaccoda: il controllo
       sullo stato e' qui, cosi' chi chiama (conversione finita, oppure
       il Riprova) non deve saperlo. */
    bpAccodaCaricamento(bpVoce) {
      if (!bpVoce || bpVoce.stato === 'caricata' || bpVoce.stato === 'in-caricamento') return;
      if (this.bpCodaCaricamento.indexOf(bpVoce) !== -1) return;
      this.bpCodaCaricamento.push(bpVoce);
      this.bpAvviaCaricamenti();
    }

    /* Riempie i posti liberi. Chiamata a ogni accodamento e alla fine di
       ogni caricamento: e' l'unico punto che decide chi parte, quindi il
       tetto dei due in volo non puo' essere sforato da nessuna parte. */
    bpAvviaCaricamenti() {
      const bpModulo = this;
      while (this.bpCaricamentiAttivi < BP_CARICAMENTI_PARALLELI && this.bpCodaCaricamento.length > 0) {
        const bpVoce = this.bpCodaCaricamento.shift();
        /* Rimossa dal cliente mentre aspettava il turno: si lascia
           cadere senza toccare niente. */
        if (this.bpFotoFiles.indexOf(bpVoce) === -1) continue;
        this.bpCaricamentiAttivi += 1;
        this.bpCaricaFoto(bpVoce).catch(function (bpErrore) {
          /* bpCaricaFoto cattura gia' tutto: questo e' solo il muro
             contro un guasto suo, che non deve mai bloccare la coda. */
          console.warn('[bp-configuratore] Caricamento foto interrotto:', bpErrore);
        }).then(function () {
          bpModulo.bpCaricamentiAttivi -= 1;
          bpModulo.bpAvviaCaricamenti();
        });
      }
    }

    /* ---- Il viaggio di UNA foto verso R2 ------------------------------
       Porta la voce da "pronta" a "caricata" (col gettone) oppure a
       "fallita" (col motivo). Non lancia mai: il chiamante non ha
       niente da decidere.

       LA VOCE SI RICONTROLLA PRIMA DI OGNI SCRITTURA, come fa la coda
       di conversione: fra l'inizio e la fine il cliente puo' aver
       rimosso la foto o svuotato tutto, e scrivere su una voce che non
       c'e' piu' rimetterebbe a schermo uno stato che nessuno ha
       chiesto.

       IL 429 NON SI RITENTA: e' il razionamento della porta, cento
       richieste al giorno per indirizzo. Riprovare fra un secondo e
       mezzo darebbe lo stesso 429 e brucerebbe un altro posto. */
    async bpCaricaFoto(bpVoce) {
      const bpModulo = this;
      const bpAncoraViva = function () { return bpModulo.bpFotoFiles.indexOf(bpVoce) !== -1; };
      const bpMarca = function (bpStato, bpErrore) {
        if (!bpAncoraViva()) return;
        bpVoce.stato = bpStato;
        bpVoce.erroreCaricamento = bpErrore || null;
        bpModulo.bpRenderFoto();
      };

      if (!bpAncoraViva()) return;

      /* Sopra il tetto della porta non si chiama nemmeno: la porta
         risponderebbe 400 e avremmo speso un giro di rete per sentirci
         dire una cosa che sapevamo gia'.
         STATO A PARTE, "non-caricabile" e non "fallita": qui non c'e'
         niente da riprovare. Il file e' quello e restera' quello, il
         peso non cambia, e un Riprova sarebbe un bottone che promette
         un esito diverso sapendo gia' che sara' identico. Ci si arriva
         solo quando nemmeno bpRiduciSottoTetto e' riuscita a farla
         stare sotto il tetto: allegarla al carrello non si fa piu', quindi
         al click si ferma e il cliente e' invitato a sceglierne un'altra. */
      if (bpVoce.file.size > BP_FOTO_TETTO_R2) {
        bpMarca('non-caricabile', 'foto troppo grande per il caricamento anticipato');
        return;
      }

      bpVoce.stato = 'in-caricamento';
      bpVoce.erroreCaricamento = null;
      this.bpRenderFoto();

      /* Il tipo e il peso si leggono UNA volta sola, prima del primo
         tentativo, e non si rileggono piu': sono esattamente cio' che
         viene dichiarato alla porta e poi firmato. */
      const bpContentType = bpVoce.file.type;
      const bpContentLength = bpVoce.file.size;
      let bpUltimoErrore = 'caricamento non riuscito';
      /* Il diario dei tentativi, per l'avviso al Capitano: numero, passo in
         cui e' caduto (prepara-foto o R2), durata, motivo. */
      const bpGiri = [];
      const bpInizioFoto = Date.now();
      let bpPasso = 'prepara-foto';
      let bpInizioGiro = Date.now();

      for (let bpTentativo = 1; bpTentativo <= BP_PUT_TENTATIVI; bpTentativo += 1) {
        if (!bpAncoraViva()) return;
        if (bpTentativo > 1) {
          if (Date.now() - bpInizioFoto > BP_FOTO_BUDGET_MS) break;
          /* Da qui il cliente vede "Riprovo…" sulla foto e, sotto la
             griglia, "Connessione lenta, sto riprovando…". */
          bpModulo.bpSegnaRiprovo(bpVoce, bpTentativo);
          await bpAspetta(BP_PUT_ATTESE_MS[bpTentativo - 2]);
        }
        if (!bpAncoraViva()) { bpModulo.bpSegnaRiprovo(bpVoce, 0); return; }
        bpPasso = 'prepara-foto';
        bpInizioGiro = Date.now();

        try {
          const bpPorta = await bpChiediPorta(bpContentType, bpContentLength);

          if (bpPorta.status === 429) {
            bpModulo.bpSegnaRiprovo(bpVoce, 0);
            bpMarca('fallita', 'troppe foto caricate oggi, riprova più tardi');
            bpModulo.bpAvvisaCapitano('foto non caricata', 'limite giornaliero di prepara-foto (429) per questo indirizzo');
            return;
          }
          if (bpPorta.status < 200 || bpPorta.status >= 300) {
            bpUltimoErrore = 'la preparazione non è riuscita (' + bpPorta.status + ')';
            bpGiri.push((bpGiri.length + 1) + ' prepara-foto ' + bpFormatoDurata(Date.now() - bpInizioGiro) + ' HTTP ' + bpPorta.status);
            /* Un 4xx (tranne 408 e 425) dice che la richiesta e' sbagliata e
               che riprovarla darebbe lo stesso esito: ci si ferma. */
            if (bpPorta.status >= 400 && bpPorta.status < 500 && bpPorta.status !== 408 && bpPorta.status !== 425) break;
            continue;
          }

          const bpDati = bpPorta.dati;
          if (!bpDati || !bpDati.gettone || !bpDati.urlPut) {
            bpUltimoErrore = 'risposta della preparazione incompleta';
            bpGiri.push((bpGiri.length + 1) + ' prepara-foto ' + bpFormatoDurata(Date.now() - bpInizioGiro) + ' risposta incompleta');
            continue;
          }

          bpPasso = 'R2';
          bpInizioGiro = Date.now();
          /* I byte catturati (22/10/2026, bpVoce.bpByte), se ci sono, SEMPRE
             al posto di bpVoce.file: sono lo stesso contenuto ma non
             dipendono piu' da un riferimento che il WebView puo' perdere fra
             un tentativo e il successivo. Senza cattura (oltre il tetto di
             BP_FOTO_CATTURA_MAX, o se bpCatturaByte e' fallita) resta il
             comportamento di sempre. */
          const bpEsitoPut = await bpPutBlob(bpDati.urlPut, bpVoce.bpByte || bpVoce.file, bpContentType);
          if (!bpEsitoPut.ok) {
            bpUltimoErrore = 'il caricamento è stato rifiutato (' + bpEsitoPut.status + ')';
            bpGiri.push((bpGiri.length + 1) + ' R2 ' + bpFormatoDurata(Date.now() - bpInizioGiro) + ' HTTP ' + bpEsitoPut.status);
            continue;
          }

          if (!bpAncoraViva()) { bpModulo.bpSegnaRiprovo(bpVoce, 0); return; }
          bpVoce.gettone = bpDati.gettone;
          /* I byte catturati non servono piu' una volta su R2: tenerli
             tenerebbe occupata la memoria per tutto il resto del modulo
             (sfondo, dettagli, altre foto) per niente. */
          bpVoce.bpByte = null;
          bpModulo.bpSegnaRiprovo(bpVoce, 0);
          bpMarca('caricata', null);
          /* LA MEMORIA SI RISCRIVE QUI, e non basta quella dei gestori:
             il gettone nasce alla fine di un viaggio di rete, fuori da
             qualunque interazione del cliente. Senza questa riga una
             foto caricata mentre lui sceglieva lo sfondo resterebbe
             fuori dalla memoria fino al tocco successivo, e un ritorno
             sulla pagina in mezzo la perderebbe. */
          bpModulo.bpMemoriaSalva();
          return;
        } catch (bpErrore) {
          /* Rete caduta, timeout, JSON storto: si riprova, e se era
             l'ultimo giro il messaggio finisce sotto la foto. */
          bpUltimoErrore = (bpErrore && bpErrore.message) ? bpErrore.message : 'caricamento non riuscito';
          /* Il nome e il messaggio veri (bpDettaglio, 22/10/2026) finiscono
             SOLO nel diario per Telegram, mai sotto la foto: il cliente
             legge sempre e solo la frase amica di sopra. */
          const bpDettaglioGiro = (bpErrore && bpErrore.bpDettaglio) ? ' [' + bpErrore.bpDettaglio + ']' : '';
          bpGiri.push((bpGiri.length + 1) + ' ' + bpPasso + ' ' + bpFormatoDurata(Date.now() - bpInizioGiro) + ' ' + bpUltimoErrore + bpDettaglioGiro);
        }
      }

      bpModulo.bpSegnaRiprovo(bpVoce, 0);
      bpMarca('fallita', bpUltimoErrore);
      bpModulo.bpAvvisaCapitano('foto non caricata', 'dopo tutti i tentativi: ' + bpUltimoErrore
        + ' | tentativi=' + bpGiri.length + ' | caduto in ' + bpPasso
        + ' | giri: ' + bpGiri.join('; ')
        + ' | totale ' + bpFormatoDurata(Date.now() - bpInizioFoto)
        + ' | tipo=' + (bpContentType || '?') + ' | peso=' + bpContentLength + ' byte | online=' + (navigator.onLine === false ? 'no' : 'si'));
    }

    /* "Connessione lenta, sto riprovando…" (21/10/2026): la foto segna il
       tentativo in cui e' (bpVoce.riprovo, 0 = nessuno) e il velo sulla
       miniatura diventa "Riprovo…"; sotto la griglia compare il testo
       finche' almeno una foto sta riprovando. Il testo e' NOSTRO solo se
       porta il marcatore: un altro messaggio (foto illeggibile, limite
       foto) non lo si cancella mai e non lo si copre. */
    bpSegnaRiprovo(bpVoce, bpTentativo) {
      bpVoce.riprovo = bpTentativo > 1 ? bpTentativo : 0;
      const bpEl = this.bpFotoMsgEl;
      const bpAttive = this.bpFotoFiles.filter(function (bpV) { return bpV.riprovo > 1; }).length;
      if (bpAttive > 0) {
        if (bpEl && (bpEl.hidden || bpEl.getAttribute('data-bp-riprovo') === '1')) {
          this.bpShowFotoMsg('Connessione lenta, sto riprovando…', false);
          bpEl.setAttribute('data-bp-riprovo', '1');
          /* Grigio e non rosso: non e' un errore, stiamo ancora provando. */
          bpEl.style.color = '#6b7a8c';
        }
      } else if (bpEl && bpEl.getAttribute('data-bp-riprovo') === '1') {
        this.bpHideFotoMsg();
      }
      this.bpRenderFoto();
    }

    /* ---- Le due strade del click ---------------------------------------
       NESSUNA FOTO VIAGGIA PIU' NEL CARRELLO. Fino a ieri, se una foto non
       era arrivata su R2 (caduta, troppo pesante, attesa scaduta), il
       click ripiegava sull'allegare TUTTI i file al POST /cart/add.js. Era
       la strada del 413 con le foto pesanti, e su Android quella del
       file illeggibile. Ora le strade sono due:

       1. TUTTE caricate, ognuna col suo gettone: si mandano i gettoni;
       2. altrimenti il click si FERMA e dice il motivo vero (in
          bpMotivoBlocco), dopo aver fatto tutto il possibile:
          - le foto cadute per la rete si rimettono in coda da sole, una
            volta, prima di arrendersi (il 429 no: e' il razionamento
            della porta, riprovare lo brucerebbe e basta);
          - quelle ancora in viaggio si aspettano fino a
            BP_ATTESA_GETTONI_MS.

       La regola del tutto o niente resta vera per costruzione: o tutti
       gettoni, o nessun ordine. Una voce ripristinata col gettone ma
       senza byte non e' piu' un problema: e' "caricata" e parte col suo
       gettone come le altre.

       Torna 'gettoni' oppure 'blocco'. Non lancia mai. */
    async bpDecidiGettoni() {
      const bpModulo = this;
      this.bpMotivoBlocco = null;
      /* USCITA WHATSAPP (20/10/2026): i blocchi senza rimedio per il cliente
         ("troppo pesante", "non e' arrivata ai nostri server") portano
         l'uscita 'foto'; quelli che si risolvono da soli o con un gesto
         ("carica una foto", "aspetta qualche secondo") no. */
      this.bpUscitaBlocco = null;
      const bpBlocco = function (bpMotivo, bpTesto, bpUscita) {
        console.log('[bp-configuratore] Foto al carrello: blocco (' + bpMotivo + ').');
        bpModulo.bpMotivoBlocco = bpTesto;
        bpModulo.bpUscitaBlocco = bpUscita || null;
        return 'blocco';
      };

      /* Nessuna foto: non capita (il click e' fermato prima) ma costa nulla. */
      if (this.bpFotoFiles.length === 0) {
        return bpBlocco('nessuna foto', 'Carica almeno una foto per continuare.');
      }

      const bpTroppoPesante = function (bpVoce) { return bpVoce.stato === 'non-caricabile'; };
      const bpRazionata = function (bpVoce) {
        return bpVoce.stato === 'fallita' && /troppe foto/.test(bpVoce.erroreCaricamento || '');
      };
      const bpInTransito = function (bpVoce) {
        return bpVoce.stato === 'in-corso' || bpVoce.stato === 'pronta' || bpVoce.stato === 'in-caricamento';
      };
      const bpTestoPesante = 'Una foto è troppo pesante anche dopo averla ridotta: toglila e scegline un’altra, oppure carica uno screenshot della foto.';
      const bpTestoRazionata = 'Oggi da questa connessione sono state caricate troppe foto: riprova più tardi, oppure scrivici.';

      if (this.bpFotoFiles.some(bpTroppoPesante)) return bpBlocco('foto sopra il tetto', bpTestoPesante, 'foto');
      if (this.bpFotoFiles.some(bpRazionata)) return bpBlocco('razionamento della porta', bpTestoRazionata);

      /* Le cadute per la rete ripartono da sole, UNA volta per click. */
      this.bpFotoFiles.forEach(function (bpVoce, bpIndice) {
        if (bpVoce.stato === 'fallita') bpModulo.bpRiprovaCaricamento(bpIndice);
      });

      /* L'attesa. Il bottone e' gia' in "Aggiunta in corso" da prima di
         questa chiamata: il cliente vede che stiamo lavorando. Si cede il
         controllo al browser a ogni giro, cosi' i caricamenti in volo
         proseguono e l'interfaccia resta viva. */
      const bpScade = Date.now() + BP_ATTESA_GETTONI_MS;
      while (this.bpFotoFiles.some(bpInTransito)) {
        if (Date.now() >= bpScade) {
          return bpBlocco(
            'attesa dei gettoni scaduta dopo ' + BP_ATTESA_GETTONI_MS + ' ms',
            'Le foto stanno ancora caricando: la connessione è lenta. Aspetta qualche secondo e premi di nuovo.'
          );
        }
        await bpAspetta(BP_ATTESA_PASSO_MS);
      }

      if (this.bpFotoFiles.some(bpTroppoPesante)) return bpBlocco('foto sopra il tetto', bpTestoPesante, 'foto');
      if (this.bpFotoFiles.some(bpRazionata)) return bpBlocco('razionamento della porta', bpTestoRazionata);
      if (this.bpFotoFiles.some(function (bpVoce) { return bpVoce.stato === 'fallita'; })) {
        return bpBlocco(
          'una foto non e arrivata su R2 nemmeno riprovando',
          'Una foto non è arrivata ai nostri server: controlla la connessione e tocca “Riprova” sulla foto.',
          'foto'
        );
      }

      /* Ultimo controllo, il piu' severo: ogni voce caricata E con un
         gettone vero. Una property vuota non e' ne' un URL ne' un
         gettone, e la barriera del server la fermerebbe. */
      const bpTutteConGettone = this.bpFotoFiles.every(function (bpVoce) {
        return bpVoce.stato === 'caricata'
          && typeof bpVoce.gettone === 'string'
          && bpVoce.gettone !== '';
      });
      if (!bpTutteConGettone) {
        return bpBlocco(
          'gettone mancante o vuoto su almeno una foto',
          'Una foto non è arrivata ai nostri server: toglila e caricala di nuovo.',
          'foto'
        );
      }

      console.log('[bp-configuratore] Foto al carrello: gettoni (' + this.bpFotoFiles.length + ').');
      return 'gettoni';
    }

    /* Il click si ferma: il motivo va nell'errore del bottone, dove il
       cliente guarda quando il bottone non ha funzionato. */
    bpBloccaFoto(bpTesto) {
      this.bpShowError(bpTesto || 'Una foto non è pronta: controlla le foto e riprova.', this.bpUscitaBlocco);
    }

    /* Rimette in coda una foto caduta. Azzera il motivo e riporta lo
       stato a "pronta": il file non si tocca, è già quello definitivo
       dopo la conversione, e ritoccarlo cambierebbe il peso che verrà
       dichiarato alla porta. */
    bpRiprovaCaricamento(bpIndex) {
      if (isNaN(bpIndex) || bpIndex < 0 || bpIndex >= this.bpFotoFiles.length) return;
      const bpVoce = this.bpFotoFiles[bpIndex];
      if (!bpVoce || bpVoce.stato !== 'fallita') return;
      bpVoce.stato = 'pronta';
      bpVoce.erroreCaricamento = null;
      this.bpRenderFoto();
      this.bpAccodaCaricamento(bpVoce);
    }

    /* Una foto che non si puo' usare: il telefono non ci ha dato i byte,
       oppure i byte non sono un'immagine. Si toglie dalla griglia (non
       c'e' niente che un Riprova possa cambiare) e il motivo va sotto il
       campo foto, dove il cliente sta guardando. */
    bpTogliFotoNonUsabile(bpVoce, bpErrore) {
      const bpPos = this.bpFotoFiles.indexOf(bpVoce);
      if (bpPos === -1) return;
      console.warn('[bp-configuratore] Foto tolta, non usabile:', bpVoce.originale && bpVoce.originale.name, bpErrore);
      /* Il nome del file no (e' del cliente): solo tipo, peso e motivo. */
      const bpOrig = bpVoce.originale || {};
      this.bpAvvisaCapitano('foto rifiutata', 'motivo=' + ((bpErrore && bpErrore.message) || String(bpErrore)).slice(0, 120)
        + ' | tipo=' + (bpOrig.type || 'vuoto') + ' | peso=' + (bpOrig.size || 0) + ' byte');
      this.bpFotoFiles.splice(bpPos, 1);
      this.bpRenderFoto();
      this.bpRefreshFotoState();
      /* IL RIPIEGO DEL PHOTO PICKER (vedi BP_ACCEPT_ANDROID): su Android,
         alla prima foto illeggibile il prossimo tocco su "Carica le foto"
         apre il selettore normale, che il file vero lo consegna. Resta
         cosi' fino alla fine della visita: il picker ha gia' dimostrato
         di non funzionare su questo telefono. Vale anche per i browser
         dentro le app (Instagram, Facebook), che dichiarano "Android". */
      const bpAndroid = /Android/i.test(navigator.userAgent || '');
      const bpIlleggibile = !(bpErrore && bpErrore.bpCausa === 'non-immagine');
      if (bpIlleggibile && bpAndroid && this.bpFotoInputEl) {
        this.bpFotoInputEl.setAttribute('accept', BP_ACCEPT_ANDROID);
      }
      let bpTesto = 'Alcuni file non sono immagini e sono stati ignorati.';
      if (bpIlleggibile && bpAndroid) {
        bpTesto = 'Non riusciamo a leggere questa foto dal telefono. Tocca di nuovo “Carica le foto” e sceglila ancora: si aprirà un selettore diverso. Se non funziona, fai uno screenshot della foto e carica quello.';
      } else if (bpIlleggibile) {
        bpTesto = 'Non riusciamo a leggere questa foto dal telefono. Sceglila di nuovo, oppure fai uno screenshot della foto e carica quello.';
      }
      /* USCITA WHATSAPP (20/10/2026): il messaggio della foto non e' in
         [data-bp-error], l'unico posto che il salvagente guardava, quindi
         restava senza pulsante. Il segnale e' un attributo, non il testo:
         snippets/bp-salvagente.liquid lo legge e aggiunge il pulsante. Solo
         per la foto illeggibile (non per "non sono immagini"). */
      this.bpShowFotoMsg(bpTesto, false, bpIlleggibile ? 'foto' : null);
      /* Fuori da ogni gestore di evento: la memoria si riscrive a mano,
         come fa bpCaricaFoto quando arriva un gettone. */
      this.bpMemoriaSalva();
    }

    /* ---- Anteprima delle HEIC: la coda (vedi BP_HEIC_WORKER) ---------
       Entra in coda una HEIC gia' su R2 che il browser non sa mostrare.
       Torna true se la miniatura e' partita (o era gia' in corso), false
       se questo dispositivo non ci prova: poca memoria dichiarata,
       browser senza worker o senza OffscreenCanvas, libreria non
       indicata dal Liquid. Nel secondo caso la voce resta col riquadro.
       deviceMemory lo danno solo i browser Chromium: dove manca non si
       esclude nessuno. */
    bpAccodaAnteprimaHeic(bpVoce) {
      if (bpVoce.anteprimaStato) return bpVoce.anteprimaStato === 'in-corso';
      const bpMemoria = navigator.deviceMemory;
      const bpLibUrl = bpUrlAssolutoLibreria(this.getAttribute('data-bp-heic-lib'));
      if (!bpLibUrl) {
        console.info('[bp-configuratore] Anteprima HEIC non disponibile, resta il riquadro: indirizzo della libreria non valido.');
      }
      const bpAdatto = !!bpLibUrl
        && typeof Worker === 'function'
        && typeof OffscreenCanvas === 'function'
        && typeof createImageBitmap === 'function'
        && !(typeof bpMemoria === 'number' && bpMemoria < BP_HEIC_MEMORIA_MIN_GB);
      if (!bpAdatto) {
        bpVoce.anteprimaStato = 'fallita';
        return false;
      }
      bpVoce.anteprimaStato = 'in-corso';
      this.bpCodaAnteprime.push(bpVoce);
      this.bpProssimaAnteprimaHeic();
      return true;
    }

    /* UNA ALLA VOLTA. La prossima parte solo quando la precedente ha
       finito, in qualunque modo. A coda vuota il worker si chiude: la
       memoria del WebAssembly non si restituisce da sola, e un worker
       fermo la terrebbe occupata finche' resta aperta la pagina. */
    async bpProssimaAnteprimaHeic() {
      if (this.bpAnteprimaOccupata) return;
      const bpVoce = this.bpCodaAnteprime.shift();
      if (!bpVoce) {
        this.bpChiudiWorkerHeic();
        return;
      }
      /* Tolta con la X mentre aspettava: si salta. */
      if (this.bpFotoFiles.indexOf(bpVoce) === -1) {
        bpVoce.anteprimaStato = null;
        this.bpProssimaAnteprimaHeic();
        return;
      }
      this.bpAnteprimaOccupata = true;
      const bpInizio = Date.now();
      let bpEsito = null;
      try {
        /* Una copia dei byte, TRASFERITA al worker: il file della voce,
           quello che va all'ordine, resta com'e'. */
        const bpByte = await bpVoce.file.arrayBuffer();
        if (!this.bpHeicWorker) {
          this.bpHeicWorkerUrl = URL.createObjectURL(new Blob([BP_HEIC_WORKER], { type: 'text/javascript' }));
          this.bpHeicWorker = new Worker(this.bpHeicWorkerUrl);
        }
        const bpWorker = this.bpHeicWorker;
        const bpLibUrl = bpUrlAssolutoLibreria(this.getAttribute('data-bp-heic-lib'));
        bpEsito = await new Promise(function (bpRisolvi) {
          const bpTimer = setTimeout(function () {
            bpRisolvi({ ok: false, errore: 'tempo scaduto (' + BP_HEIC_TIMEOUT_MS / 1000 + ' s)' });
          }, BP_HEIC_TIMEOUT_MS);
          bpWorker.onmessage = function (bpEv) {
            clearTimeout(bpTimer);
            bpRisolvi(bpEv.data || { ok: false, errore: 'risposta vuota' });
          };
          bpWorker.onerror = function (bpEv) {
            clearTimeout(bpTimer);
            if (bpEv && bpEv.preventDefault) bpEv.preventDefault();
            bpRisolvi({ ok: false, errore: 'errore del worker' + (bpEv && bpEv.message ? ': ' + bpEv.message : '') });
          };
          bpWorker.postMessage({ libUrl: bpLibUrl, byte: bpByte, lato: BP_HEIC_LATO_ANTEPRIMA }, [bpByte]);
        });
      } catch (bpErrore) {
        bpEsito = { ok: false, errore: (bpErrore && bpErrore.message) || String(bpErrore) };
      }
      /* Scaduto o andato storto: il worker si butta (un worker scaduto
         potrebbe stare ancora decodificando), la prossima ne fa uno nuovo. */
      if (!bpEsito || !bpEsito.ok) this.bpChiudiWorkerHeic();
      bpVoce.anteprimaMs = Date.now() - bpInizio;
      if (bpEsito && bpEsito.ok && bpEsito.blob) {
        bpVoce.anteprimaUrl = URL.createObjectURL(bpEsito.blob);
        bpVoce.anteprimaStato = 'pronta';
      } else {
        bpVoce.anteprimaStato = 'fallita';
        /* info e non warn: e' un caso previsto (file rotto, telefono
           lento), il cliente vede comunque il riquadro "Foto caricata". */
        console.info('[bp-configuratore] Anteprima HEIC non disponibile, resta il riquadro:', bpEsito && bpEsito.errore);
      }
      this.bpAnteprimaOccupata = false;
      if (this.bpFotoFiles.indexOf(bpVoce) === -1) {
        /* Tolta con la X durante la conversione: la miniatura non serve. */
        if (bpVoce.anteprimaUrl) URL.revokeObjectURL(bpVoce.anteprimaUrl);
        bpVoce.anteprimaUrl = null;
      } else {
        this.bpRenderFoto();
      }
      this.bpProssimaAnteprimaHeic();
    }

    bpChiudiWorkerHeic() {
      if (this.bpHeicWorker) {
        try { this.bpHeicWorker.terminate(); } catch (bpErrore) { /* niente da fare */ }
        this.bpHeicWorker = null;
      }
      if (this.bpHeicWorkerUrl) {
        URL.revokeObjectURL(this.bpHeicWorkerUrl);
        this.bpHeicWorkerUrl = null;
      }
    }

    /* Togliere una foto NON avvisa R2, nemmeno se era già caricata. Il
       gettone resta orfano nel secchio e lo porta via la scopa notturna
       lato server: una chiamata di cancellazione da qui costerebbe una
       porta pubblica in più, aperta a chiunque, per risparmiare un file
       che si cancella da solo dopo sessanta giorni. */
    bpRemoveFoto(bpIndex) {
      if (isNaN(bpIndex) || bpIndex < 0 || bpIndex >= this.bpFotoFiles.length) return;
      this.bpHideFotoMsg();
      /* La miniatura della HEIC, se c'era, si libera con la foto. */
      const bpTolta = this.bpFotoFiles[bpIndex];
      if (bpTolta && bpTolta.anteprimaUrl) {
        URL.revokeObjectURL(bpTolta.anteprimaUrl);
        bpTolta.anteprimaUrl = null;
      }
      this.bpFotoFiles.splice(bpIndex, 1);
      this.bpSpegniAvvisoGiaAggiunto();
      this.bpRenderFoto();
      this.bpRefreshFotoState();
    }

    /* NESSUN CHIAMANTE, di proposito. Fino a ieri partiva dopo ogni
       add-to-cart riuscito, per impedire un secondo ordine identico per
       sbaglio: svuotava anche la memoria (che e' una fotocopia dello
       stato vivo), e il cliente che tornava sul configuratore trovava
       il riquadro foto vuoto, senza nemmeno i segnaposto. Il doppio
       ordine si affronta adesso avvisando ("Questo ritratto è già nel
       carrello", bpRefreshAtcState), non cancellando il lavoro fatto.
       Resta qui perche' e' un metodo onesto (svuota le foto e basta,
       la griglia e lo stato restano coerenti) e un domani potrebbe
       servire a un bottone "svuota" vero, che oggi non esiste. */
    bpClearFoto() {
      this.bpFotoFiles = [];
      this.bpHideFotoMsg();
      this.bpRenderFoto();
      this.bpRefreshFotoState();
    }

    /* Ricostruisce la griglia anteprime dallo stato. Gli objectURL
       vecchi vengono sempre revocati per non tenere memoria occupata. */
    bpRenderFoto() {
      if (!this.bpFotoGridEl) return;
      const bpModulo = this;
      this.bpFotoUrls.forEach(function (bpUrl) { URL.revokeObjectURL(bpUrl); });
      this.bpFotoUrls = [];
      this.bpFotoGridEl.textContent = '';

      this.bpFotoFiles.forEach(function (bpVoce, bpIndex) {
        /* L'anteprima viene dal file CORRENTE della voce: durante la
           conversione è l'originale, dopo è quello convertito, e in
           quest'ultimo caso mostra esattamente ciò che verrà caricato
           (orientamento compreso).
           UNA VOCE RIPRISTINATA NON HA ANCORA I BYTE: niente objectURL e
           niente tag immagine, perché un src vuoto mostrerebbe l'icona
           di immagine rotta del browser, che sembra un guasto. Al suo
           posto resta il solo velo, che esiste già ed è esattamente il
           messaggio giusto ("questa foto non è ancora a posto"). */
        const bpNome = bpVoce.originale ? bpVoce.originale.name : (bpVoce.nome || 'foto');
        const bpUrl = bpVoce.file ? URL.createObjectURL(bpVoce.file) : null;
        if (bpUrl) this.bpFotoUrls.push(bpUrl);

        const bpThumb = document.createElement('div');
        bpThumb.className = 'bp-configuratore__foto-thumb';
        /* Lo stesso velo scuro serve a tre momenti: la conversione, il
           caricamento e il fallimento. Sono tutti e tre "questa foto non
           è ancora a posto", e riusare la classe esistente evita di
           inventare stili che i due liquid non hanno. */
        const bpVelato = !bpUrl
          || bpVoce.stato === 'in-corso'
          || bpVoce.stato === 'in-caricamento'
          || bpVoce.stato === 'fallita'
          || bpVoce.stato === 'non-caricabile';
        if (bpVelato) {
          bpThumb.classList.add('bp-configuratore__foto-thumb--preparo');
        }

        /* Il riquadro pulito che sta al posto dell'immagine quando il
           browser non la sa mostrare: icona, una riga di testo, il nome. */
        const bpRiquadro = function (bpTestoRiquadro) {
          const bpRipiego = document.createElement('span');
          bpRipiego.className = 'bp-configuratore__foto-ripiego';
          const bpIcona = document.createElement('span');
          bpIcona.className = 'bp-configuratore__foto-ripiego-icona';
          bpIcona.setAttribute('aria-hidden', 'true');
          bpIcona.textContent = '📷';
          const bpTesto = document.createElement('span');
          bpTesto.className = 'bp-configuratore__foto-ripiego-testo';
          bpTesto.textContent = bpTestoRiquadro;
          const bpNomeEl = document.createElement('span');
          bpNomeEl.className = 'bp-configuratore__foto-ripiego-nome';
          bpNomeEl.textContent = bpNome;
          bpRipiego.appendChild(bpIcona);
          bpRipiego.appendChild(bpTesto);
          bpRipiego.appendChild(bpNomeEl);
          return bpRipiego;
        };
        const bpTestoFinale = bpVoce.stato === 'caricata' ? 'Foto caricata ✓' : 'Foto';

        if (bpVoce.anteprimaStato === 'in-corso') {
          /* HEIC in conversione nel worker: il cliente sa che sta
             succedendo qualcosa, e la X resta li' sopra, attiva. */
          bpThumb.appendChild(bpRiquadro('Caricamento anteprima…'));
        } else if (bpVoce.anteprimaStato === 'fallita') {
          bpThumb.appendChild(bpRiquadro(bpTestoFinale));
        } else if (bpUrl) {
          /* L'ANTEPRIMA SI MOSTRA SOLO SE IL BROWSER LA SA DECODIFICARE.
             Una HEIC su Chrome e su Android (e qualunque file che il
             browser non sa leggere) dava l'icona dell'immagine rotta con
             accanto il nome del file, che sembra un guasto: la foto invece
             e' caricata e arriva intera all'ordine. Quindi l'immagine nasce
             invisibile e compare al "load". All'"error": se e' una HEIC
             gia' arrivata su R2 parte la miniatura vera nel worker
             (bpAccodaAnteprimaHeic), altrimenti resta il riquadro pulito.
             Il file che va all'ordine non si tocca: qui cambia solo cosa
             si vede. */
          const bpImg = document.createElement('img');
          bpImg.alt = bpNome;
          bpImg.style.visibility = 'hidden';
          bpImg.addEventListener('load', function () {
            bpImg.style.visibility = '';
          });
          bpImg.addEventListener('error', function () {
            if (!bpImg.parentNode) return;
            if (!bpVoce.anteprimaUrl
                && bpVoce.stato === 'caricata'
                && bpEHeic(bpVoce.file)
                && bpModulo.bpAccodaAnteprimaHeic(bpVoce)) {
              bpImg.parentNode.replaceChild(bpRiquadro('Caricamento anteprima…'), bpImg);
              return;
            }
            bpImg.parentNode.replaceChild(bpRiquadro(bpTestoFinale), bpImg);
          });
          /* La miniatura della HEIC, quando c'e', al posto del file. */
          bpImg.src = bpVoce.anteprimaUrl || bpUrl;
          bpThumb.appendChild(bpImg);
        }

        /* Velo di stato: mentre la conversione è in corso, mentre la
           foto sale, e quando è caduta. L'anteprima resta visibile
           sotto in tutti e tre i casi. */
        if (bpVelato) {
          const bpVelo = document.createElement('span');
          bpVelo.className = 'bp-configuratore__foto-preparo';
          if (!bpUrl) {
            /* Voce ripristinata. Due testi, perché sono due situazioni
               diverse per chi guarda: i byte stanno tornando, oppure non
               sono tornati e non torneranno in questa visita. In
               entrambi i casi la foto per l'ordine c'è già, ed è questo
               che il testo deve dire: nessun allarme, nessun invito a
               fare qualcosa che non serve. */
            bpVelo.textContent = bpVoce.recuperoFallito ? 'Foto già caricata' : 'Recupero la foto…';
          } else if (bpVoce.stato === 'in-corso') {
            bpVelo.textContent = 'Preparo la foto…';
          } else if (bpVoce.stato === 'in-caricamento') {
            bpVelo.textContent = bpVoce.riprovo > 1 ? 'Riprovo…' : 'Carico la foto…';
          } else if (bpVoce.stato === 'non-caricabile') {
            /* Nessun invito a riprovare: il file non cambia e l'esito
               sarebbe lo stesso. Non viaggia piu' allegata al click
               (vedi bpDecidiGettoni): va tolta e sostituita. */
            bpVelo.textContent = 'Troppo pesante, scegline un’altra';
          } else {
            /* Il testo del Riprova sta nel velo, ma il velo ha
               pointer-events: none: a ricevere il clic è il riquadro,
               che qui sotto diventa cliccabile. */
            bpVelo.textContent = 'Riprova';
          }
          bpThumb.appendChild(bpVelo);
        }

        /* IL RIPROVA E' IL RIQUADRO STESSO, e va spiegato perche' non e'
           un bottone come il rimuovi. Il velo che porta la scritta ha
           pointer-events: none, quindi un bottone dentro non riceverebbe
           il clic; l'unica altra classe di bottone della zona foto e'
           foto-remove, ancorata in alto a destra, e riusarla qui
           metterebbe due bottoni tondi uno sopra l'altro. Servirebbe una
           classe nuova nei due liquid, che questo mattone non tocca.
           Quindi: nessun markup inventato, nessun CSS inventato, e il
           riquadro fallito diventa lui stesso il bersaglio del clic, con
           role e aria per chi naviga da tastiera. */
        /* "non-caricabile" resta muto e NON cliccabile: niente
           data-bp-foto-riprova, niente role, niente cursore. Solo un
           title che spiega, per chi ci passa sopra. */
        if (bpVoce.stato === 'non-caricabile') {
          bpThumb.setAttribute(
            'title',
            'Questa foto è troppo pesante anche dopo averla ridotta: toglila e scegline un’altra, oppure carica uno screenshot.'
          );
        }

        /* Voce ripristinata: il title spiega perché non si vede
           l'anteprima e rassicura sul fatto che la foto c'è. Nessun
           role, nessun cursore: qui non c'è niente da cliccare, e il
           Riprova sarebbe un bottone che promette una cosa che il
           cliente non deve fare. */
        if (!bpUrl) {
          bpThumb.setAttribute(
            'title',
            bpVoce.recuperoFallito
              ? 'Questa foto è già stata caricata e partirà con l’ordine: non riusciamo solo a mostrarne l’anteprima adesso.'
              : 'Sto recuperando l’anteprima di questa foto, che è già stata caricata.'
          );
        }

        if (bpVoce.stato === 'fallita') {
          bpThumb.setAttribute('data-bp-foto-riprova', String(bpIndex));
          bpThumb.setAttribute('role', 'button');
          bpThumb.setAttribute('tabindex', '0');
          bpThumb.style.cursor = 'pointer';
          const bpMotivo = bpVoce.erroreCaricamento ? (': ' + bpVoce.erroreCaricamento) : '';
          bpThumb.setAttribute('title', 'Caricamento non riuscito' + bpMotivo + '. Tocca per riprovare.');
          bpThumb.setAttribute('aria-label', 'Riprova il caricamento di ' + bpNome);
        }

        const bpRemove = document.createElement('button');
        bpRemove.type = 'button';
        bpRemove.className = 'bp-configuratore__foto-remove';
        bpRemove.setAttribute('data-bp-foto-remove', String(bpIndex));
        bpRemove.setAttribute('aria-label', 'Rimuovi ' + bpNome);
        bpRemove.textContent = '×';
        bpThumb.appendChild(bpRemove);

        this.bpFotoGridEl.appendChild(bpThumb);
      }, this);
    }

    /* Aggiorna contatore, stato del picker e messaggi legati al massimo.
       Le foto oltre il limite NON vengono mai cancellate da sole: se il
       cliente scende di personaggi con troppe foto caricate, vede
       l'avviso e il bottone resta bloccato finché non ne rimuove. */
    bpRefreshFotoState() {
      const bpMax = this.bpGetMaxFoto();
      const bpCount = this.bpFotoFiles.length;

      /* Appena c'e' almeno una foto, il rosso non serve piu'. */
      if (bpCount >= 1 && this.bpFotoAddEl) {
        this.bpFotoAddEl.classList.remove('bp-campo-mancante');
        this.bpNascondiErroreCampo(this.bpErroreFotoEl);
      }

      if (this.bpFotoCounterEl) {
        this.bpFotoCounterEl.textContent = '(' + bpCount + '/' + bpMax + ')';
      }
      const bpPieno = bpCount >= bpMax;
      if (this.bpFotoAddEl) this.bpFotoAddEl.classList.toggle('bp-is-full', bpPieno);
      if (this.bpFotoInputEl) this.bpFotoInputEl.disabled = bpPieno;

      if (bpCount > bpMax) {
        this.bpShowFotoMsg(
          'Hai ' + bpCount + ' foto ma il massimo per questa scelta è ' + bpMax +
          ': rimuovi quelle in eccesso.',
          true
        );
      } else if (this.bpFotoMsgIsOverflow) {
        this.bpHideFotoMsg();
      }

      this.bpRefreshAtcState();
    }

    bpShowFotoMsg(bpText, bpIsOverflow, bpUscita) {
      if (!this.bpFotoMsgEl) return;
      /* L'attributo prima del testo: il salvagente scatta alla scrittura
         del testo e deve trovarlo gia' al suo posto. */
      if (bpUscita) this.bpFotoMsgEl.setAttribute('data-bp-uscita', bpUscita);
      else this.bpFotoMsgEl.removeAttribute('data-bp-uscita');
      /* Il marcatore del testo "sto riprovando" cade con ogni altro testo. */
      this.bpFotoMsgEl.removeAttribute('data-bp-riprovo');
      this.bpFotoMsgEl.style.removeProperty('color');
      this.bpFotoMsgEl.textContent = bpText;
      this.bpFotoMsgEl.hidden = false;
      this.bpFotoMsgIsOverflow = bpIsOverflow === true;
    }

    bpHideFotoMsg() {
      if (!this.bpFotoMsgEl) return;
      this.bpFotoMsgEl.removeAttribute('data-bp-uscita');
      this.bpFotoMsgEl.removeAttribute('data-bp-riprovo');
      this.bpFotoMsgEl.style.removeProperty('color');
      this.bpFotoMsgEl.hidden = true;
      this.bpFotoMsgEl.textContent = '';
      this.bpFotoMsgIsOverflow = false;
    }

    /* --- aggancio per i mattoni futuri ----------------------------------
       (upload foto, dettagli, sfondo, saltacoda, add-to-cart)
       ascolteranno questo evento per sapere quale variante è selezionata. */

    bpEmitVariantChange(bpVariant) {
      this.dispatchEvent(
        new CustomEvent('bp:variant-change', {
          bubbles: true,
          detail: { variant: bpVariant },
        })
      );
    }
  }

  window.customElements.define('bp-configuratore', BPConfiguratore);
})();